/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TeachPhoebeFeedbackTagsMockupRouteImport } from './routes/teach-phoebe-feedback-tags-mockup'
import { Route as PhoebeThinkingTipsMockupRouteImport } from './routes/phoebe-thinking-tips-mockup'
import { Route as AuthRouteRouteImport } from './routes/_auth/route'
import { Route as AppRouteRouteImport } from './routes/_app/route'
import { Route as SimulatorWorldDisplayRouteImport } from './routes/simulator-world/display'
import { Route as RCodeRouteImport } from './routes/r.$code'
import { Route as OutreachesPhoebeThinkingTipsMockupRouteImport } from './routes/outreaches/phoebe-thinking-tips-mockup'
import { Route as ChromeExtensionPrivacyRouteImport } from './routes/chrome-extension.privacy'
import { Route as AuthSignUpRouteImport } from './routes/_auth/sign-up'
import { Route as AuthSignOutRouteImport } from './routes/_auth/sign-out'
import { Route as AuthSignInRouteImport } from './routes/_auth/sign-in'
import { Route as AuthResetPasswordRouteImport } from './routes/_auth/reset-password'
import { Route as AuthIntroCallBookedRouteImport } from './routes/_auth/intro-call-booked'
import { Route as AuthErrorRouteImport } from './routes/_auth/error'
import { Route as AuthChangePasswordRouteImport } from './routes/_auth/change-password'
import { Route as AuthAcceptInvitationRouteImport } from './routes/_auth/accept-invitation'
import { Route as OrganizationIdDemoRouteImport } from './routes/$organization-id.demo'
import { Route as AppSettingsRouteRouteImport } from './routes/_app/settings/route'
import { Route as AppAdminRouteRouteImport } from './routes/_app/admin/route'
import { Route as AppmainRouteRouteImport } from './routes/_app/(main)/route'
import { Route as AppextensionRouteRouteImport } from './routes/_app/(extension)/route'
import { Route as AppagentRouteRouteImport } from './routes/_app/(agent)/route'
import { Route as AppSettingsIndexRouteImport } from './routes/_app/settings/index'
import { Route as AppAdminIndexRouteImport } from './routes/_app/admin/index'
import { Route as AppmainIndexRouteImport } from './routes/_app/(main)/index'
import { Route as AppSlackLinkRouteImport } from './routes/_app/slack/link'
import { Route as AppSettingsTestModeRouteImport } from './routes/_app/settings/test-mode'
import { Route as AppSettingsTeamMembersRouteImport } from './routes/_app/settings/team-members'
import { Route as AppSettingsTeamCoverageRouteImport } from './routes/_app/settings/team-coverage'
import { Route as AppSettingsTagMatchingRouteImport } from './routes/_app/settings/tag-matching'
import { Route as AppSettingsSlackRouteImport } from './routes/_app/settings/slack'
import { Route as AppSettingsSkipAllowListsRouteImport } from './routes/_app/settings/skip-allow-lists'
import { Route as AppSettingsShiftConfirmationsRouteImport } from './routes/_app/settings/shift-confirmations'
import { Route as AppSettingsShiftConfirmationSkipAllowListsRouteImport } from './routes/_app/settings/shift-confirmation-skip-allow-lists'
import { Route as AppSettingsRecommendationsRouteImport } from './routes/_app/settings/recommendations'
import { Route as AppSettingsQuietHoursRouteImport } from './routes/_app/settings/quiet-hours'
import { Route as AppSettingsPhoneTryRouteImport } from './routes/_app/settings/phone-try'
import { Route as AppSettingsPhoneNumbersRouteImport } from './routes/_app/settings/phone-numbers'
import { Route as AppSettingsPhoneInstructionsRouteImport } from './routes/_app/settings/phone-instructions'
import { Route as AppSettingsPhoneRouteImport } from './routes/_app/settings/phone'
import { Route as AppSettingsPhoebeRouteImport } from './routes/_app/settings/phoebe'
import { Route as AppSettingsOutreachTemplatesRouteImport } from './routes/_app/settings/outreach-templates'
import { Route as AppSettingsOutreachAutomationRouteImport } from './routes/_app/settings/outreach-automation'
import { Route as AppSettingsOtherTemplatesRouteImport } from './routes/_app/settings/other-templates'
import { Route as AppSettingsOpenShiftResponsesRouteImport } from './routes/_app/settings/open-shift-responses'
import { Route as AppSettingsOfficesRouteImport } from './routes/_app/settings/offices'
import { Route as AppSettingsOffHoursRouteImport } from './routes/_app/settings/off-hours'
import { Route as AppSettingsHelpCenterRouteImport } from './routes/_app/settings/help-center'
import { Route as AppSettingsEarlyAccessRouteImport } from './routes/_app/settings/early-access'
import { Route as AppSettingsDataSyncRouteImport } from './routes/_app/settings/data-sync'
import { Route as AppSettingsDailyDigestRouteImport } from './routes/_app/settings/daily-digest'
import { Route as AppSettingsConfirmationMessagesRouteImport } from './routes/_app/settings/confirmation-messages'
import { Route as AppSettingsConfigurationsRouteImport } from './routes/_app/settings/configurations'
import { Route as AppSettingsClockInTemplatesRouteImport } from './routes/_app/settings/clock-in-templates'
import { Route as AppSettingsClockInOutRouteImport } from './routes/_app/settings/clock-in-out'
import { Route as AppSettingsChromeExtensionRouteImport } from './routes/_app/settings/chrome-extension'
import { Route as AppSettingsChangeHistoryRouteImport } from './routes/_app/settings/change-history'
import { Route as AppSettingsCaregiverTagsRouteImport } from './routes/_app/settings/caregiver-tags'
import { Route as AppSettingsCaregiverEngagementRouteImport } from './routes/_app/settings/caregiver-engagement'
import { Route as AppSettingsCareCoordinatorsRouteImport } from './routes/_app/settings/care-coordinators'
import { Route as AppSettingsCancellationsRouteImport } from './routes/_app/settings/cancellations'
import { Route as AppSettingsCallTemplatesRouteImport } from './routes/_app/settings/call-templates'
import { Route as AppSettingsCallRoutingRouteImport } from './routes/_app/settings/call-routing'
import { Route as AppSettingsAutomationsRouteImport } from './routes/_app/settings/automations'
import { Route as AppSettingsAutomationScheduleRouteImport } from './routes/_app/settings/automation-schedule'
import { Route as AppSettingsAutoSendRouteImport } from './routes/_app/settings/auto-send'
import { Route as AppSettingsAutoReplySettingsRouteImport } from './routes/_app/settings/auto-reply-settings'
import { Route as AppSettingsAutoDraftRouteImport } from './routes/_app/settings/auto-draft'
import { Route as AppSettingsAutoAssignRouteImport } from './routes/_app/settings/auto-assign'
import { Route as AppSettingsAgentSkillsRouteImport } from './routes/_app/settings/agent-skills'
import { Route as AppSettingsAgentRulesRouteImport } from './routes/_app/settings/agent-rules'
import { Route as AppSettingsAgencyContextRouteImport } from './routes/_app/settings/agency-context'
import { Route as AppSettingsActivityFeedRouteImport } from './routes/_app/settings/activity-feed'
import { Route as AppInternalAgreementsRouteImport } from './routes/_app/internal/agreements'
import { Route as AppAdminVoiceLatencyRouteImport } from './routes/_app/admin/voice-latency'
import { Route as AppAdminVoiceRouteImport } from './routes/_app/admin/voice'
import { Route as AppAdminUiComponentsRouteImport } from './routes/_app/admin/ui-components'
import { Route as AppAdminTamMapRouteImport } from './routes/_app/admin/tam-map'
import { Route as AppAdminTagMatchingRouteImport } from './routes/_app/admin/tag-matching'
import { Route as AppAdminSyncSettingsRouteImport } from './routes/_app/admin/sync-settings'
import { Route as AppAdminSmsDebugRouteImport } from './routes/_app/admin/sms-debug'
import { Route as AppAdminSimulatorWorldRouteImport } from './routes/_app/admin/simulator-world'
import { Route as AppAdminShiftAssignmentHealthRouteImport } from './routes/_app/admin/shift-assignment-health'
import { Route as AppAdminSearchRouteImport } from './routes/_app/admin/search'
import { Route as AppAdminReportGeneratorRouteImport } from './routes/_app/admin/report-generator'
import { Route as AppAdminQualityScoreboardRouteImport } from './routes/_app/admin/quality-scoreboard'
import { Route as AppAdminPromptRolloutRouteImport } from './routes/_app/admin/prompt-rollout'
import { Route as AppAdminOutreachesRouteImport } from './routes/_app/admin/outreaches'
import { Route as AppAdminOutreachObservabilityRouteImport } from './routes/_app/admin/outreach-observability'
import { Route as AppAdminOrganizationDefaultSettingsRouteImport } from './routes/_app/admin/organization-default-settings'
import { Route as AppAdminOrgSnapshotsRouteImport } from './routes/_app/admin/org-snapshots'
import { Route as AppAdminNotificationsLabRouteImport } from './routes/_app/admin/notifications-lab'
import { Route as AppAdminMessageQueueRouteImport } from './routes/_app/admin/message-queue'
import { Route as AppAdminImessageRequestsRouteImport } from './routes/_app/admin/imessage-requests'
import { Route as AppAdminImessageRouteImport } from './routes/_app/admin/imessage'
import { Route as AppAdminFlagsRouteImport } from './routes/_app/admin/flags'
import { Route as AppAdminDocumentIngestionRouteImport } from './routes/_app/admin/document-ingestion'
import { Route as AppAdminDesignKitRouteImport } from './routes/_app/admin/design-kit'
import { Route as AppAdminDemoOrgRouteImport } from './routes/_app/admin/demo-org'
import { Route as AppAdminDataSyncRouteImport } from './routes/_app/admin/data-sync'
import { Route as AppAdminDataQualityRouteImport } from './routes/_app/admin/data-quality'
import { Route as AppAdminCaregiverSimRouteImport } from './routes/_app/admin/caregiver-sim'
import { Route as AppAdminCarePlanPreviewerRouteImport } from './routes/_app/admin/care-plan-previewer'
import { Route as AppAdminAmdShadowRouteImport } from './routes/_app/admin/amd-shadow'
import { Route as AppAdminAgentToolsRouteImport } from './routes/_app/admin/agent-tools'
import { Route as AppAdminAgentAnalysisRouteImport } from './routes/_app/admin/agent-analysis'
import { Route as AppmainVoiceCallsRouteImport } from './routes/_app/(main)/voice-calls'
import { Route as AppmainTrainingRouteImport } from './routes/_app/(main)/training'
import { Route as AppmainTeachPhoebeRouteImport } from './routes/_app/(main)/teach-phoebe'
import { Route as AppmainReferralsRouteImport } from './routes/_app/(main)/referrals'
import { Route as AppmainPlaybooksRouteImport } from './routes/_app/(main)/playbooks'
import { Route as AppmainPhoneRouteImport } from './routes/_app/(main)/phone'
import { Route as AppmainMetricsRouteImport } from './routes/_app/(main)/metrics'
import { Route as AppmainLearnPhoebeRouteImport } from './routes/_app/(main)/learn-phoebe'
import { Route as AppmainLeaderboardRouteImport } from './routes/_app/(main)/leaderboard'
import { Route as AppmainHomeRouteImport } from './routes/_app/(main)/home'
import { Route as AppmainDryRunReportRouteImport } from './routes/_app/(main)/dry-run-report'
import { Route as AppmainCoverageRouteImport } from './routes/_app/(main)/coverage'
import { Route as AppmainClientsRouteImport } from './routes/_app/(main)/clients'
import { Route as AppmainCaregiversRouteImport } from './routes/_app/(main)/caregivers'
import { Route as AppmainCalloutsRouteImport } from './routes/_app/(main)/callouts'
import { Route as AppmainAutomationsRouteImport } from './routes/_app/(main)/automations'
import { Route as AppmainAuthorizationsRouteImport } from './routes/_app/(main)/authorizations'
import { Route as AppmainActivityBoardRouteImport } from './routes/_app/(main)/activity-board'
import { Route as AppmainActivityRouteImport } from './routes/_app/(main)/activity'
import { Route as AppagentAgentRouteImport } from './routes/_app/(agent)/agent'
import { Route as AppSettingsNotificationsRouteRouteImport } from './routes/_app/settings/notifications/route'
import { Route as AppAdminExtensionLabRouteRouteImport } from './routes/_app/admin/extension-lab/route'
import { Route as AppextensionExtensionLocalRouteRouteImport } from './routes/_app/(extension)/extension-local/route'
import { Route as AppextensionExtensionRouteRouteImport } from './routes/_app/(extension)/extension/route'
import { Route as AppSettingsNotificationsIndexRouteImport } from './routes/_app/settings/notifications/index'
import { Route as AppAdminVoipIndexRouteImport } from './routes/_app/admin/voip/index'
import { Route as AppAdminVoiceQaIndexRouteImport } from './routes/_app/admin/voice-qa/index'
import { Route as AppAdminVoicePlaygroundIndexRouteImport } from './routes/_app/admin/voice-playground/index'
import { Route as AppAdminVoiceEvalsIndexRouteImport } from './routes/_app/admin/voice-evals/index'
import { Route as AppAdminVoiceConfigIndexRouteImport } from './routes/_app/admin/voice-config/index'
import { Route as AppAdminUsersIndexRouteImport } from './routes/_app/admin/users/index'
import { Route as AppAdminSmsEngineRunsIndexRouteImport } from './routes/_app/admin/sms-engine-runs/index'
import { Route as AppAdminShiftsIndexRouteImport } from './routes/_app/admin/shifts/index'
import { Route as AppAdminSandboxIndexRouteImport } from './routes/_app/admin/sandbox/index'
import { Route as AppAdminRevenueIndexRouteImport } from './routes/_app/admin/revenue/index'
import { Route as AppAdminRecommendationExplorerIndexRouteImport } from './routes/_app/admin/recommendation-explorer/index'
import { Route as AppAdminOutboxIndexRouteImport } from './routes/_app/admin/outbox/index'
import { Route as AppAdminOrganizationsIndexRouteImport } from './routes/_app/admin/organizations/index'
import { Route as AppAdminOrgDistributionsIndexRouteImport } from './routes/_app/admin/org-distributions/index'
import { Route as AppAdminFranchisesIndexRouteImport } from './routes/_app/admin/franchises/index'
import { Route as AppAdminExtensionLabIndexRouteImport } from './routes/_app/admin/extension-lab/index'
import { Route as AppAdminClientsIndexRouteImport } from './routes/_app/admin/clients/index'
import { Route as AppAdminCaregiversIndexRouteImport } from './routes/_app/admin/caregivers/index'
import { Route as AppAdminCareCoordinatorsIndexRouteImport } from './routes/_app/admin/care-coordinators/index'
import { Route as AppAdminCallsIndexRouteImport } from './routes/_app/admin/calls/index'
import { Route as AppAdminAutomationsIndexRouteImport } from './routes/_app/admin/automations/index'
import { Route as AppAdminAutoCalloutBoardIndexRouteImport } from './routes/_app/admin/auto-callout-board/index'
import { Route as AppAdminAnalyticsIndexRouteImport } from './routes/_app/admin/analytics/index'
import { Route as AppAdminAgentIndexRouteImport } from './routes/_app/admin/agent/index'
import { Route as AppAdminAgentTracesIndexRouteImport } from './routes/_app/admin/agent-traces/index'
import { Route as AppAdminAgentNotesIndexRouteImport } from './routes/_app/admin/agent-notes/index'
import { Route as AppAdminAccountsIndexRouteImport } from './routes/_app/admin/accounts/index'
import { Route as AppAdminAccessTokensIndexRouteImport } from './routes/_app/admin/access-tokens/index'
import { Route as AppmainTrainingIndexRouteImport } from './routes/_app/(main)/training/index'
import { Route as AppmainSurveysIndexRouteImport } from './routes/_app/(main)/surveys/index'
import { Route as AppmainShiftsIndexRouteImport } from './routes/_app/(main)/shifts/index'
import { Route as AppmainScheduledIndexRouteImport } from './routes/_app/(main)/scheduled/index'
import { Route as AppmainOutreachesIndexRouteImport } from './routes/_app/(main)/outreaches/index'
import { Route as AppmainConversationsIndexRouteImport } from './routes/_app/(main)/conversations/index'
import { Route as AppmainCalendarIndexRouteImport } from './routes/_app/(main)/calendar/index'
import { Route as AppagentAgentIndexRouteImport } from './routes/_app/(agent)/agent/index'
import { Route as AppSettingsNotificationsChannelRouteImport } from './routes/_app/settings/notifications/$channel'
import { Route as AppAdminVoipOrganizationIdRouteImport } from './routes/_app/admin/voip/$organization-id'
import { Route as AppAdminVoiceQaShadowComparisonRouteImport } from './routes/_app/admin/voice-qa/shadow-comparison'
import { Route as AppAdminVoiceQaCallIdRouteImport } from './routes/_app/admin/voice-qa/$callId'
import { Route as AppAdminVoicePlaygroundCallIdRouteImport } from './routes/_app/admin/voice-playground/$call-id'
import { Route as AppAdminVoiceEvalsCompareCaseRouteImport } from './routes/_app/admin/voice-evals/compare-case'
import { Route as AppAdminVoiceEvalsCompareRouteImport } from './routes/_app/admin/voice-evals/compare'
import { Route as AppAdminVoiceEvalsCatalogRouteImport } from './routes/_app/admin/voice-evals/catalog'
import { Route as AppAdminVoiceEvalsCasesRouteImport } from './routes/_app/admin/voice-evals/cases'
import { Route as AppAdminVoiceConfigOrganizationIdRouteImport } from './routes/_app/admin/voice-config/$organization-id'
import { Route as AppAdminUsersUserIdRouteImport } from './routes/_app/admin/users/$user-id'
import { Route as AppAdminSmsEngineRunsRunIdRouteImport } from './routes/_app/admin/sms-engine-runs/$runId'
import { Route as AppAdminShiftsShiftIdRouteImport } from './routes/_app/admin/shifts/$shift-id'
import { Route as AppAdminSandboxOrganizationIdRouteImport } from './routes/_app/admin/sandbox/$organizationId'
import { Route as AppAdminSalesAgreementsRouteImport } from './routes/_app/admin/sales/agreements'
import { Route as AppAdminRevenueAccountsRouteImport } from './routes/_app/admin/revenue/accounts'
import { Route as AppAdminRevenueAccountIdRouteImport } from './routes/_app/admin/revenue/$account-id'
import { Route as AppAdminOrganizationsOrganizationIdRouteImport } from './routes/_app/admin/organizations/$organization-id'
import { Route as AppAdminClientsClientIdRouteImport } from './routes/_app/admin/clients/$client-id'
import { Route as AppAdminCaregiversCaregiverIdRouteImport } from './routes/_app/admin/caregivers/$caregiver-id'
import { Route as AppAdminCareCoordinatorsCareCoordinatorIdRouteImport } from './routes/_app/admin/care-coordinators/$care-coordinator-id'
import { Route as AppAdminCallsCallIdRouteImport } from './routes/_app/admin/calls/$callId'
import { Route as AppAdminAnalyticsSlugRouteImport } from './routes/_app/admin/analytics/$slug'
import { Route as AppAdminAgentToolTelemetryRouteImport } from './routes/_app/admin/agent/tool-telemetry'
import { Route as AppAdminAgentMissingToolsRouteImport } from './routes/_app/admin/agent/missing-tools'
import { Route as AppAdminAgentCapabilitiesRouteImport } from './routes/_app/admin/agent/capabilities'
import { Route as AppAdminAgentRunIdRouteImport } from './routes/_app/admin/agent/$runId'
import { Route as AppAdminAgentTracesEphemeralRouteImport } from './routes/_app/admin/agent-traces/ephemeral'
import { Route as AppAdminAgentTracesConversationIdRouteImport } from './routes/_app/admin/agent-traces/$conversationId'
import { Route as AppAdminAgentNotesNoteIdRouteImport } from './routes/_app/admin/agent-notes/$note-id'
import { Route as AppAdminAccountsAccountIdRouteImport } from './routes/_app/admin/accounts/$accountId'
import { Route as AppmainTrainingOnboardingRouteImport } from './routes/_app/(main)/training/onboarding'
import { Route as AppmainTrainingDemoRouteImport } from './routes/_app/(main)/training/demo'
import { Route as AppmainTrainingAnnouncementRouteImport } from './routes/_app/(main)/training/announcement'
import { Route as AppmainSurveysCreateRouteImport } from './routes/_app/(main)/surveys/create'
import { Route as AppmainSurveysSurveyIdRouteImport } from './routes/_app/(main)/surveys/$survey-id'
import { Route as AppmainShiftsShiftIdRouteImport } from './routes/_app/(main)/shifts/$shift-id'
import { Route as AppmainOutreachesCalloutIdRouteImport } from './routes/_app/(main)/outreaches/$callout-id'
import { Route as AppAdminAgentScratchpadIndexRouteImport } from './routes/_app/admin/agent/scratchpad/index'
import { Route as AppAdminAgentPagesIndexRouteImport } from './routes/_app/admin/agent/pages/index'
import { Route as AppAdminAgentAutomationsIndexRouteImport } from './routes/_app/admin/agent/automations/index'
import { Route as AppAdminAgentActionsIndexRouteImport } from './routes/_app/admin/agent/actions/index'
import { Route as AppAdminAutomationsOrganizationIdAutomationIdRouteImport } from './routes/_app/admin/automations/$organizationId/$automationId'
import { Route as AppAdminAgentScratchpadNoteIdRouteImport } from './routes/_app/admin/agent/scratchpad/$note-id'
import { Route as AppAdminAgentPagesSlugRouteImport } from './routes/_app/admin/agent/pages/$slug'
import { Route as AppAdminAgentAutomationsRunsRouteImport } from './routes/_app/admin/agent/automations/runs'
import { Route as AppAdminAgentAutomationsListRouteImport } from './routes/_app/admin/agent/automations/list'
import { Route as AppAdminAgentActionsAuditIdRouteImport } from './routes/_app/admin/agent/actions/$audit-id'
import { Route as AppAdminAgentTracesRunRunIdRouteImport } from './routes/_app/admin/agent-traces/run/$runId'
import { Route as AppmainOutreachesSurveyCreateRouteImport } from './routes/_app/(main)/outreaches/survey.create'
import { Route as AppmainOutreachesSurveySurveyIdRouteImport } from './routes/_app/(main)/outreaches/survey.$survey-id'
import { Route as AppmainOutreachesMessageCreateRouteImport } from './routes/_app/(main)/outreaches/message.create'
import { Route as AppmainOutreachesMessageMessageIdRouteImport } from './routes/_app/(main)/outreaches/message.$message-id'
import { Route as AppagentAgentRunsRunIdRouteImport } from './routes/_app/(agent)/agent/runs/$runId'
import { Route as AppAdminVoiceEvalsRunsRunIdIndexRouteImport } from './routes/_app/admin/voice-evals/runs/$runId/index'
import { Route as AppAdminAutomationsOrganizationIdAutomationIdIndexRouteImport } from './routes/_app/admin/automations/$organizationId/$automationId/index'
import { Route as AppAdminAgentAutomationsOrganizationIdAutomationIdRouteImport } from './routes/_app/admin/agent/automations/$organizationId/$automationId'
import { Route as AppmainExtensionReviewCalendarPhpUnassignedRouteImport } from './routes/_app/(main)/extension-review/calendar/php/unassigned'
import { Route as AppAdminAgentAutomationsOrganizationIdAutomationIdIndexRouteImport } from './routes/_app/admin/agent/automations/$organizationId/$automationId/index'
import { Route as AppAdminVoiceEvalsRunsRunIdCasesCaseResultIdRouteImport } from './routes/_app/admin/voice-evals/runs/$runId/cases/$caseResultId'
import { Route as AppAdminExtensionLabEhrProviderEntityExternalIdRouteImport } from './routes/_app/admin/extension-lab/ehr/$provider/$entity/$externalId'
import { Route as AppAdminAutomationsOrganizationIdAutomationIdRunsAutomationRunIdRouteImport } from './routes/_app/admin/automations/$organizationId/$automationId/runs/$automationRunId'
import { Route as AppAdminAgentRunsRunIdArtifactsArtifactIdRouteImport } from './routes/_app/admin/agent/runs/$runId/artifacts/$artifactId'
import { Route as AppAdminAgentAutomationsOrganizationIdAutomationIdRunsAutomationRunIdRouteImport } from './routes/_app/admin/agent/automations/$organizationId/$automationId/runs/$automationRunId'

const TeachPhoebeFeedbackTagsMockupRoute =
  TeachPhoebeFeedbackTagsMockupRouteImport.update({
    id: '/teach-phoebe-feedback-tags-mockup',
    path: '/teach-phoebe-feedback-tags-mockup',
    getParentRoute: () => rootRouteImport,
  } as any)
const PhoebeThinkingTipsMockupRoute =
  PhoebeThinkingTipsMockupRouteImport.update({
    id: '/phoebe-thinking-tips-mockup',
    path: '/phoebe-thinking-tips-mockup',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuthRouteRoute = AuthRouteRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRouteRoute = AppRouteRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const SimulatorWorldDisplayRoute = SimulatorWorldDisplayRouteImport.update({
  id: '/simulator-world/display',
  path: '/simulator-world/display',
  getParentRoute: () => rootRouteImport,
} as any)
const RCodeRoute = RCodeRouteImport.update({
  id: '/r/$code',
  path: '/r/$code',
  getParentRoute: () => rootRouteImport,
} as any)
const OutreachesPhoebeThinkingTipsMockupRoute =
  OutreachesPhoebeThinkingTipsMockupRouteImport.update({
    id: '/outreaches/phoebe-thinking-tips-mockup',
    path: '/outreaches/phoebe-thinking-tips-mockup',
    getParentRoute: () => rootRouteImport,
  } as any)
const ChromeExtensionPrivacyRoute = ChromeExtensionPrivacyRouteImport.update({
  id: '/chrome-extension/privacy',
  path: '/chrome-extension/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthSignUpRoute = AuthSignUpRouteImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthSignOutRoute = AuthSignOutRouteImport.update({
  id: '/sign-out',
  path: '/sign-out',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthSignInRoute = AuthSignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthResetPasswordRoute = AuthResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthIntroCallBookedRoute = AuthIntroCallBookedRouteImport.update({
  id: '/intro-call-booked',
  path: '/intro-call-booked',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthErrorRoute = AuthErrorRouteImport.update({
  id: '/error',
  path: '/error',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthChangePasswordRoute = AuthChangePasswordRouteImport.update({
  id: '/change-password',
  path: '/change-password',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthAcceptInvitationRoute = AuthAcceptInvitationRouteImport.update({
  id: '/accept-invitation',
  path: '/accept-invitation',
  getParentRoute: () => AuthRouteRoute,
} as any)
const OrganizationIdDemoRoute = OrganizationIdDemoRouteImport.update({
  id: '/$organization-id/demo',
  path: '/$organization-id/demo',
  getParentRoute: () => rootRouteImport,
} as any)
const AppSettingsRouteRoute = AppSettingsRouteRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppAdminRouteRoute = AppAdminRouteRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppmainRouteRoute = AppmainRouteRouteImport.update({
  id: '/(main)',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppextensionRouteRoute = AppextensionRouteRouteImport.update({
  id: '/(extension)',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppagentRouteRoute = AppagentRouteRouteImport.update({
  id: '/(agent)',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppSettingsIndexRoute = AppSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppAdminIndexRoute = AppAdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppmainIndexRoute = AppmainIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppmainRouteRoute,
} as any)
const AppSlackLinkRoute = AppSlackLinkRouteImport.update({
  id: '/slack/link',
  path: '/slack/link',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppSettingsTestModeRoute = AppSettingsTestModeRouteImport.update({
  id: '/test-mode',
  path: '/test-mode',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsTeamMembersRoute = AppSettingsTeamMembersRouteImport.update({
  id: '/team-members',
  path: '/team-members',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsTeamCoverageRoute = AppSettingsTeamCoverageRouteImport.update({
  id: '/team-coverage',
  path: '/team-coverage',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsTagMatchingRoute = AppSettingsTagMatchingRouteImport.update({
  id: '/tag-matching',
  path: '/tag-matching',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsSlackRoute = AppSettingsSlackRouteImport.update({
  id: '/slack',
  path: '/slack',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsSkipAllowListsRoute =
  AppSettingsSkipAllowListsRouteImport.update({
    id: '/skip-allow-lists',
    path: '/skip-allow-lists',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppSettingsShiftConfirmationsRoute =
  AppSettingsShiftConfirmationsRouteImport.update({
    id: '/shift-confirmations',
    path: '/shift-confirmations',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppSettingsShiftConfirmationSkipAllowListsRoute =
  AppSettingsShiftConfirmationSkipAllowListsRouteImport.update({
    id: '/shift-confirmation-skip-allow-lists',
    path: '/shift-confirmation-skip-allow-lists',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppSettingsRecommendationsRoute =
  AppSettingsRecommendationsRouteImport.update({
    id: '/recommendations',
    path: '/recommendations',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppSettingsQuietHoursRoute = AppSettingsQuietHoursRouteImport.update({
  id: '/quiet-hours',
  path: '/quiet-hours',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsPhoneTryRoute = AppSettingsPhoneTryRouteImport.update({
  id: '/phone-try',
  path: '/phone-try',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsPhoneNumbersRoute = AppSettingsPhoneNumbersRouteImport.update({
  id: '/phone-numbers',
  path: '/phone-numbers',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsPhoneInstructionsRoute =
  AppSettingsPhoneInstructionsRouteImport.update({
    id: '/phone-instructions',
    path: '/phone-instructions',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppSettingsPhoneRoute = AppSettingsPhoneRouteImport.update({
  id: '/phone',
  path: '/phone',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsPhoebeRoute = AppSettingsPhoebeRouteImport.update({
  id: '/phoebe',
  path: '/phoebe',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsOutreachTemplatesRoute =
  AppSettingsOutreachTemplatesRouteImport.update({
    id: '/outreach-templates',
    path: '/outreach-templates',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppSettingsOutreachAutomationRoute =
  AppSettingsOutreachAutomationRouteImport.update({
    id: '/outreach-automation',
    path: '/outreach-automation',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppSettingsOtherTemplatesRoute =
  AppSettingsOtherTemplatesRouteImport.update({
    id: '/other-templates',
    path: '/other-templates',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppSettingsOpenShiftResponsesRoute =
  AppSettingsOpenShiftResponsesRouteImport.update({
    id: '/open-shift-responses',
    path: '/open-shift-responses',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppSettingsOfficesRoute = AppSettingsOfficesRouteImport.update({
  id: '/offices',
  path: '/offices',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsOffHoursRoute = AppSettingsOffHoursRouteImport.update({
  id: '/off-hours',
  path: '/off-hours',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsHelpCenterRoute = AppSettingsHelpCenterRouteImport.update({
  id: '/help-center',
  path: '/help-center',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsEarlyAccessRoute = AppSettingsEarlyAccessRouteImport.update({
  id: '/early-access',
  path: '/early-access',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsDataSyncRoute = AppSettingsDataSyncRouteImport.update({
  id: '/data-sync',
  path: '/data-sync',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsDailyDigestRoute = AppSettingsDailyDigestRouteImport.update({
  id: '/daily-digest',
  path: '/daily-digest',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsConfirmationMessagesRoute =
  AppSettingsConfirmationMessagesRouteImport.update({
    id: '/confirmation-messages',
    path: '/confirmation-messages',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppSettingsConfigurationsRoute =
  AppSettingsConfigurationsRouteImport.update({
    id: '/configurations',
    path: '/configurations',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppSettingsClockInTemplatesRoute =
  AppSettingsClockInTemplatesRouteImport.update({
    id: '/clock-in-templates',
    path: '/clock-in-templates',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppSettingsClockInOutRoute = AppSettingsClockInOutRouteImport.update({
  id: '/clock-in-out',
  path: '/clock-in-out',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsChromeExtensionRoute =
  AppSettingsChromeExtensionRouteImport.update({
    id: '/chrome-extension',
    path: '/chrome-extension',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppSettingsChangeHistoryRoute =
  AppSettingsChangeHistoryRouteImport.update({
    id: '/change-history',
    path: '/change-history',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppSettingsCaregiverTagsRoute =
  AppSettingsCaregiverTagsRouteImport.update({
    id: '/caregiver-tags',
    path: '/caregiver-tags',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppSettingsCaregiverEngagementRoute =
  AppSettingsCaregiverEngagementRouteImport.update({
    id: '/caregiver-engagement',
    path: '/caregiver-engagement',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppSettingsCareCoordinatorsRoute =
  AppSettingsCareCoordinatorsRouteImport.update({
    id: '/care-coordinators',
    path: '/care-coordinators',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppSettingsCancellationsRoute =
  AppSettingsCancellationsRouteImport.update({
    id: '/cancellations',
    path: '/cancellations',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppSettingsCallTemplatesRoute =
  AppSettingsCallTemplatesRouteImport.update({
    id: '/call-templates',
    path: '/call-templates',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppSettingsCallRoutingRoute = AppSettingsCallRoutingRouteImport.update({
  id: '/call-routing',
  path: '/call-routing',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsAutomationsRoute = AppSettingsAutomationsRouteImport.update({
  id: '/automations',
  path: '/automations',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsAutomationScheduleRoute =
  AppSettingsAutomationScheduleRouteImport.update({
    id: '/automation-schedule',
    path: '/automation-schedule',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppSettingsAutoSendRoute = AppSettingsAutoSendRouteImport.update({
  id: '/auto-send',
  path: '/auto-send',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsAutoReplySettingsRoute =
  AppSettingsAutoReplySettingsRouteImport.update({
    id: '/auto-reply-settings',
    path: '/auto-reply-settings',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppSettingsAutoDraftRoute = AppSettingsAutoDraftRouteImport.update({
  id: '/auto-draft',
  path: '/auto-draft',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsAutoAssignRoute = AppSettingsAutoAssignRouteImport.update({
  id: '/auto-assign',
  path: '/auto-assign',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsAgentSkillsRoute = AppSettingsAgentSkillsRouteImport.update({
  id: '/agent-skills',
  path: '/agent-skills',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsAgentRulesRoute = AppSettingsAgentRulesRouteImport.update({
  id: '/agent-rules',
  path: '/agent-rules',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsAgencyContextRoute =
  AppSettingsAgencyContextRouteImport.update({
    id: '/agency-context',
    path: '/agency-context',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppSettingsActivityFeedRoute = AppSettingsActivityFeedRouteImport.update({
  id: '/activity-feed',
  path: '/activity-feed',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppInternalAgreementsRoute = AppInternalAgreementsRouteImport.update({
  id: '/internal/agreements',
  path: '/internal/agreements',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppAdminVoiceLatencyRoute = AppAdminVoiceLatencyRouteImport.update({
  id: '/voice-latency',
  path: '/voice-latency',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminVoiceRoute = AppAdminVoiceRouteImport.update({
  id: '/voice',
  path: '/voice',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminUiComponentsRoute = AppAdminUiComponentsRouteImport.update({
  id: '/ui-components',
  path: '/ui-components',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminTamMapRoute = AppAdminTamMapRouteImport.update({
  id: '/tam-map',
  path: '/tam-map',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminTagMatchingRoute = AppAdminTagMatchingRouteImport.update({
  id: '/tag-matching',
  path: '/tag-matching',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminSyncSettingsRoute = AppAdminSyncSettingsRouteImport.update({
  id: '/sync-settings',
  path: '/sync-settings',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminSmsDebugRoute = AppAdminSmsDebugRouteImport.update({
  id: '/sms-debug',
  path: '/sms-debug',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminSimulatorWorldRoute = AppAdminSimulatorWorldRouteImport.update({
  id: '/simulator-world',
  path: '/simulator-world',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminShiftAssignmentHealthRoute =
  AppAdminShiftAssignmentHealthRouteImport.update({
    id: '/shift-assignment-health',
    path: '/shift-assignment-health',
    getParentRoute: () => AppAdminRouteRoute,
  } as any)
const AppAdminSearchRoute = AppAdminSearchRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminReportGeneratorRoute = AppAdminReportGeneratorRouteImport.update({
  id: '/report-generator',
  path: '/report-generator',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminQualityScoreboardRoute =
  AppAdminQualityScoreboardRouteImport.update({
    id: '/quality-scoreboard',
    path: '/quality-scoreboard',
    getParentRoute: () => AppAdminRouteRoute,
  } as any)
const AppAdminPromptRolloutRoute = AppAdminPromptRolloutRouteImport.update({
  id: '/prompt-rollout',
  path: '/prompt-rollout',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminOutreachesRoute = AppAdminOutreachesRouteImport.update({
  id: '/outreaches',
  path: '/outreaches',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminOutreachObservabilityRoute =
  AppAdminOutreachObservabilityRouteImport.update({
    id: '/outreach-observability',
    path: '/outreach-observability',
    getParentRoute: () => AppAdminRouteRoute,
  } as any)
const AppAdminOrganizationDefaultSettingsRoute =
  AppAdminOrganizationDefaultSettingsRouteImport.update({
    id: '/organization-default-settings',
    path: '/organization-default-settings',
    getParentRoute: () => AppAdminRouteRoute,
  } as any)
const AppAdminOrgSnapshotsRoute = AppAdminOrgSnapshotsRouteImport.update({
  id: '/org-snapshots',
  path: '/org-snapshots',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminNotificationsLabRoute =
  AppAdminNotificationsLabRouteImport.update({
    id: '/notifications-lab',
    path: '/notifications-lab',
    getParentRoute: () => AppAdminRouteRoute,
  } as any)
const AppAdminMessageQueueRoute = AppAdminMessageQueueRouteImport.update({
  id: '/message-queue',
  path: '/message-queue',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminImessageRequestsRoute =
  AppAdminImessageRequestsRouteImport.update({
    id: '/imessage-requests',
    path: '/imessage-requests',
    getParentRoute: () => AppAdminRouteRoute,
  } as any)
const AppAdminImessageRoute = AppAdminImessageRouteImport.update({
  id: '/imessage',
  path: '/imessage',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminFlagsRoute = AppAdminFlagsRouteImport.update({
  id: '/flags',
  path: '/flags',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminDocumentIngestionRoute =
  AppAdminDocumentIngestionRouteImport.update({
    id: '/document-ingestion',
    path: '/document-ingestion',
    getParentRoute: () => AppAdminRouteRoute,
  } as any)
const AppAdminDesignKitRoute = AppAdminDesignKitRouteImport.update({
  id: '/design-kit',
  path: '/design-kit',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminDemoOrgRoute = AppAdminDemoOrgRouteImport.update({
  id: '/demo-org',
  path: '/demo-org',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminDataSyncRoute = AppAdminDataSyncRouteImport.update({
  id: '/data-sync',
  path: '/data-sync',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminDataQualityRoute = AppAdminDataQualityRouteImport.update({
  id: '/data-quality',
  path: '/data-quality',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminCaregiverSimRoute = AppAdminCaregiverSimRouteImport.update({
  id: '/caregiver-sim',
  path: '/caregiver-sim',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminCarePlanPreviewerRoute =
  AppAdminCarePlanPreviewerRouteImport.update({
    id: '/care-plan-previewer',
    path: '/care-plan-previewer',
    getParentRoute: () => AppAdminRouteRoute,
  } as any)
const AppAdminAmdShadowRoute = AppAdminAmdShadowRouteImport.update({
  id: '/amd-shadow',
  path: '/amd-shadow',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminAgentToolsRoute = AppAdminAgentToolsRouteImport.update({
  id: '/agent-tools',
  path: '/agent-tools',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminAgentAnalysisRoute = AppAdminAgentAnalysisRouteImport.update({
  id: '/agent-analysis',
  path: '/agent-analysis',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppmainVoiceCallsRoute = AppmainVoiceCallsRouteImport.update({
  id: '/voice-calls',
  path: '/voice-calls',
  getParentRoute: () => AppmainRouteRoute,
} as any)
const AppmainTrainingRoute = AppmainTrainingRouteImport.update({
  id: '/training',
  path: '/training',
  getParentRoute: () => AppmainRouteRoute,
} as any)
const AppmainTeachPhoebeRoute = AppmainTeachPhoebeRouteImport.update({
  id: '/teach-phoebe',
  path: '/teach-phoebe',
  getParentRoute: () => AppmainRouteRoute,
} as any)
const AppmainReferralsRoute = AppmainReferralsRouteImport.update({
  id: '/referrals',
  path: '/referrals',
  getParentRoute: () => AppmainRouteRoute,
} as any)
const AppmainPlaybooksRoute = AppmainPlaybooksRouteImport.update({
  id: '/playbooks',
  path: '/playbooks',
  getParentRoute: () => AppmainRouteRoute,
} as any)
const AppmainPhoneRoute = AppmainPhoneRouteImport.update({
  id: '/phone',
  path: '/phone',
  getParentRoute: () => AppmainRouteRoute,
} as any)
const AppmainMetricsRoute = AppmainMetricsRouteImport.update({
  id: '/metrics',
  path: '/metrics',
  getParentRoute: () => AppmainRouteRoute,
} as any)
const AppmainLearnPhoebeRoute = AppmainLearnPhoebeRouteImport.update({
  id: '/learn-phoebe',
  path: '/learn-phoebe',
  getParentRoute: () => AppmainRouteRoute,
} as any)
const AppmainLeaderboardRoute = AppmainLeaderboardRouteImport.update({
  id: '/leaderboard',
  path: '/leaderboard',
  getParentRoute: () => AppmainRouteRoute,
} as any)
const AppmainHomeRoute = AppmainHomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => AppmainRouteRoute,
} as any)
const AppmainDryRunReportRoute = AppmainDryRunReportRouteImport.update({
  id: '/dry-run-report',
  path: '/dry-run-report',
  getParentRoute: () => AppmainRouteRoute,
} as any)
const AppmainCoverageRoute = AppmainCoverageRouteImport.update({
  id: '/coverage',
  path: '/coverage',
  getParentRoute: () => AppmainRouteRoute,
} as any)
const AppmainClientsRoute = AppmainClientsRouteImport.update({
  id: '/clients',
  path: '/clients',
  getParentRoute: () => AppmainRouteRoute,
} as any)
const AppmainCaregiversRoute = AppmainCaregiversRouteImport.update({
  id: '/caregivers',
  path: '/caregivers',
  getParentRoute: () => AppmainRouteRoute,
} as any)
const AppmainCalloutsRoute = AppmainCalloutsRouteImport.update({
  id: '/callouts',
  path: '/callouts',
  getParentRoute: () => AppmainRouteRoute,
} as any)
const AppmainAutomationsRoute = AppmainAutomationsRouteImport.update({
  id: '/automations',
  path: '/automations',
  getParentRoute: () => AppmainRouteRoute,
} as any)
const AppmainAuthorizationsRoute = AppmainAuthorizationsRouteImport.update({
  id: '/authorizations',
  path: '/authorizations',
  getParentRoute: () => AppmainRouteRoute,
} as any)
const AppmainActivityBoardRoute = AppmainActivityBoardRouteImport.update({
  id: '/activity-board',
  path: '/activity-board',
  getParentRoute: () => AppmainRouteRoute,
} as any)
const AppmainActivityRoute = AppmainActivityRouteImport.update({
  id: '/activity',
  path: '/activity',
  getParentRoute: () => AppmainRouteRoute,
} as any)
const AppagentAgentRoute = AppagentAgentRouteImport.update({
  id: '/agent',
  path: '/agent',
  getParentRoute: () => AppagentRouteRoute,
} as any)
const AppSettingsNotificationsRouteRoute =
  AppSettingsNotificationsRouteRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppAdminExtensionLabRouteRoute =
  AppAdminExtensionLabRouteRouteImport.update({
    id: '/extension-lab',
    path: '/extension-lab',
    getParentRoute: () => AppAdminRouteRoute,
  } as any)
const AppextensionExtensionLocalRouteRoute =
  AppextensionExtensionLocalRouteRouteImport.update({
    id: '/extension-local',
    path: '/extension-local',
    getParentRoute: () => AppextensionRouteRoute,
  } as any)
const AppextensionExtensionRouteRoute =
  AppextensionExtensionRouteRouteImport.update({
    id: '/extension',
    path: '/extension',
    getParentRoute: () => AppextensionRouteRoute,
  } as any)
const AppSettingsNotificationsIndexRoute =
  AppSettingsNotificationsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppSettingsNotificationsRouteRoute,
  } as any)
const AppAdminVoipIndexRoute = AppAdminVoipIndexRouteImport.update({
  id: '/voip/',
  path: '/voip/',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminVoiceQaIndexRoute = AppAdminVoiceQaIndexRouteImport.update({
  id: '/voice-qa/',
  path: '/voice-qa/',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminVoicePlaygroundIndexRoute =
  AppAdminVoicePlaygroundIndexRouteImport.update({
    id: '/voice-playground/',
    path: '/voice-playground/',
    getParentRoute: () => AppAdminRouteRoute,
  } as any)
const AppAdminVoiceEvalsIndexRoute = AppAdminVoiceEvalsIndexRouteImport.update({
  id: '/voice-evals/',
  path: '/voice-evals/',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminVoiceConfigIndexRoute =
  AppAdminVoiceConfigIndexRouteImport.update({
    id: '/voice-config/',
    path: '/voice-config/',
    getParentRoute: () => AppAdminRouteRoute,
  } as any)
const AppAdminUsersIndexRoute = AppAdminUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminSmsEngineRunsIndexRoute =
  AppAdminSmsEngineRunsIndexRouteImport.update({
    id: '/sms-engine-runs/',
    path: '/sms-engine-runs/',
    getParentRoute: () => AppAdminRouteRoute,
  } as any)
const AppAdminShiftsIndexRoute = AppAdminShiftsIndexRouteImport.update({
  id: '/shifts/',
  path: '/shifts/',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminSandboxIndexRoute = AppAdminSandboxIndexRouteImport.update({
  id: '/sandbox/',
  path: '/sandbox/',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminRevenueIndexRoute = AppAdminRevenueIndexRouteImport.update({
  id: '/revenue/',
  path: '/revenue/',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminRecommendationExplorerIndexRoute =
  AppAdminRecommendationExplorerIndexRouteImport.update({
    id: '/recommendation-explorer/',
    path: '/recommendation-explorer/',
    getParentRoute: () => AppAdminRouteRoute,
  } as any)
const AppAdminOutboxIndexRoute = AppAdminOutboxIndexRouteImport.update({
  id: '/outbox/',
  path: '/outbox/',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminOrganizationsIndexRoute =
  AppAdminOrganizationsIndexRouteImport.update({
    id: '/organizations/',
    path: '/organizations/',
    getParentRoute: () => AppAdminRouteRoute,
  } as any)
const AppAdminOrgDistributionsIndexRoute =
  AppAdminOrgDistributionsIndexRouteImport.update({
    id: '/org-distributions/',
    path: '/org-distributions/',
    getParentRoute: () => AppAdminRouteRoute,
  } as any)
const AppAdminFranchisesIndexRoute = AppAdminFranchisesIndexRouteImport.update({
  id: '/franchises/',
  path: '/franchises/',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminExtensionLabIndexRoute =
  AppAdminExtensionLabIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppAdminExtensionLabRouteRoute,
  } as any)
const AppAdminClientsIndexRoute = AppAdminClientsIndexRouteImport.update({
  id: '/clients/',
  path: '/clients/',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminCaregiversIndexRoute = AppAdminCaregiversIndexRouteImport.update({
  id: '/caregivers/',
  path: '/caregivers/',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminCareCoordinatorsIndexRoute =
  AppAdminCareCoordinatorsIndexRouteImport.update({
    id: '/care-coordinators/',
    path: '/care-coordinators/',
    getParentRoute: () => AppAdminRouteRoute,
  } as any)
const AppAdminCallsIndexRoute = AppAdminCallsIndexRouteImport.update({
  id: '/calls/',
  path: '/calls/',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminAutomationsIndexRoute =
  AppAdminAutomationsIndexRouteImport.update({
    id: '/automations/',
    path: '/automations/',
    getParentRoute: () => AppAdminRouteRoute,
  } as any)
const AppAdminAutoCalloutBoardIndexRoute =
  AppAdminAutoCalloutBoardIndexRouteImport.update({
    id: '/auto-callout-board/',
    path: '/auto-callout-board/',
    getParentRoute: () => AppAdminRouteRoute,
  } as any)
const AppAdminAnalyticsIndexRoute = AppAdminAnalyticsIndexRouteImport.update({
  id: '/analytics/',
  path: '/analytics/',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminAgentIndexRoute = AppAdminAgentIndexRouteImport.update({
  id: '/agent/',
  path: '/agent/',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminAgentTracesIndexRoute =
  AppAdminAgentTracesIndexRouteImport.update({
    id: '/agent-traces/',
    path: '/agent-traces/',
    getParentRoute: () => AppAdminRouteRoute,
  } as any)
const AppAdminAgentNotesIndexRoute = AppAdminAgentNotesIndexRouteImport.update({
  id: '/agent-notes/',
  path: '/agent-notes/',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminAccountsIndexRoute = AppAdminAccountsIndexRouteImport.update({
  id: '/accounts/',
  path: '/accounts/',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminAccessTokensIndexRoute =
  AppAdminAccessTokensIndexRouteImport.update({
    id: '/access-tokens/',
    path: '/access-tokens/',
    getParentRoute: () => AppAdminRouteRoute,
  } as any)
const AppmainTrainingIndexRoute = AppmainTrainingIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppmainTrainingRoute,
} as any)
const AppmainSurveysIndexRoute = AppmainSurveysIndexRouteImport.update({
  id: '/surveys/',
  path: '/surveys/',
  getParentRoute: () => AppmainRouteRoute,
} as any)
const AppmainShiftsIndexRoute = AppmainShiftsIndexRouteImport.update({
  id: '/shifts/',
  path: '/shifts/',
  getParentRoute: () => AppmainRouteRoute,
} as any)
const AppmainScheduledIndexRoute = AppmainScheduledIndexRouteImport.update({
  id: '/scheduled/',
  path: '/scheduled/',
  getParentRoute: () => AppmainRouteRoute,
} as any)
const AppmainOutreachesIndexRoute = AppmainOutreachesIndexRouteImport.update({
  id: '/outreaches/',
  path: '/outreaches/',
  getParentRoute: () => AppmainRouteRoute,
} as any)
const AppmainConversationsIndexRoute =
  AppmainConversationsIndexRouteImport.update({
    id: '/conversations/',
    path: '/conversations/',
    getParentRoute: () => AppmainRouteRoute,
  } as any)
const AppmainCalendarIndexRoute = AppmainCalendarIndexRouteImport.update({
  id: '/calendar/',
  path: '/calendar/',
  getParentRoute: () => AppmainRouteRoute,
} as any)
const AppagentAgentIndexRoute = AppagentAgentIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppagentAgentRoute,
} as any)
const AppSettingsNotificationsChannelRoute =
  AppSettingsNotificationsChannelRouteImport.update({
    id: '/$channel',
    path: '/$channel',
    getParentRoute: () => AppSettingsNotificationsRouteRoute,
  } as any)
const AppAdminVoipOrganizationIdRoute =
  AppAdminVoipOrganizationIdRouteImport.update({
    id: '/voip/$organization-id',
    path: '/voip/$organization-id',
    getParentRoute: () => AppAdminRouteRoute,
  } as any)
const AppAdminVoiceQaShadowComparisonRoute =
  AppAdminVoiceQaShadowComparisonRouteImport.update({
    id: '/voice-qa/shadow-comparison',
    path: '/voice-qa/shadow-comparison',
    getParentRoute: () => AppAdminRouteRoute,
  } as any)
const AppAdminVoiceQaCallIdRoute = AppAdminVoiceQaCallIdRouteImport.update({
  id: '/voice-qa/$callId',
  path: '/voice-qa/$callId',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminVoicePlaygroundCallIdRoute =
  AppAdminVoicePlaygroundCallIdRouteImport.update({
    id: '/voice-playground/$call-id',
    path: '/voice-playground/$call-id',
    getParentRoute: () => AppAdminRouteRoute,
  } as any)
const AppAdminVoiceEvalsCompareCaseRoute =
  AppAdminVoiceEvalsCompareCaseRouteImport.update({
    id: '/voice-evals/compare-case',
    path: '/voice-evals/compare-case',
    getParentRoute: () => AppAdminRouteRoute,
  } as any)
const AppAdminVoiceEvalsCompareRoute =
  AppAdminVoiceEvalsCompareRouteImport.update({
    id: '/voice-evals/compare',
    path: '/voice-evals/compare',
    getParentRoute: () => AppAdminRouteRoute,
  } as any)
const AppAdminVoiceEvalsCatalogRoute =
  AppAdminVoiceEvalsCatalogRouteImport.update({
    id: '/voice-evals/catalog',
    path: '/voice-evals/catalog',
    getParentRoute: () => AppAdminRouteRoute,
  } as any)
const AppAdminVoiceEvalsCasesRoute = AppAdminVoiceEvalsCasesRouteImport.update({
  id: '/voice-evals/cases',
  path: '/voice-evals/cases',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminVoiceConfigOrganizationIdRoute =
  AppAdminVoiceConfigOrganizationIdRouteImport.update({
    id: '/voice-config/$organization-id',
    path: '/voice-config/$organization-id',
    getParentRoute: () => AppAdminRouteRoute,
  } as any)
const AppAdminUsersUserIdRoute = AppAdminUsersUserIdRouteImport.update({
  id: '/users/$user-id',
  path: '/users/$user-id',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminSmsEngineRunsRunIdRoute =
  AppAdminSmsEngineRunsRunIdRouteImport.update({
    id: '/sms-engine-runs/$runId',
    path: '/sms-engine-runs/$runId',
    getParentRoute: () => AppAdminRouteRoute,
  } as any)
const AppAdminShiftsShiftIdRoute = AppAdminShiftsShiftIdRouteImport.update({
  id: '/shifts/$shift-id',
  path: '/shifts/$shift-id',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminSandboxOrganizationIdRoute =
  AppAdminSandboxOrganizationIdRouteImport.update({
    id: '/sandbox/$organizationId',
    path: '/sandbox/$organizationId',
    getParentRoute: () => AppAdminRouteRoute,
  } as any)
const AppAdminSalesAgreementsRoute = AppAdminSalesAgreementsRouteImport.update({
  id: '/sales/agreements',
  path: '/sales/agreements',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminRevenueAccountsRoute = AppAdminRevenueAccountsRouteImport.update({
  id: '/revenue/accounts',
  path: '/revenue/accounts',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminRevenueAccountIdRoute =
  AppAdminRevenueAccountIdRouteImport.update({
    id: '/revenue/$account-id',
    path: '/revenue/$account-id',
    getParentRoute: () => AppAdminRouteRoute,
  } as any)
const AppAdminOrganizationsOrganizationIdRoute =
  AppAdminOrganizationsOrganizationIdRouteImport.update({
    id: '/organizations/$organization-id',
    path: '/organizations/$organization-id',
    getParentRoute: () => AppAdminRouteRoute,
  } as any)
const AppAdminClientsClientIdRoute = AppAdminClientsClientIdRouteImport.update({
  id: '/clients/$client-id',
  path: '/clients/$client-id',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminCaregiversCaregiverIdRoute =
  AppAdminCaregiversCaregiverIdRouteImport.update({
    id: '/caregivers/$caregiver-id',
    path: '/caregivers/$caregiver-id',
    getParentRoute: () => AppAdminRouteRoute,
  } as any)
const AppAdminCareCoordinatorsCareCoordinatorIdRoute =
  AppAdminCareCoordinatorsCareCoordinatorIdRouteImport.update({
    id: '/care-coordinators/$care-coordinator-id',
    path: '/care-coordinators/$care-coordinator-id',
    getParentRoute: () => AppAdminRouteRoute,
  } as any)
const AppAdminCallsCallIdRoute = AppAdminCallsCallIdRouteImport.update({
  id: '/calls/$callId',
  path: '/calls/$callId',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminAnalyticsSlugRoute = AppAdminAnalyticsSlugRouteImport.update({
  id: '/analytics/$slug',
  path: '/analytics/$slug',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminAgentToolTelemetryRoute =
  AppAdminAgentToolTelemetryRouteImport.update({
    id: '/agent/tool-telemetry',
    path: '/agent/tool-telemetry',
    getParentRoute: () => AppAdminRouteRoute,
  } as any)
const AppAdminAgentMissingToolsRoute =
  AppAdminAgentMissingToolsRouteImport.update({
    id: '/agent/missing-tools',
    path: '/agent/missing-tools',
    getParentRoute: () => AppAdminRouteRoute,
  } as any)
const AppAdminAgentCapabilitiesRoute =
  AppAdminAgentCapabilitiesRouteImport.update({
    id: '/agent/capabilities',
    path: '/agent/capabilities',
    getParentRoute: () => AppAdminRouteRoute,
  } as any)
const AppAdminAgentRunIdRoute = AppAdminAgentRunIdRouteImport.update({
  id: '/agent/$runId',
  path: '/agent/$runId',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminAgentTracesEphemeralRoute =
  AppAdminAgentTracesEphemeralRouteImport.update({
    id: '/agent-traces/ephemeral',
    path: '/agent-traces/ephemeral',
    getParentRoute: () => AppAdminRouteRoute,
  } as any)
const AppAdminAgentTracesConversationIdRoute =
  AppAdminAgentTracesConversationIdRouteImport.update({
    id: '/agent-traces/$conversationId',
    path: '/agent-traces/$conversationId',
    getParentRoute: () => AppAdminRouteRoute,
  } as any)
const AppAdminAgentNotesNoteIdRoute =
  AppAdminAgentNotesNoteIdRouteImport.update({
    id: '/agent-notes/$note-id',
    path: '/agent-notes/$note-id',
    getParentRoute: () => AppAdminRouteRoute,
  } as any)
const AppAdminAccountsAccountIdRoute =
  AppAdminAccountsAccountIdRouteImport.update({
    id: '/accounts/$accountId',
    path: '/accounts/$accountId',
    getParentRoute: () => AppAdminRouteRoute,
  } as any)
const AppmainTrainingOnboardingRoute =
  AppmainTrainingOnboardingRouteImport.update({
    id: '/onboarding',
    path: '/onboarding',
    getParentRoute: () => AppmainTrainingRoute,
  } as any)
const AppmainTrainingDemoRoute = AppmainTrainingDemoRouteImport.update({
  id: '/demo',
  path: '/demo',
  getParentRoute: () => AppmainTrainingRoute,
} as any)
const AppmainTrainingAnnouncementRoute =
  AppmainTrainingAnnouncementRouteImport.update({
    id: '/announcement',
    path: '/announcement',
    getParentRoute: () => AppmainTrainingRoute,
  } as any)
const AppmainSurveysCreateRoute = AppmainSurveysCreateRouteImport.update({
  id: '/surveys/create',
  path: '/surveys/create',
  getParentRoute: () => AppmainRouteRoute,
} as any)
const AppmainSurveysSurveyIdRoute = AppmainSurveysSurveyIdRouteImport.update({
  id: '/surveys/$survey-id',
  path: '/surveys/$survey-id',
  getParentRoute: () => AppmainRouteRoute,
} as any)
const AppmainShiftsShiftIdRoute = AppmainShiftsShiftIdRouteImport.update({
  id: '/shifts/$shift-id',
  path: '/shifts/$shift-id',
  getParentRoute: () => AppmainRouteRoute,
} as any)
const AppmainOutreachesCalloutIdRoute =
  AppmainOutreachesCalloutIdRouteImport.update({
    id: '/outreaches/$callout-id',
    path: '/outreaches/$callout-id',
    getParentRoute: () => AppmainRouteRoute,
  } as any)
const AppAdminAgentScratchpadIndexRoute =
  AppAdminAgentScratchpadIndexRouteImport.update({
    id: '/agent/scratchpad/',
    path: '/agent/scratchpad/',
    getParentRoute: () => AppAdminRouteRoute,
  } as any)
const AppAdminAgentPagesIndexRoute = AppAdminAgentPagesIndexRouteImport.update({
  id: '/agent/pages/',
  path: '/agent/pages/',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminAgentAutomationsIndexRoute =
  AppAdminAgentAutomationsIndexRouteImport.update({
    id: '/agent/automations/',
    path: '/agent/automations/',
    getParentRoute: () => AppAdminRouteRoute,
  } as any)
const AppAdminAgentActionsIndexRoute =
  AppAdminAgentActionsIndexRouteImport.update({
    id: '/agent/actions/',
    path: '/agent/actions/',
    getParentRoute: () => AppAdminRouteRoute,
  } as any)
const AppAdminAutomationsOrganizationIdAutomationIdRoute =
  AppAdminAutomationsOrganizationIdAutomationIdRouteImport.update({
    id: '/automations/$organizationId/$automationId',
    path: '/automations/$organizationId/$automationId',
    getParentRoute: () => AppAdminRouteRoute,
  } as any)
const AppAdminAgentScratchpadNoteIdRoute =
  AppAdminAgentScratchpadNoteIdRouteImport.update({
    id: '/agent/scratchpad/$note-id',
    path: '/agent/scratchpad/$note-id',
    getParentRoute: () => AppAdminRouteRoute,
  } as any)
const AppAdminAgentPagesSlugRoute = AppAdminAgentPagesSlugRouteImport.update({
  id: '/agent/pages/$slug',
  path: '/agent/pages/$slug',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminAgentAutomationsRunsRoute =
  AppAdminAgentAutomationsRunsRouteImport.update({
    id: '/agent/automations/runs',
    path: '/agent/automations/runs',
    getParentRoute: () => AppAdminRouteRoute,
  } as any)
const AppAdminAgentAutomationsListRoute =
  AppAdminAgentAutomationsListRouteImport.update({
    id: '/agent/automations/list',
    path: '/agent/automations/list',
    getParentRoute: () => AppAdminRouteRoute,
  } as any)
const AppAdminAgentActionsAuditIdRoute =
  AppAdminAgentActionsAuditIdRouteImport.update({
    id: '/agent/actions/$audit-id',
    path: '/agent/actions/$audit-id',
    getParentRoute: () => AppAdminRouteRoute,
  } as any)
const AppAdminAgentTracesRunRunIdRoute =
  AppAdminAgentTracesRunRunIdRouteImport.update({
    id: '/agent-traces/run/$runId',
    path: '/agent-traces/run/$runId',
    getParentRoute: () => AppAdminRouteRoute,
  } as any)
const AppmainOutreachesSurveyCreateRoute =
  AppmainOutreachesSurveyCreateRouteImport.update({
    id: '/outreaches/survey/create',
    path: '/outreaches/survey/create',
    getParentRoute: () => AppmainRouteRoute,
  } as any)
const AppmainOutreachesSurveySurveyIdRoute =
  AppmainOutreachesSurveySurveyIdRouteImport.update({
    id: '/outreaches/survey/$survey-id',
    path: '/outreaches/survey/$survey-id',
    getParentRoute: () => AppmainRouteRoute,
  } as any)
const AppmainOutreachesMessageCreateRoute =
  AppmainOutreachesMessageCreateRouteImport.update({
    id: '/outreaches/message/create',
    path: '/outreaches/message/create',
    getParentRoute: () => AppmainRouteRoute,
  } as any)
const AppmainOutreachesMessageMessageIdRoute =
  AppmainOutreachesMessageMessageIdRouteImport.update({
    id: '/outreaches/message/$message-id',
    path: '/outreaches/message/$message-id',
    getParentRoute: () => AppmainRouteRoute,
  } as any)
const AppagentAgentRunsRunIdRoute = AppagentAgentRunsRunIdRouteImport.update({
  id: '/runs/$runId',
  path: '/runs/$runId',
  getParentRoute: () => AppagentAgentRoute,
} as any)
const AppAdminVoiceEvalsRunsRunIdIndexRoute =
  AppAdminVoiceEvalsRunsRunIdIndexRouteImport.update({
    id: '/voice-evals/runs/$runId/',
    path: '/voice-evals/runs/$runId/',
    getParentRoute: () => AppAdminRouteRoute,
  } as any)
const AppAdminAutomationsOrganizationIdAutomationIdIndexRoute =
  AppAdminAutomationsOrganizationIdAutomationIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppAdminAutomationsOrganizationIdAutomationIdRoute,
  } as any)
const AppAdminAgentAutomationsOrganizationIdAutomationIdRoute =
  AppAdminAgentAutomationsOrganizationIdAutomationIdRouteImport.update({
    id: '/agent/automations/$organizationId/$automationId',
    path: '/agent/automations/$organizationId/$automationId',
    getParentRoute: () => AppAdminRouteRoute,
  } as any)
const AppmainExtensionReviewCalendarPhpUnassignedRoute =
  AppmainExtensionReviewCalendarPhpUnassignedRouteImport.update({
    id: '/extension-review/calendar/php/unassigned',
    path: '/extension-review/calendar/php/unassigned',
    getParentRoute: () => AppmainRouteRoute,
  } as any)
const AppAdminAgentAutomationsOrganizationIdAutomationIdIndexRoute =
  AppAdminAgentAutomationsOrganizationIdAutomationIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AppAdminAgentAutomationsOrganizationIdAutomationIdRoute,
  } as any)
const AppAdminVoiceEvalsRunsRunIdCasesCaseResultIdRoute =
  AppAdminVoiceEvalsRunsRunIdCasesCaseResultIdRouteImport.update({
    id: '/voice-evals/runs/$runId/cases/$caseResultId',
    path: '/voice-evals/runs/$runId/cases/$caseResultId',
    getParentRoute: () => AppAdminRouteRoute,
  } as any)
const AppAdminExtensionLabEhrProviderEntityExternalIdRoute =
  AppAdminExtensionLabEhrProviderEntityExternalIdRouteImport.update({
    id: '/ehr/$provider/$entity/$externalId',
    path: '/ehr/$provider/$entity/$externalId',
    getParentRoute: () => AppAdminExtensionLabRouteRoute,
  } as any)
const AppAdminAutomationsOrganizationIdAutomationIdRunsAutomationRunIdRoute =
  AppAdminAutomationsOrganizationIdAutomationIdRunsAutomationRunIdRouteImport.update(
    {
      id: '/runs/$automationRunId',
      path: '/runs/$automationRunId',
      getParentRoute: () => AppAdminAutomationsOrganizationIdAutomationIdRoute,
    } as any,
  )
const AppAdminAgentRunsRunIdArtifactsArtifactIdRoute =
  AppAdminAgentRunsRunIdArtifactsArtifactIdRouteImport.update({
    id: '/agent/runs/$runId/artifacts/$artifactId',
    path: '/agent/runs/$runId/artifacts/$artifactId',
    getParentRoute: () => AppAdminRouteRoute,
  } as any)
const AppAdminAgentAutomationsOrganizationIdAutomationIdRunsAutomationRunIdRoute =
  AppAdminAgentAutomationsOrganizationIdAutomationIdRunsAutomationRunIdRouteImport.update(
    {
      id: '/runs/$automationRunId',
      path: '/runs/$automationRunId',
      getParentRoute: () =>
        AppAdminAgentAutomationsOrganizationIdAutomationIdRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof AppmainIndexRoute
  '/phoebe-thinking-tips-mockup': typeof PhoebeThinkingTipsMockupRoute
  '/teach-phoebe-feedback-tags-mockup': typeof TeachPhoebeFeedbackTagsMockupRoute
  '/admin': typeof AppAdminRouteRouteWithChildren
  '/settings': typeof AppSettingsRouteRouteWithChildren
  '/$organization-id/demo': typeof OrganizationIdDemoRoute
  '/accept-invitation': typeof AuthAcceptInvitationRoute
  '/change-password': typeof AuthChangePasswordRoute
  '/error': typeof AuthErrorRoute
  '/intro-call-booked': typeof AuthIntroCallBookedRoute
  '/reset-password': typeof AuthResetPasswordRoute
  '/sign-in': typeof AuthSignInRoute
  '/sign-out': typeof AuthSignOutRoute
  '/sign-up': typeof AuthSignUpRoute
  '/chrome-extension/privacy': typeof ChromeExtensionPrivacyRoute
  '/outreaches/phoebe-thinking-tips-mockup': typeof OutreachesPhoebeThinkingTipsMockupRoute
  '/r/$code': typeof RCodeRoute
  '/simulator-world/display': typeof SimulatorWorldDisplayRoute
  '/extension': typeof AppextensionExtensionRouteRoute
  '/extension-local': typeof AppextensionExtensionLocalRouteRoute
  '/admin/extension-lab': typeof AppAdminExtensionLabRouteRouteWithChildren
  '/settings/notifications': typeof AppSettingsNotificationsRouteRouteWithChildren
  '/agent': typeof AppagentAgentRouteWithChildren
  '/activity': typeof AppmainActivityRoute
  '/activity-board': typeof AppmainActivityBoardRoute
  '/authorizations': typeof AppmainAuthorizationsRoute
  '/automations': typeof AppmainAutomationsRoute
  '/callouts': typeof AppmainCalloutsRoute
  '/caregivers': typeof AppmainCaregiversRoute
  '/clients': typeof AppmainClientsRoute
  '/coverage': typeof AppmainCoverageRoute
  '/dry-run-report': typeof AppmainDryRunReportRoute
  '/home': typeof AppmainHomeRoute
  '/leaderboard': typeof AppmainLeaderboardRoute
  '/learn-phoebe': typeof AppmainLearnPhoebeRoute
  '/metrics': typeof AppmainMetricsRoute
  '/phone': typeof AppmainPhoneRoute
  '/playbooks': typeof AppmainPlaybooksRoute
  '/referrals': typeof AppmainReferralsRoute
  '/teach-phoebe': typeof AppmainTeachPhoebeRoute
  '/training': typeof AppmainTrainingRouteWithChildren
  '/voice-calls': typeof AppmainVoiceCallsRoute
  '/admin/agent-analysis': typeof AppAdminAgentAnalysisRoute
  '/admin/agent-tools': typeof AppAdminAgentToolsRoute
  '/admin/amd-shadow': typeof AppAdminAmdShadowRoute
  '/admin/care-plan-previewer': typeof AppAdminCarePlanPreviewerRoute
  '/admin/caregiver-sim': typeof AppAdminCaregiverSimRoute
  '/admin/data-quality': typeof AppAdminDataQualityRoute
  '/admin/data-sync': typeof AppAdminDataSyncRoute
  '/admin/demo-org': typeof AppAdminDemoOrgRoute
  '/admin/design-kit': typeof AppAdminDesignKitRoute
  '/admin/document-ingestion': typeof AppAdminDocumentIngestionRoute
  '/admin/flags': typeof AppAdminFlagsRoute
  '/admin/imessage': typeof AppAdminImessageRoute
  '/admin/imessage-requests': typeof AppAdminImessageRequestsRoute
  '/admin/message-queue': typeof AppAdminMessageQueueRoute
  '/admin/notifications-lab': typeof AppAdminNotificationsLabRoute
  '/admin/org-snapshots': typeof AppAdminOrgSnapshotsRoute
  '/admin/organization-default-settings': typeof AppAdminOrganizationDefaultSettingsRoute
  '/admin/outreach-observability': typeof AppAdminOutreachObservabilityRoute
  '/admin/outreaches': typeof AppAdminOutreachesRoute
  '/admin/prompt-rollout': typeof AppAdminPromptRolloutRoute
  '/admin/quality-scoreboard': typeof AppAdminQualityScoreboardRoute
  '/admin/report-generator': typeof AppAdminReportGeneratorRoute
  '/admin/search': typeof AppAdminSearchRoute
  '/admin/shift-assignment-health': typeof AppAdminShiftAssignmentHealthRoute
  '/admin/simulator-world': typeof AppAdminSimulatorWorldRoute
  '/admin/sms-debug': typeof AppAdminSmsDebugRoute
  '/admin/sync-settings': typeof AppAdminSyncSettingsRoute
  '/admin/tag-matching': typeof AppAdminTagMatchingRoute
  '/admin/tam-map': typeof AppAdminTamMapRoute
  '/admin/ui-components': typeof AppAdminUiComponentsRoute
  '/admin/voice': typeof AppAdminVoiceRoute
  '/admin/voice-latency': typeof AppAdminVoiceLatencyRoute
  '/internal/agreements': typeof AppInternalAgreementsRoute
  '/settings/activity-feed': typeof AppSettingsActivityFeedRoute
  '/settings/agency-context': typeof AppSettingsAgencyContextRoute
  '/settings/agent-rules': typeof AppSettingsAgentRulesRoute
  '/settings/agent-skills': typeof AppSettingsAgentSkillsRoute
  '/settings/auto-assign': typeof AppSettingsAutoAssignRoute
  '/settings/auto-draft': typeof AppSettingsAutoDraftRoute
  '/settings/auto-reply-settings': typeof AppSettingsAutoReplySettingsRoute
  '/settings/auto-send': typeof AppSettingsAutoSendRoute
  '/settings/automation-schedule': typeof AppSettingsAutomationScheduleRoute
  '/settings/automations': typeof AppSettingsAutomationsRoute
  '/settings/call-routing': typeof AppSettingsCallRoutingRoute
  '/settings/call-templates': typeof AppSettingsCallTemplatesRoute
  '/settings/cancellations': typeof AppSettingsCancellationsRoute
  '/settings/care-coordinators': typeof AppSettingsCareCoordinatorsRoute
  '/settings/caregiver-engagement': typeof AppSettingsCaregiverEngagementRoute
  '/settings/caregiver-tags': typeof AppSettingsCaregiverTagsRoute
  '/settings/change-history': typeof AppSettingsChangeHistoryRoute
  '/settings/chrome-extension': typeof AppSettingsChromeExtensionRoute
  '/settings/clock-in-out': typeof AppSettingsClockInOutRoute
  '/settings/clock-in-templates': typeof AppSettingsClockInTemplatesRoute
  '/settings/configurations': typeof AppSettingsConfigurationsRoute
  '/settings/confirmation-messages': typeof AppSettingsConfirmationMessagesRoute
  '/settings/daily-digest': typeof AppSettingsDailyDigestRoute
  '/settings/data-sync': typeof AppSettingsDataSyncRoute
  '/settings/early-access': typeof AppSettingsEarlyAccessRoute
  '/settings/help-center': typeof AppSettingsHelpCenterRoute
  '/settings/off-hours': typeof AppSettingsOffHoursRoute
  '/settings/offices': typeof AppSettingsOfficesRoute
  '/settings/open-shift-responses': typeof AppSettingsOpenShiftResponsesRoute
  '/settings/other-templates': typeof AppSettingsOtherTemplatesRoute
  '/settings/outreach-automation': typeof AppSettingsOutreachAutomationRoute
  '/settings/outreach-templates': typeof AppSettingsOutreachTemplatesRoute
  '/settings/phoebe': typeof AppSettingsPhoebeRoute
  '/settings/phone': typeof AppSettingsPhoneRoute
  '/settings/phone-instructions': typeof AppSettingsPhoneInstructionsRoute
  '/settings/phone-numbers': typeof AppSettingsPhoneNumbersRoute
  '/settings/phone-try': typeof AppSettingsPhoneTryRoute
  '/settings/quiet-hours': typeof AppSettingsQuietHoursRoute
  '/settings/recommendations': typeof AppSettingsRecommendationsRoute
  '/settings/shift-confirmation-skip-allow-lists': typeof AppSettingsShiftConfirmationSkipAllowListsRoute
  '/settings/shift-confirmations': typeof AppSettingsShiftConfirmationsRoute
  '/settings/skip-allow-lists': typeof AppSettingsSkipAllowListsRoute
  '/settings/slack': typeof AppSettingsSlackRoute
  '/settings/tag-matching': typeof AppSettingsTagMatchingRoute
  '/settings/team-coverage': typeof AppSettingsTeamCoverageRoute
  '/settings/team-members': typeof AppSettingsTeamMembersRoute
  '/settings/test-mode': typeof AppSettingsTestModeRoute
  '/slack/link': typeof AppSlackLinkRoute
  '/admin/': typeof AppAdminIndexRoute
  '/settings/': typeof AppSettingsIndexRoute
  '/outreaches/$callout-id': typeof AppmainOutreachesCalloutIdRoute
  '/shifts/$shift-id': typeof AppmainShiftsShiftIdRoute
  '/surveys/$survey-id': typeof AppmainSurveysSurveyIdRoute
  '/surveys/create': typeof AppmainSurveysCreateRoute
  '/training/announcement': typeof AppmainTrainingAnnouncementRoute
  '/training/demo': typeof AppmainTrainingDemoRoute
  '/training/onboarding': typeof AppmainTrainingOnboardingRoute
  '/admin/accounts/$accountId': typeof AppAdminAccountsAccountIdRoute
  '/admin/agent-notes/$note-id': typeof AppAdminAgentNotesNoteIdRoute
  '/admin/agent-traces/$conversationId': typeof AppAdminAgentTracesConversationIdRoute
  '/admin/agent-traces/ephemeral': typeof AppAdminAgentTracesEphemeralRoute
  '/admin/agent/$runId': typeof AppAdminAgentRunIdRoute
  '/admin/agent/capabilities': typeof AppAdminAgentCapabilitiesRoute
  '/admin/agent/missing-tools': typeof AppAdminAgentMissingToolsRoute
  '/admin/agent/tool-telemetry': typeof AppAdminAgentToolTelemetryRoute
  '/admin/analytics/$slug': typeof AppAdminAnalyticsSlugRoute
  '/admin/calls/$callId': typeof AppAdminCallsCallIdRoute
  '/admin/care-coordinators/$care-coordinator-id': typeof AppAdminCareCoordinatorsCareCoordinatorIdRoute
  '/admin/caregivers/$caregiver-id': typeof AppAdminCaregiversCaregiverIdRoute
  '/admin/clients/$client-id': typeof AppAdminClientsClientIdRoute
  '/admin/organizations/$organization-id': typeof AppAdminOrganizationsOrganizationIdRoute
  '/admin/revenue/$account-id': typeof AppAdminRevenueAccountIdRoute
  '/admin/revenue/accounts': typeof AppAdminRevenueAccountsRoute
  '/admin/sales/agreements': typeof AppAdminSalesAgreementsRoute
  '/admin/sandbox/$organizationId': typeof AppAdminSandboxOrganizationIdRoute
  '/admin/shifts/$shift-id': typeof AppAdminShiftsShiftIdRoute
  '/admin/sms-engine-runs/$runId': typeof AppAdminSmsEngineRunsRunIdRoute
  '/admin/users/$user-id': typeof AppAdminUsersUserIdRoute
  '/admin/voice-config/$organization-id': typeof AppAdminVoiceConfigOrganizationIdRoute
  '/admin/voice-evals/cases': typeof AppAdminVoiceEvalsCasesRoute
  '/admin/voice-evals/catalog': typeof AppAdminVoiceEvalsCatalogRoute
  '/admin/voice-evals/compare': typeof AppAdminVoiceEvalsCompareRoute
  '/admin/voice-evals/compare-case': typeof AppAdminVoiceEvalsCompareCaseRoute
  '/admin/voice-playground/$call-id': typeof AppAdminVoicePlaygroundCallIdRoute
  '/admin/voice-qa/$callId': typeof AppAdminVoiceQaCallIdRoute
  '/admin/voice-qa/shadow-comparison': typeof AppAdminVoiceQaShadowComparisonRoute
  '/admin/voip/$organization-id': typeof AppAdminVoipOrganizationIdRoute
  '/settings/notifications/$channel': typeof AppSettingsNotificationsChannelRoute
  '/agent/': typeof AppagentAgentIndexRoute
  '/calendar/': typeof AppmainCalendarIndexRoute
  '/conversations/': typeof AppmainConversationsIndexRoute
  '/outreaches/': typeof AppmainOutreachesIndexRoute
  '/scheduled/': typeof AppmainScheduledIndexRoute
  '/shifts/': typeof AppmainShiftsIndexRoute
  '/surveys/': typeof AppmainSurveysIndexRoute
  '/training/': typeof AppmainTrainingIndexRoute
  '/admin/access-tokens/': typeof AppAdminAccessTokensIndexRoute
  '/admin/accounts/': typeof AppAdminAccountsIndexRoute
  '/admin/agent-notes/': typeof AppAdminAgentNotesIndexRoute
  '/admin/agent-traces/': typeof AppAdminAgentTracesIndexRoute
  '/admin/agent/': typeof AppAdminAgentIndexRoute
  '/admin/analytics/': typeof AppAdminAnalyticsIndexRoute
  '/admin/auto-callout-board/': typeof AppAdminAutoCalloutBoardIndexRoute
  '/admin/automations/': typeof AppAdminAutomationsIndexRoute
  '/admin/calls/': typeof AppAdminCallsIndexRoute
  '/admin/care-coordinators/': typeof AppAdminCareCoordinatorsIndexRoute
  '/admin/caregivers/': typeof AppAdminCaregiversIndexRoute
  '/admin/clients/': typeof AppAdminClientsIndexRoute
  '/admin/extension-lab/': typeof AppAdminExtensionLabIndexRoute
  '/admin/franchises/': typeof AppAdminFranchisesIndexRoute
  '/admin/org-distributions/': typeof AppAdminOrgDistributionsIndexRoute
  '/admin/organizations/': typeof AppAdminOrganizationsIndexRoute
  '/admin/outbox/': typeof AppAdminOutboxIndexRoute
  '/admin/recommendation-explorer/': typeof AppAdminRecommendationExplorerIndexRoute
  '/admin/revenue/': typeof AppAdminRevenueIndexRoute
  '/admin/sandbox/': typeof AppAdminSandboxIndexRoute
  '/admin/shifts/': typeof AppAdminShiftsIndexRoute
  '/admin/sms-engine-runs/': typeof AppAdminSmsEngineRunsIndexRoute
  '/admin/users/': typeof AppAdminUsersIndexRoute
  '/admin/voice-config/': typeof AppAdminVoiceConfigIndexRoute
  '/admin/voice-evals/': typeof AppAdminVoiceEvalsIndexRoute
  '/admin/voice-playground/': typeof AppAdminVoicePlaygroundIndexRoute
  '/admin/voice-qa/': typeof AppAdminVoiceQaIndexRoute
  '/admin/voip/': typeof AppAdminVoipIndexRoute
  '/settings/notifications/': typeof AppSettingsNotificationsIndexRoute
  '/agent/runs/$runId': typeof AppagentAgentRunsRunIdRoute
  '/outreaches/message/$message-id': typeof AppmainOutreachesMessageMessageIdRoute
  '/outreaches/message/create': typeof AppmainOutreachesMessageCreateRoute
  '/outreaches/survey/$survey-id': typeof AppmainOutreachesSurveySurveyIdRoute
  '/outreaches/survey/create': typeof AppmainOutreachesSurveyCreateRoute
  '/admin/agent-traces/run/$runId': typeof AppAdminAgentTracesRunRunIdRoute
  '/admin/agent/actions/$audit-id': typeof AppAdminAgentActionsAuditIdRoute
  '/admin/agent/automations/list': typeof AppAdminAgentAutomationsListRoute
  '/admin/agent/automations/runs': typeof AppAdminAgentAutomationsRunsRoute
  '/admin/agent/pages/$slug': typeof AppAdminAgentPagesSlugRoute
  '/admin/agent/scratchpad/$note-id': typeof AppAdminAgentScratchpadNoteIdRoute
  '/admin/automations/$organizationId/$automationId': typeof AppAdminAutomationsOrganizationIdAutomationIdRouteWithChildren
  '/admin/agent/actions/': typeof AppAdminAgentActionsIndexRoute
  '/admin/agent/automations/': typeof AppAdminAgentAutomationsIndexRoute
  '/admin/agent/pages/': typeof AppAdminAgentPagesIndexRoute
  '/admin/agent/scratchpad/': typeof AppAdminAgentScratchpadIndexRoute
  '/extension-review/calendar/php/unassigned': typeof AppmainExtensionReviewCalendarPhpUnassignedRoute
  '/admin/agent/automations/$organizationId/$automationId': typeof AppAdminAgentAutomationsOrganizationIdAutomationIdRouteWithChildren
  '/admin/automations/$organizationId/$automationId/': typeof AppAdminAutomationsOrganizationIdAutomationIdIndexRoute
  '/admin/voice-evals/runs/$runId/': typeof AppAdminVoiceEvalsRunsRunIdIndexRoute
  '/admin/agent/runs/$runId/artifacts/$artifactId': typeof AppAdminAgentRunsRunIdArtifactsArtifactIdRoute
  '/admin/automations/$organizationId/$automationId/runs/$automationRunId': typeof AppAdminAutomationsOrganizationIdAutomationIdRunsAutomationRunIdRoute
  '/admin/extension-lab/ehr/$provider/$entity/$externalId': typeof AppAdminExtensionLabEhrProviderEntityExternalIdRoute
  '/admin/voice-evals/runs/$runId/cases/$caseResultId': typeof AppAdminVoiceEvalsRunsRunIdCasesCaseResultIdRoute
  '/admin/agent/automations/$organizationId/$automationId/': typeof AppAdminAgentAutomationsOrganizationIdAutomationIdIndexRoute
  '/admin/agent/automations/$organizationId/$automationId/runs/$automationRunId': typeof AppAdminAgentAutomationsOrganizationIdAutomationIdRunsAutomationRunIdRoute
}
export interface FileRoutesByTo {
  '/': typeof AppmainIndexRoute
  '/phoebe-thinking-tips-mockup': typeof PhoebeThinkingTipsMockupRoute
  '/teach-phoebe-feedback-tags-mockup': typeof TeachPhoebeFeedbackTagsMockupRoute
  '/$organization-id/demo': typeof OrganizationIdDemoRoute
  '/accept-invitation': typeof AuthAcceptInvitationRoute
  '/change-password': typeof AuthChangePasswordRoute
  '/error': typeof AuthErrorRoute
  '/intro-call-booked': typeof AuthIntroCallBookedRoute
  '/reset-password': typeof AuthResetPasswordRoute
  '/sign-in': typeof AuthSignInRoute
  '/sign-out': typeof AuthSignOutRoute
  '/sign-up': typeof AuthSignUpRoute
  '/chrome-extension/privacy': typeof ChromeExtensionPrivacyRoute
  '/outreaches/phoebe-thinking-tips-mockup': typeof OutreachesPhoebeThinkingTipsMockupRoute
  '/r/$code': typeof RCodeRoute
  '/simulator-world/display': typeof SimulatorWorldDisplayRoute
  '/extension': typeof AppextensionExtensionRouteRoute
  '/extension-local': typeof AppextensionExtensionLocalRouteRoute
  '/activity': typeof AppmainActivityRoute
  '/activity-board': typeof AppmainActivityBoardRoute
  '/authorizations': typeof AppmainAuthorizationsRoute
  '/automations': typeof AppmainAutomationsRoute
  '/callouts': typeof AppmainCalloutsRoute
  '/caregivers': typeof AppmainCaregiversRoute
  '/clients': typeof AppmainClientsRoute
  '/coverage': typeof AppmainCoverageRoute
  '/dry-run-report': typeof AppmainDryRunReportRoute
  '/home': typeof AppmainHomeRoute
  '/leaderboard': typeof AppmainLeaderboardRoute
  '/learn-phoebe': typeof AppmainLearnPhoebeRoute
  '/metrics': typeof AppmainMetricsRoute
  '/phone': typeof AppmainPhoneRoute
  '/playbooks': typeof AppmainPlaybooksRoute
  '/referrals': typeof AppmainReferralsRoute
  '/teach-phoebe': typeof AppmainTeachPhoebeRoute
  '/voice-calls': typeof AppmainVoiceCallsRoute
  '/admin/agent-analysis': typeof AppAdminAgentAnalysisRoute
  '/admin/agent-tools': typeof AppAdminAgentToolsRoute
  '/admin/amd-shadow': typeof AppAdminAmdShadowRoute
  '/admin/care-plan-previewer': typeof AppAdminCarePlanPreviewerRoute
  '/admin/caregiver-sim': typeof AppAdminCaregiverSimRoute
  '/admin/data-quality': typeof AppAdminDataQualityRoute
  '/admin/data-sync': typeof AppAdminDataSyncRoute
  '/admin/demo-org': typeof AppAdminDemoOrgRoute
  '/admin/design-kit': typeof AppAdminDesignKitRoute
  '/admin/document-ingestion': typeof AppAdminDocumentIngestionRoute
  '/admin/flags': typeof AppAdminFlagsRoute
  '/admin/imessage': typeof AppAdminImessageRoute
  '/admin/imessage-requests': typeof AppAdminImessageRequestsRoute
  '/admin/message-queue': typeof AppAdminMessageQueueRoute
  '/admin/notifications-lab': typeof AppAdminNotificationsLabRoute
  '/admin/org-snapshots': typeof AppAdminOrgSnapshotsRoute
  '/admin/organization-default-settings': typeof AppAdminOrganizationDefaultSettingsRoute
  '/admin/outreach-observability': typeof AppAdminOutreachObservabilityRoute
  '/admin/outreaches': typeof AppAdminOutreachesRoute
  '/admin/prompt-rollout': typeof AppAdminPromptRolloutRoute
  '/admin/quality-scoreboard': typeof AppAdminQualityScoreboardRoute
  '/admin/report-generator': typeof AppAdminReportGeneratorRoute
  '/admin/search': typeof AppAdminSearchRoute
  '/admin/shift-assignment-health': typeof AppAdminShiftAssignmentHealthRoute
  '/admin/simulator-world': typeof AppAdminSimulatorWorldRoute
  '/admin/sms-debug': typeof AppAdminSmsDebugRoute
  '/admin/sync-settings': typeof AppAdminSyncSettingsRoute
  '/admin/tag-matching': typeof AppAdminTagMatchingRoute
  '/admin/tam-map': typeof AppAdminTamMapRoute
  '/admin/ui-components': typeof AppAdminUiComponentsRoute
  '/admin/voice': typeof AppAdminVoiceRoute
  '/admin/voice-latency': typeof AppAdminVoiceLatencyRoute
  '/internal/agreements': typeof AppInternalAgreementsRoute
  '/settings/activity-feed': typeof AppSettingsActivityFeedRoute
  '/settings/agency-context': typeof AppSettingsAgencyContextRoute
  '/settings/agent-rules': typeof AppSettingsAgentRulesRoute
  '/settings/agent-skills': typeof AppSettingsAgentSkillsRoute
  '/settings/auto-assign': typeof AppSettingsAutoAssignRoute
  '/settings/auto-draft': typeof AppSettingsAutoDraftRoute
  '/settings/auto-reply-settings': typeof AppSettingsAutoReplySettingsRoute
  '/settings/auto-send': typeof AppSettingsAutoSendRoute
  '/settings/automation-schedule': typeof AppSettingsAutomationScheduleRoute
  '/settings/automations': typeof AppSettingsAutomationsRoute
  '/settings/call-routing': typeof AppSettingsCallRoutingRoute
  '/settings/call-templates': typeof AppSettingsCallTemplatesRoute
  '/settings/cancellations': typeof AppSettingsCancellationsRoute
  '/settings/care-coordinators': typeof AppSettingsCareCoordinatorsRoute
  '/settings/caregiver-engagement': typeof AppSettingsCaregiverEngagementRoute
  '/settings/caregiver-tags': typeof AppSettingsCaregiverTagsRoute
  '/settings/change-history': typeof AppSettingsChangeHistoryRoute
  '/settings/chrome-extension': typeof AppSettingsChromeExtensionRoute
  '/settings/clock-in-out': typeof AppSettingsClockInOutRoute
  '/settings/clock-in-templates': typeof AppSettingsClockInTemplatesRoute
  '/settings/configurations': typeof AppSettingsConfigurationsRoute
  '/settings/confirmation-messages': typeof AppSettingsConfirmationMessagesRoute
  '/settings/daily-digest': typeof AppSettingsDailyDigestRoute
  '/settings/data-sync': typeof AppSettingsDataSyncRoute
  '/settings/early-access': typeof AppSettingsEarlyAccessRoute
  '/settings/help-center': typeof AppSettingsHelpCenterRoute
  '/settings/off-hours': typeof AppSettingsOffHoursRoute
  '/settings/offices': typeof AppSettingsOfficesRoute
  '/settings/open-shift-responses': typeof AppSettingsOpenShiftResponsesRoute
  '/settings/other-templates': typeof AppSettingsOtherTemplatesRoute
  '/settings/outreach-automation': typeof AppSettingsOutreachAutomationRoute
  '/settings/outreach-templates': typeof AppSettingsOutreachTemplatesRoute
  '/settings/phoebe': typeof AppSettingsPhoebeRoute
  '/settings/phone': typeof AppSettingsPhoneRoute
  '/settings/phone-instructions': typeof AppSettingsPhoneInstructionsRoute
  '/settings/phone-numbers': typeof AppSettingsPhoneNumbersRoute
  '/settings/phone-try': typeof AppSettingsPhoneTryRoute
  '/settings/quiet-hours': typeof AppSettingsQuietHoursRoute
  '/settings/recommendations': typeof AppSettingsRecommendationsRoute
  '/settings/shift-confirmation-skip-allow-lists': typeof AppSettingsShiftConfirmationSkipAllowListsRoute
  '/settings/shift-confirmations': typeof AppSettingsShiftConfirmationsRoute
  '/settings/skip-allow-lists': typeof AppSettingsSkipAllowListsRoute
  '/settings/slack': typeof AppSettingsSlackRoute
  '/settings/tag-matching': typeof AppSettingsTagMatchingRoute
  '/settings/team-coverage': typeof AppSettingsTeamCoverageRoute
  '/settings/team-members': typeof AppSettingsTeamMembersRoute
  '/settings/test-mode': typeof AppSettingsTestModeRoute
  '/slack/link': typeof AppSlackLinkRoute
  '/admin': typeof AppAdminIndexRoute
  '/settings': typeof AppSettingsIndexRoute
  '/outreaches/$callout-id': typeof AppmainOutreachesCalloutIdRoute
  '/shifts/$shift-id': typeof AppmainShiftsShiftIdRoute
  '/surveys/$survey-id': typeof AppmainSurveysSurveyIdRoute
  '/surveys/create': typeof AppmainSurveysCreateRoute
  '/training/announcement': typeof AppmainTrainingAnnouncementRoute
  '/training/demo': typeof AppmainTrainingDemoRoute
  '/training/onboarding': typeof AppmainTrainingOnboardingRoute
  '/admin/accounts/$accountId': typeof AppAdminAccountsAccountIdRoute
  '/admin/agent-notes/$note-id': typeof AppAdminAgentNotesNoteIdRoute
  '/admin/agent-traces/$conversationId': typeof AppAdminAgentTracesConversationIdRoute
  '/admin/agent-traces/ephemeral': typeof AppAdminAgentTracesEphemeralRoute
  '/admin/agent/$runId': typeof AppAdminAgentRunIdRoute
  '/admin/agent/capabilities': typeof AppAdminAgentCapabilitiesRoute
  '/admin/agent/missing-tools': typeof AppAdminAgentMissingToolsRoute
  '/admin/agent/tool-telemetry': typeof AppAdminAgentToolTelemetryRoute
  '/admin/analytics/$slug': typeof AppAdminAnalyticsSlugRoute
  '/admin/calls/$callId': typeof AppAdminCallsCallIdRoute
  '/admin/care-coordinators/$care-coordinator-id': typeof AppAdminCareCoordinatorsCareCoordinatorIdRoute
  '/admin/caregivers/$caregiver-id': typeof AppAdminCaregiversCaregiverIdRoute
  '/admin/clients/$client-id': typeof AppAdminClientsClientIdRoute
  '/admin/organizations/$organization-id': typeof AppAdminOrganizationsOrganizationIdRoute
  '/admin/revenue/$account-id': typeof AppAdminRevenueAccountIdRoute
  '/admin/revenue/accounts': typeof AppAdminRevenueAccountsRoute
  '/admin/sales/agreements': typeof AppAdminSalesAgreementsRoute
  '/admin/sandbox/$organizationId': typeof AppAdminSandboxOrganizationIdRoute
  '/admin/shifts/$shift-id': typeof AppAdminShiftsShiftIdRoute
  '/admin/sms-engine-runs/$runId': typeof AppAdminSmsEngineRunsRunIdRoute
  '/admin/users/$user-id': typeof AppAdminUsersUserIdRoute
  '/admin/voice-config/$organization-id': typeof AppAdminVoiceConfigOrganizationIdRoute
  '/admin/voice-evals/cases': typeof AppAdminVoiceEvalsCasesRoute
  '/admin/voice-evals/catalog': typeof AppAdminVoiceEvalsCatalogRoute
  '/admin/voice-evals/compare': typeof AppAdminVoiceEvalsCompareRoute
  '/admin/voice-evals/compare-case': typeof AppAdminVoiceEvalsCompareCaseRoute
  '/admin/voice-playground/$call-id': typeof AppAdminVoicePlaygroundCallIdRoute
  '/admin/voice-qa/$callId': typeof AppAdminVoiceQaCallIdRoute
  '/admin/voice-qa/shadow-comparison': typeof AppAdminVoiceQaShadowComparisonRoute
  '/admin/voip/$organization-id': typeof AppAdminVoipOrganizationIdRoute
  '/settings/notifications/$channel': typeof AppSettingsNotificationsChannelRoute
  '/agent': typeof AppagentAgentIndexRoute
  '/calendar': typeof AppmainCalendarIndexRoute
  '/conversations': typeof AppmainConversationsIndexRoute
  '/outreaches': typeof AppmainOutreachesIndexRoute
  '/scheduled': typeof AppmainScheduledIndexRoute
  '/shifts': typeof AppmainShiftsIndexRoute
  '/surveys': typeof AppmainSurveysIndexRoute
  '/training': typeof AppmainTrainingIndexRoute
  '/admin/access-tokens': typeof AppAdminAccessTokensIndexRoute
  '/admin/accounts': typeof AppAdminAccountsIndexRoute
  '/admin/agent-notes': typeof AppAdminAgentNotesIndexRoute
  '/admin/agent-traces': typeof AppAdminAgentTracesIndexRoute
  '/admin/agent': typeof AppAdminAgentIndexRoute
  '/admin/analytics': typeof AppAdminAnalyticsIndexRoute
  '/admin/auto-callout-board': typeof AppAdminAutoCalloutBoardIndexRoute
  '/admin/automations': typeof AppAdminAutomationsIndexRoute
  '/admin/calls': typeof AppAdminCallsIndexRoute
  '/admin/care-coordinators': typeof AppAdminCareCoordinatorsIndexRoute
  '/admin/caregivers': typeof AppAdminCaregiversIndexRoute
  '/admin/clients': typeof AppAdminClientsIndexRoute
  '/admin/extension-lab': typeof AppAdminExtensionLabIndexRoute
  '/admin/franchises': typeof AppAdminFranchisesIndexRoute
  '/admin/org-distributions': typeof AppAdminOrgDistributionsIndexRoute
  '/admin/organizations': typeof AppAdminOrganizationsIndexRoute
  '/admin/outbox': typeof AppAdminOutboxIndexRoute
  '/admin/recommendation-explorer': typeof AppAdminRecommendationExplorerIndexRoute
  '/admin/revenue': typeof AppAdminRevenueIndexRoute
  '/admin/sandbox': typeof AppAdminSandboxIndexRoute
  '/admin/shifts': typeof AppAdminShiftsIndexRoute
  '/admin/sms-engine-runs': typeof AppAdminSmsEngineRunsIndexRoute
  '/admin/users': typeof AppAdminUsersIndexRoute
  '/admin/voice-config': typeof AppAdminVoiceConfigIndexRoute
  '/admin/voice-evals': typeof AppAdminVoiceEvalsIndexRoute
  '/admin/voice-playground': typeof AppAdminVoicePlaygroundIndexRoute
  '/admin/voice-qa': typeof AppAdminVoiceQaIndexRoute
  '/admin/voip': typeof AppAdminVoipIndexRoute
  '/settings/notifications': typeof AppSettingsNotificationsIndexRoute
  '/agent/runs/$runId': typeof AppagentAgentRunsRunIdRoute
  '/outreaches/message/$message-id': typeof AppmainOutreachesMessageMessageIdRoute
  '/outreaches/message/create': typeof AppmainOutreachesMessageCreateRoute
  '/outreaches/survey/$survey-id': typeof AppmainOutreachesSurveySurveyIdRoute
  '/outreaches/survey/create': typeof AppmainOutreachesSurveyCreateRoute
  '/admin/agent-traces/run/$runId': typeof AppAdminAgentTracesRunRunIdRoute
  '/admin/agent/actions/$audit-id': typeof AppAdminAgentActionsAuditIdRoute
  '/admin/agent/automations/list': typeof AppAdminAgentAutomationsListRoute
  '/admin/agent/automations/runs': typeof AppAdminAgentAutomationsRunsRoute
  '/admin/agent/pages/$slug': typeof AppAdminAgentPagesSlugRoute
  '/admin/agent/scratchpad/$note-id': typeof AppAdminAgentScratchpadNoteIdRoute
  '/admin/agent/actions': typeof AppAdminAgentActionsIndexRoute
  '/admin/agent/automations': typeof AppAdminAgentAutomationsIndexRoute
  '/admin/agent/pages': typeof AppAdminAgentPagesIndexRoute
  '/admin/agent/scratchpad': typeof AppAdminAgentScratchpadIndexRoute
  '/extension-review/calendar/php/unassigned': typeof AppmainExtensionReviewCalendarPhpUnassignedRoute
  '/admin/automations/$organizationId/$automationId': typeof AppAdminAutomationsOrganizationIdAutomationIdIndexRoute
  '/admin/voice-evals/runs/$runId': typeof AppAdminVoiceEvalsRunsRunIdIndexRoute
  '/admin/agent/runs/$runId/artifacts/$artifactId': typeof AppAdminAgentRunsRunIdArtifactsArtifactIdRoute
  '/admin/automations/$organizationId/$automationId/runs/$automationRunId': typeof AppAdminAutomationsOrganizationIdAutomationIdRunsAutomationRunIdRoute
  '/admin/extension-lab/ehr/$provider/$entity/$externalId': typeof AppAdminExtensionLabEhrProviderEntityExternalIdRoute
  '/admin/voice-evals/runs/$runId/cases/$caseResultId': typeof AppAdminVoiceEvalsRunsRunIdCasesCaseResultIdRoute
  '/admin/agent/automations/$organizationId/$automationId': typeof AppAdminAgentAutomationsOrganizationIdAutomationIdIndexRoute
  '/admin/agent/automations/$organizationId/$automationId/runs/$automationRunId': typeof AppAdminAgentAutomationsOrganizationIdAutomationIdRunsAutomationRunIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteRouteWithChildren
  '/_auth': typeof AuthRouteRouteWithChildren
  '/phoebe-thinking-tips-mockup': typeof PhoebeThinkingTipsMockupRoute
  '/teach-phoebe-feedback-tags-mockup': typeof TeachPhoebeFeedbackTagsMockupRoute
  '/_app/(agent)': typeof AppagentRouteRouteWithChildren
  '/_app/(extension)': typeof AppextensionRouteRouteWithChildren
  '/_app/(main)': typeof AppmainRouteRouteWithChildren
  '/_app/admin': typeof AppAdminRouteRouteWithChildren
  '/_app/settings': typeof AppSettingsRouteRouteWithChildren
  '/$organization-id/demo': typeof OrganizationIdDemoRoute
  '/_auth/accept-invitation': typeof AuthAcceptInvitationRoute
  '/_auth/change-password': typeof AuthChangePasswordRoute
  '/_auth/error': typeof AuthErrorRoute
  '/_auth/intro-call-booked': typeof AuthIntroCallBookedRoute
  '/_auth/reset-password': typeof AuthResetPasswordRoute
  '/_auth/sign-in': typeof AuthSignInRoute
  '/_auth/sign-out': typeof AuthSignOutRoute
  '/_auth/sign-up': typeof AuthSignUpRoute
  '/chrome-extension/privacy': typeof ChromeExtensionPrivacyRoute
  '/outreaches/phoebe-thinking-tips-mockup': typeof OutreachesPhoebeThinkingTipsMockupRoute
  '/r/$code': typeof RCodeRoute
  '/simulator-world/display': typeof SimulatorWorldDisplayRoute
  '/_app/(extension)/extension': typeof AppextensionExtensionRouteRoute
  '/_app/(extension)/extension-local': typeof AppextensionExtensionLocalRouteRoute
  '/_app/admin/extension-lab': typeof AppAdminExtensionLabRouteRouteWithChildren
  '/_app/settings/notifications': typeof AppSettingsNotificationsRouteRouteWithChildren
  '/_app/(agent)/agent': typeof AppagentAgentRouteWithChildren
  '/_app/(main)/activity': typeof AppmainActivityRoute
  '/_app/(main)/activity-board': typeof AppmainActivityBoardRoute
  '/_app/(main)/authorizations': typeof AppmainAuthorizationsRoute
  '/_app/(main)/automations': typeof AppmainAutomationsRoute
  '/_app/(main)/callouts': typeof AppmainCalloutsRoute
  '/_app/(main)/caregivers': typeof AppmainCaregiversRoute
  '/_app/(main)/clients': typeof AppmainClientsRoute
  '/_app/(main)/coverage': typeof AppmainCoverageRoute
  '/_app/(main)/dry-run-report': typeof AppmainDryRunReportRoute
  '/_app/(main)/home': typeof AppmainHomeRoute
  '/_app/(main)/leaderboard': typeof AppmainLeaderboardRoute
  '/_app/(main)/learn-phoebe': typeof AppmainLearnPhoebeRoute
  '/_app/(main)/metrics': typeof AppmainMetricsRoute
  '/_app/(main)/phone': typeof AppmainPhoneRoute
  '/_app/(main)/playbooks': typeof AppmainPlaybooksRoute
  '/_app/(main)/referrals': typeof AppmainReferralsRoute
  '/_app/(main)/teach-phoebe': typeof AppmainTeachPhoebeRoute
  '/_app/(main)/training': typeof AppmainTrainingRouteWithChildren
  '/_app/(main)/voice-calls': typeof AppmainVoiceCallsRoute
  '/_app/admin/agent-analysis': typeof AppAdminAgentAnalysisRoute
  '/_app/admin/agent-tools': typeof AppAdminAgentToolsRoute
  '/_app/admin/amd-shadow': typeof AppAdminAmdShadowRoute
  '/_app/admin/care-plan-previewer': typeof AppAdminCarePlanPreviewerRoute
  '/_app/admin/caregiver-sim': typeof AppAdminCaregiverSimRoute
  '/_app/admin/data-quality': typeof AppAdminDataQualityRoute
  '/_app/admin/data-sync': typeof AppAdminDataSyncRoute
  '/_app/admin/demo-org': typeof AppAdminDemoOrgRoute
  '/_app/admin/design-kit': typeof AppAdminDesignKitRoute
  '/_app/admin/document-ingestion': typeof AppAdminDocumentIngestionRoute
  '/_app/admin/flags': typeof AppAdminFlagsRoute
  '/_app/admin/imessage': typeof AppAdminImessageRoute
  '/_app/admin/imessage-requests': typeof AppAdminImessageRequestsRoute
  '/_app/admin/message-queue': typeof AppAdminMessageQueueRoute
  '/_app/admin/notifications-lab': typeof AppAdminNotificationsLabRoute
  '/_app/admin/org-snapshots': typeof AppAdminOrgSnapshotsRoute
  '/_app/admin/organization-default-settings': typeof AppAdminOrganizationDefaultSettingsRoute
  '/_app/admin/outreach-observability': typeof AppAdminOutreachObservabilityRoute
  '/_app/admin/outreaches': typeof AppAdminOutreachesRoute
  '/_app/admin/prompt-rollout': typeof AppAdminPromptRolloutRoute
  '/_app/admin/quality-scoreboard': typeof AppAdminQualityScoreboardRoute
  '/_app/admin/report-generator': typeof AppAdminReportGeneratorRoute
  '/_app/admin/search': typeof AppAdminSearchRoute
  '/_app/admin/shift-assignment-health': typeof AppAdminShiftAssignmentHealthRoute
  '/_app/admin/simulator-world': typeof AppAdminSimulatorWorldRoute
  '/_app/admin/sms-debug': typeof AppAdminSmsDebugRoute
  '/_app/admin/sync-settings': typeof AppAdminSyncSettingsRoute
  '/_app/admin/tag-matching': typeof AppAdminTagMatchingRoute
  '/_app/admin/tam-map': typeof AppAdminTamMapRoute
  '/_app/admin/ui-components': typeof AppAdminUiComponentsRoute
  '/_app/admin/voice': typeof AppAdminVoiceRoute
  '/_app/admin/voice-latency': typeof AppAdminVoiceLatencyRoute
  '/_app/internal/agreements': typeof AppInternalAgreementsRoute
  '/_app/settings/activity-feed': typeof AppSettingsActivityFeedRoute
  '/_app/settings/agency-context': typeof AppSettingsAgencyContextRoute
  '/_app/settings/agent-rules': typeof AppSettingsAgentRulesRoute
  '/_app/settings/agent-skills': typeof AppSettingsAgentSkillsRoute
  '/_app/settings/auto-assign': typeof AppSettingsAutoAssignRoute
  '/_app/settings/auto-draft': typeof AppSettingsAutoDraftRoute
  '/_app/settings/auto-reply-settings': typeof AppSettingsAutoReplySettingsRoute
  '/_app/settings/auto-send': typeof AppSettingsAutoSendRoute
  '/_app/settings/automation-schedule': typeof AppSettingsAutomationScheduleRoute
  '/_app/settings/automations': typeof AppSettingsAutomationsRoute
  '/_app/settings/call-routing': typeof AppSettingsCallRoutingRoute
  '/_app/settings/call-templates': typeof AppSettingsCallTemplatesRoute
  '/_app/settings/cancellations': typeof AppSettingsCancellationsRoute
  '/_app/settings/care-coordinators': typeof AppSettingsCareCoordinatorsRoute
  '/_app/settings/caregiver-engagement': typeof AppSettingsCaregiverEngagementRoute
  '/_app/settings/caregiver-tags': typeof AppSettingsCaregiverTagsRoute
  '/_app/settings/change-history': typeof AppSettingsChangeHistoryRoute
  '/_app/settings/chrome-extension': typeof AppSettingsChromeExtensionRoute
  '/_app/settings/clock-in-out': typeof AppSettingsClockInOutRoute
  '/_app/settings/clock-in-templates': typeof AppSettingsClockInTemplatesRoute
  '/_app/settings/configurations': typeof AppSettingsConfigurationsRoute
  '/_app/settings/confirmation-messages': typeof AppSettingsConfirmationMessagesRoute
  '/_app/settings/daily-digest': typeof AppSettingsDailyDigestRoute
  '/_app/settings/data-sync': typeof AppSettingsDataSyncRoute
  '/_app/settings/early-access': typeof AppSettingsEarlyAccessRoute
  '/_app/settings/help-center': typeof AppSettingsHelpCenterRoute
  '/_app/settings/off-hours': typeof AppSettingsOffHoursRoute
  '/_app/settings/offices': typeof AppSettingsOfficesRoute
  '/_app/settings/open-shift-responses': typeof AppSettingsOpenShiftResponsesRoute
  '/_app/settings/other-templates': typeof AppSettingsOtherTemplatesRoute
  '/_app/settings/outreach-automation': typeof AppSettingsOutreachAutomationRoute
  '/_app/settings/outreach-templates': typeof AppSettingsOutreachTemplatesRoute
  '/_app/settings/phoebe': typeof AppSettingsPhoebeRoute
  '/_app/settings/phone': typeof AppSettingsPhoneRoute
  '/_app/settings/phone-instructions': typeof AppSettingsPhoneInstructionsRoute
  '/_app/settings/phone-numbers': typeof AppSettingsPhoneNumbersRoute
  '/_app/settings/phone-try': typeof AppSettingsPhoneTryRoute
  '/_app/settings/quiet-hours': typeof AppSettingsQuietHoursRoute
  '/_app/settings/recommendations': typeof AppSettingsRecommendationsRoute
  '/_app/settings/shift-confirmation-skip-allow-lists': typeof AppSettingsShiftConfirmationSkipAllowListsRoute
  '/_app/settings/shift-confirmations': typeof AppSettingsShiftConfirmationsRoute
  '/_app/settings/skip-allow-lists': typeof AppSettingsSkipAllowListsRoute
  '/_app/settings/slack': typeof AppSettingsSlackRoute
  '/_app/settings/tag-matching': typeof AppSettingsTagMatchingRoute
  '/_app/settings/team-coverage': typeof AppSettingsTeamCoverageRoute
  '/_app/settings/team-members': typeof AppSettingsTeamMembersRoute
  '/_app/settings/test-mode': typeof AppSettingsTestModeRoute
  '/_app/slack/link': typeof AppSlackLinkRoute
  '/_app/(main)/': typeof AppmainIndexRoute
  '/_app/admin/': typeof AppAdminIndexRoute
  '/_app/settings/': typeof AppSettingsIndexRoute
  '/_app/(main)/outreaches/$callout-id': typeof AppmainOutreachesCalloutIdRoute
  '/_app/(main)/shifts/$shift-id': typeof AppmainShiftsShiftIdRoute
  '/_app/(main)/surveys/$survey-id': typeof AppmainSurveysSurveyIdRoute
  '/_app/(main)/surveys/create': typeof AppmainSurveysCreateRoute
  '/_app/(main)/training/announcement': typeof AppmainTrainingAnnouncementRoute
  '/_app/(main)/training/demo': typeof AppmainTrainingDemoRoute
  '/_app/(main)/training/onboarding': typeof AppmainTrainingOnboardingRoute
  '/_app/admin/accounts/$accountId': typeof AppAdminAccountsAccountIdRoute
  '/_app/admin/agent-notes/$note-id': typeof AppAdminAgentNotesNoteIdRoute
  '/_app/admin/agent-traces/$conversationId': typeof AppAdminAgentTracesConversationIdRoute
  '/_app/admin/agent-traces/ephemeral': typeof AppAdminAgentTracesEphemeralRoute
  '/_app/admin/agent/$runId': typeof AppAdminAgentRunIdRoute
  '/_app/admin/agent/capabilities': typeof AppAdminAgentCapabilitiesRoute
  '/_app/admin/agent/missing-tools': typeof AppAdminAgentMissingToolsRoute
  '/_app/admin/agent/tool-telemetry': typeof AppAdminAgentToolTelemetryRoute
  '/_app/admin/analytics/$slug': typeof AppAdminAnalyticsSlugRoute
  '/_app/admin/calls/$callId': typeof AppAdminCallsCallIdRoute
  '/_app/admin/care-coordinators/$care-coordinator-id': typeof AppAdminCareCoordinatorsCareCoordinatorIdRoute
  '/_app/admin/caregivers/$caregiver-id': typeof AppAdminCaregiversCaregiverIdRoute
  '/_app/admin/clients/$client-id': typeof AppAdminClientsClientIdRoute
  '/_app/admin/organizations/$organization-id': typeof AppAdminOrganizationsOrganizationIdRoute
  '/_app/admin/revenue/$account-id': typeof AppAdminRevenueAccountIdRoute
  '/_app/admin/revenue/accounts': typeof AppAdminRevenueAccountsRoute
  '/_app/admin/sales/agreements': typeof AppAdminSalesAgreementsRoute
  '/_app/admin/sandbox/$organizationId': typeof AppAdminSandboxOrganizationIdRoute
  '/_app/admin/shifts/$shift-id': typeof AppAdminShiftsShiftIdRoute
  '/_app/admin/sms-engine-runs/$runId': typeof AppAdminSmsEngineRunsRunIdRoute
  '/_app/admin/users/$user-id': typeof AppAdminUsersUserIdRoute
  '/_app/admin/voice-config/$organization-id': typeof AppAdminVoiceConfigOrganizationIdRoute
  '/_app/admin/voice-evals/cases': typeof AppAdminVoiceEvalsCasesRoute
  '/_app/admin/voice-evals/catalog': typeof AppAdminVoiceEvalsCatalogRoute
  '/_app/admin/voice-evals/compare': typeof AppAdminVoiceEvalsCompareRoute
  '/_app/admin/voice-evals/compare-case': typeof AppAdminVoiceEvalsCompareCaseRoute
  '/_app/admin/voice-playground/$call-id': typeof AppAdminVoicePlaygroundCallIdRoute
  '/_app/admin/voice-qa/$callId': typeof AppAdminVoiceQaCallIdRoute
  '/_app/admin/voice-qa/shadow-comparison': typeof AppAdminVoiceQaShadowComparisonRoute
  '/_app/admin/voip/$organization-id': typeof AppAdminVoipOrganizationIdRoute
  '/_app/settings/notifications/$channel': typeof AppSettingsNotificationsChannelRoute
  '/_app/(agent)/agent/': typeof AppagentAgentIndexRoute
  '/_app/(main)/calendar/': typeof AppmainCalendarIndexRoute
  '/_app/(main)/conversations/': typeof AppmainConversationsIndexRoute
  '/_app/(main)/outreaches/': typeof AppmainOutreachesIndexRoute
  '/_app/(main)/scheduled/': typeof AppmainScheduledIndexRoute
  '/_app/(main)/shifts/': typeof AppmainShiftsIndexRoute
  '/_app/(main)/surveys/': typeof AppmainSurveysIndexRoute
  '/_app/(main)/training/': typeof AppmainTrainingIndexRoute
  '/_app/admin/access-tokens/': typeof AppAdminAccessTokensIndexRoute
  '/_app/admin/accounts/': typeof AppAdminAccountsIndexRoute
  '/_app/admin/agent-notes/': typeof AppAdminAgentNotesIndexRoute
  '/_app/admin/agent-traces/': typeof AppAdminAgentTracesIndexRoute
  '/_app/admin/agent/': typeof AppAdminAgentIndexRoute
  '/_app/admin/analytics/': typeof AppAdminAnalyticsIndexRoute
  '/_app/admin/auto-callout-board/': typeof AppAdminAutoCalloutBoardIndexRoute
  '/_app/admin/automations/': typeof AppAdminAutomationsIndexRoute
  '/_app/admin/calls/': typeof AppAdminCallsIndexRoute
  '/_app/admin/care-coordinators/': typeof AppAdminCareCoordinatorsIndexRoute
  '/_app/admin/caregivers/': typeof AppAdminCaregiversIndexRoute
  '/_app/admin/clients/': typeof AppAdminClientsIndexRoute
  '/_app/admin/extension-lab/': typeof AppAdminExtensionLabIndexRoute
  '/_app/admin/franchises/': typeof AppAdminFranchisesIndexRoute
  '/_app/admin/org-distributions/': typeof AppAdminOrgDistributionsIndexRoute
  '/_app/admin/organizations/': typeof AppAdminOrganizationsIndexRoute
  '/_app/admin/outbox/': typeof AppAdminOutboxIndexRoute
  '/_app/admin/recommendation-explorer/': typeof AppAdminRecommendationExplorerIndexRoute
  '/_app/admin/revenue/': typeof AppAdminRevenueIndexRoute
  '/_app/admin/sandbox/': typeof AppAdminSandboxIndexRoute
  '/_app/admin/shifts/': typeof AppAdminShiftsIndexRoute
  '/_app/admin/sms-engine-runs/': typeof AppAdminSmsEngineRunsIndexRoute
  '/_app/admin/users/': typeof AppAdminUsersIndexRoute
  '/_app/admin/voice-config/': typeof AppAdminVoiceConfigIndexRoute
  '/_app/admin/voice-evals/': typeof AppAdminVoiceEvalsIndexRoute
  '/_app/admin/voice-playground/': typeof AppAdminVoicePlaygroundIndexRoute
  '/_app/admin/voice-qa/': typeof AppAdminVoiceQaIndexRoute
  '/_app/admin/voip/': typeof AppAdminVoipIndexRoute
  '/_app/settings/notifications/': typeof AppSettingsNotificationsIndexRoute
  '/_app/(agent)/agent/runs/$runId': typeof AppagentAgentRunsRunIdRoute
  '/_app/(main)/outreaches/message/$message-id': typeof AppmainOutreachesMessageMessageIdRoute
  '/_app/(main)/outreaches/message/create': typeof AppmainOutreachesMessageCreateRoute
  '/_app/(main)/outreaches/survey/$survey-id': typeof AppmainOutreachesSurveySurveyIdRoute
  '/_app/(main)/outreaches/survey/create': typeof AppmainOutreachesSurveyCreateRoute
  '/_app/admin/agent-traces/run/$runId': typeof AppAdminAgentTracesRunRunIdRoute
  '/_app/admin/agent/actions/$audit-id': typeof AppAdminAgentActionsAuditIdRoute
  '/_app/admin/agent/automations/list': typeof AppAdminAgentAutomationsListRoute
  '/_app/admin/agent/automations/runs': typeof AppAdminAgentAutomationsRunsRoute
  '/_app/admin/agent/pages/$slug': typeof AppAdminAgentPagesSlugRoute
  '/_app/admin/agent/scratchpad/$note-id': typeof AppAdminAgentScratchpadNoteIdRoute
  '/_app/admin/automations/$organizationId/$automationId': typeof AppAdminAutomationsOrganizationIdAutomationIdRouteWithChildren
  '/_app/admin/agent/actions/': typeof AppAdminAgentActionsIndexRoute
  '/_app/admin/agent/automations/': typeof AppAdminAgentAutomationsIndexRoute
  '/_app/admin/agent/pages/': typeof AppAdminAgentPagesIndexRoute
  '/_app/admin/agent/scratchpad/': typeof AppAdminAgentScratchpadIndexRoute
  '/_app/(main)/extension-review/calendar/php/unassigned': typeof AppmainExtensionReviewCalendarPhpUnassignedRoute
  '/_app/admin/agent/automations/$organizationId/$automationId': typeof AppAdminAgentAutomationsOrganizationIdAutomationIdRouteWithChildren
  '/_app/admin/automations/$organizationId/$automationId/': typeof AppAdminAutomationsOrganizationIdAutomationIdIndexRoute
  '/_app/admin/voice-evals/runs/$runId/': typeof AppAdminVoiceEvalsRunsRunIdIndexRoute
  '/_app/admin/agent/runs/$runId/artifacts/$artifactId': typeof AppAdminAgentRunsRunIdArtifactsArtifactIdRoute
  '/_app/admin/automations/$organizationId/$automationId/runs/$automationRunId': typeof AppAdminAutomationsOrganizationIdAutomationIdRunsAutomationRunIdRoute
  '/_app/admin/extension-lab/ehr/$provider/$entity/$externalId': typeof AppAdminExtensionLabEhrProviderEntityExternalIdRoute
  '/_app/admin/voice-evals/runs/$runId/cases/$caseResultId': typeof AppAdminVoiceEvalsRunsRunIdCasesCaseResultIdRoute
  '/_app/admin/agent/automations/$organizationId/$automationId/': typeof AppAdminAgentAutomationsOrganizationIdAutomationIdIndexRoute
  '/_app/admin/agent/automations/$organizationId/$automationId/runs/$automationRunId': typeof AppAdminAgentAutomationsOrganizationIdAutomationIdRunsAutomationRunIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/phoebe-thinking-tips-mockup'
    | '/teach-phoebe-feedback-tags-mockup'
    | '/admin'
    | '/settings'
    | '/$organization-id/demo'
    | '/accept-invitation'
    | '/change-password'
    | '/error'
    | '/intro-call-booked'
    | '/reset-password'
    | '/sign-in'
    | '/sign-out'
    | '/sign-up'
    | '/chrome-extension/privacy'
    | '/outreaches/phoebe-thinking-tips-mockup'
    | '/r/$code'
    | '/simulator-world/display'
    | '/extension'
    | '/extension-local'
    | '/admin/extension-lab'
    | '/settings/notifications'
    | '/agent'
    | '/activity'
    | '/activity-board'
    | '/authorizations'
    | '/automations'
    | '/callouts'
    | '/caregivers'
    | '/clients'
    | '/coverage'
    | '/dry-run-report'
    | '/home'
    | '/leaderboard'
    | '/learn-phoebe'
    | '/metrics'
    | '/phone'
    | '/playbooks'
    | '/referrals'
    | '/teach-phoebe'
    | '/training'
    | '/voice-calls'
    | '/admin/agent-analysis'
    | '/admin/agent-tools'
    | '/admin/amd-shadow'
    | '/admin/care-plan-previewer'
    | '/admin/caregiver-sim'
    | '/admin/data-quality'
    | '/admin/data-sync'
    | '/admin/demo-org'
    | '/admin/design-kit'
    | '/admin/document-ingestion'
    | '/admin/flags'
    | '/admin/imessage'
    | '/admin/imessage-requests'
    | '/admin/message-queue'
    | '/admin/notifications-lab'
    | '/admin/org-snapshots'
    | '/admin/organization-default-settings'
    | '/admin/outreach-observability'
    | '/admin/outreaches'
    | '/admin/prompt-rollout'
    | '/admin/quality-scoreboard'
    | '/admin/report-generator'
    | '/admin/search'
    | '/admin/shift-assignment-health'
    | '/admin/simulator-world'
    | '/admin/sms-debug'
    | '/admin/sync-settings'
    | '/admin/tag-matching'
    | '/admin/tam-map'
    | '/admin/ui-components'
    | '/admin/voice'
    | '/admin/voice-latency'
    | '/internal/agreements'
    | '/settings/activity-feed'
    | '/settings/agency-context'
    | '/settings/agent-rules'
    | '/settings/agent-skills'
    | '/settings/auto-assign'
    | '/settings/auto-draft'
    | '/settings/auto-reply-settings'
    | '/settings/auto-send'
    | '/settings/automation-schedule'
    | '/settings/automations'
    | '/settings/call-routing'
    | '/settings/call-templates'
    | '/settings/cancellations'
    | '/settings/care-coordinators'
    | '/settings/caregiver-engagement'
    | '/settings/caregiver-tags'
    | '/settings/change-history'
    | '/settings/chrome-extension'
    | '/settings/clock-in-out'
    | '/settings/clock-in-templates'
    | '/settings/configurations'
    | '/settings/confirmation-messages'
    | '/settings/daily-digest'
    | '/settings/data-sync'
    | '/settings/early-access'
    | '/settings/help-center'
    | '/settings/off-hours'
    | '/settings/offices'
    | '/settings/open-shift-responses'
    | '/settings/other-templates'
    | '/settings/outreach-automation'
    | '/settings/outreach-templates'
    | '/settings/phoebe'
    | '/settings/phone'
    | '/settings/phone-instructions'
    | '/settings/phone-numbers'
    | '/settings/phone-try'
    | '/settings/quiet-hours'
    | '/settings/recommendations'
    | '/settings/shift-confirmation-skip-allow-lists'
    | '/settings/shift-confirmations'
    | '/settings/skip-allow-lists'
    | '/settings/slack'
    | '/settings/tag-matching'
    | '/settings/team-coverage'
    | '/settings/team-members'
    | '/settings/test-mode'
    | '/slack/link'
    | '/admin/'
    | '/settings/'
    | '/outreaches/$callout-id'
    | '/shifts/$shift-id'
    | '/surveys/$survey-id'
    | '/surveys/create'
    | '/training/announcement'
    | '/training/demo'
    | '/training/onboarding'
    | '/admin/accounts/$accountId'
    | '/admin/agent-notes/$note-id'
    | '/admin/agent-traces/$conversationId'
    | '/admin/agent-traces/ephemeral'
    | '/admin/agent/$runId'
    | '/admin/agent/capabilities'
    | '/admin/agent/missing-tools'
    | '/admin/agent/tool-telemetry'
    | '/admin/analytics/$slug'
    | '/admin/calls/$callId'
    | '/admin/care-coordinators/$care-coordinator-id'
    | '/admin/caregivers/$caregiver-id'
    | '/admin/clients/$client-id'
    | '/admin/organizations/$organization-id'
    | '/admin/revenue/$account-id'
    | '/admin/revenue/accounts'
    | '/admin/sales/agreements'
    | '/admin/sandbox/$organizationId'
    | '/admin/shifts/$shift-id'
    | '/admin/sms-engine-runs/$runId'
    | '/admin/users/$user-id'
    | '/admin/voice-config/$organization-id'
    | '/admin/voice-evals/cases'
    | '/admin/voice-evals/catalog'
    | '/admin/voice-evals/compare'
    | '/admin/voice-evals/compare-case'
    | '/admin/voice-playground/$call-id'
    | '/admin/voice-qa/$callId'
    | '/admin/voice-qa/shadow-comparison'
    | '/admin/voip/$organization-id'
    | '/settings/notifications/$channel'
    | '/agent/'
    | '/calendar/'
    | '/conversations/'
    | '/outreaches/'
    | '/scheduled/'
    | '/shifts/'
    | '/surveys/'
    | '/training/'
    | '/admin/access-tokens/'
    | '/admin/accounts/'
    | '/admin/agent-notes/'
    | '/admin/agent-traces/'
    | '/admin/agent/'
    | '/admin/analytics/'
    | '/admin/auto-callout-board/'
    | '/admin/automations/'
    | '/admin/calls/'
    | '/admin/care-coordinators/'
    | '/admin/caregivers/'
    | '/admin/clients/'
    | '/admin/extension-lab/'
    | '/admin/franchises/'
    | '/admin/org-distributions/'
    | '/admin/organizations/'
    | '/admin/outbox/'
    | '/admin/recommendation-explorer/'
    | '/admin/revenue/'
    | '/admin/sandbox/'
    | '/admin/shifts/'
    | '/admin/sms-engine-runs/'
    | '/admin/users/'
    | '/admin/voice-config/'
    | '/admin/voice-evals/'
    | '/admin/voice-playground/'
    | '/admin/voice-qa/'
    | '/admin/voip/'
    | '/settings/notifications/'
    | '/agent/runs/$runId'
    | '/outreaches/message/$message-id'
    | '/outreaches/message/create'
    | '/outreaches/survey/$survey-id'
    | '/outreaches/survey/create'
    | '/admin/agent-traces/run/$runId'
    | '/admin/agent/actions/$audit-id'
    | '/admin/agent/automations/list'
    | '/admin/agent/automations/runs'
    | '/admin/agent/pages/$slug'
    | '/admin/agent/scratchpad/$note-id'
    | '/admin/automations/$organizationId/$automationId'
    | '/admin/agent/actions/'
    | '/admin/agent/automations/'
    | '/admin/agent/pages/'
    | '/admin/agent/scratchpad/'
    | '/extension-review/calendar/php/unassigned'
    | '/admin/agent/automations/$organizationId/$automationId'
    | '/admin/automations/$organizationId/$automationId/'
    | '/admin/voice-evals/runs/$runId/'
    | '/admin/agent/runs/$runId/artifacts/$artifactId'
    | '/admin/automations/$organizationId/$automationId/runs/$automationRunId'
    | '/admin/extension-lab/ehr/$provider/$entity/$externalId'
    | '/admin/voice-evals/runs/$runId/cases/$caseResultId'
    | '/admin/agent/automations/$organizationId/$automationId/'
    | '/admin/agent/automations/$organizationId/$automationId/runs/$automationRunId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/phoebe-thinking-tips-mockup'
    | '/teach-phoebe-feedback-tags-mockup'
    | '/$organization-id/demo'
    | '/accept-invitation'
    | '/change-password'
    | '/error'
    | '/intro-call-booked'
    | '/reset-password'
    | '/sign-in'
    | '/sign-out'
    | '/sign-up'
    | '/chrome-extension/privacy'
    | '/outreaches/phoebe-thinking-tips-mockup'
    | '/r/$code'
    | '/simulator-world/display'
    | '/extension'
    | '/extension-local'
    | '/activity'
    | '/activity-board'
    | '/authorizations'
    | '/automations'
    | '/callouts'
    | '/caregivers'
    | '/clients'
    | '/coverage'
    | '/dry-run-report'
    | '/home'
    | '/leaderboard'
    | '/learn-phoebe'
    | '/metrics'
    | '/phone'
    | '/playbooks'
    | '/referrals'
    | '/teach-phoebe'
    | '/voice-calls'
    | '/admin/agent-analysis'
    | '/admin/agent-tools'
    | '/admin/amd-shadow'
    | '/admin/care-plan-previewer'
    | '/admin/caregiver-sim'
    | '/admin/data-quality'
    | '/admin/data-sync'
    | '/admin/demo-org'
    | '/admin/design-kit'
    | '/admin/document-ingestion'
    | '/admin/flags'
    | '/admin/imessage'
    | '/admin/imessage-requests'
    | '/admin/message-queue'
    | '/admin/notifications-lab'
    | '/admin/org-snapshots'
    | '/admin/organization-default-settings'
    | '/admin/outreach-observability'
    | '/admin/outreaches'
    | '/admin/prompt-rollout'
    | '/admin/quality-scoreboard'
    | '/admin/report-generator'
    | '/admin/search'
    | '/admin/shift-assignment-health'
    | '/admin/simulator-world'
    | '/admin/sms-debug'
    | '/admin/sync-settings'
    | '/admin/tag-matching'
    | '/admin/tam-map'
    | '/admin/ui-components'
    | '/admin/voice'
    | '/admin/voice-latency'
    | '/internal/agreements'
    | '/settings/activity-feed'
    | '/settings/agency-context'
    | '/settings/agent-rules'
    | '/settings/agent-skills'
    | '/settings/auto-assign'
    | '/settings/auto-draft'
    | '/settings/auto-reply-settings'
    | '/settings/auto-send'
    | '/settings/automation-schedule'
    | '/settings/automations'
    | '/settings/call-routing'
    | '/settings/call-templates'
    | '/settings/cancellations'
    | '/settings/care-coordinators'
    | '/settings/caregiver-engagement'
    | '/settings/caregiver-tags'
    | '/settings/change-history'
    | '/settings/chrome-extension'
    | '/settings/clock-in-out'
    | '/settings/clock-in-templates'
    | '/settings/configurations'
    | '/settings/confirmation-messages'
    | '/settings/daily-digest'
    | '/settings/data-sync'
    | '/settings/early-access'
    | '/settings/help-center'
    | '/settings/off-hours'
    | '/settings/offices'
    | '/settings/open-shift-responses'
    | '/settings/other-templates'
    | '/settings/outreach-automation'
    | '/settings/outreach-templates'
    | '/settings/phoebe'
    | '/settings/phone'
    | '/settings/phone-instructions'
    | '/settings/phone-numbers'
    | '/settings/phone-try'
    | '/settings/quiet-hours'
    | '/settings/recommendations'
    | '/settings/shift-confirmation-skip-allow-lists'
    | '/settings/shift-confirmations'
    | '/settings/skip-allow-lists'
    | '/settings/slack'
    | '/settings/tag-matching'
    | '/settings/team-coverage'
    | '/settings/team-members'
    | '/settings/test-mode'
    | '/slack/link'
    | '/admin'
    | '/settings'
    | '/outreaches/$callout-id'
    | '/shifts/$shift-id'
    | '/surveys/$survey-id'
    | '/surveys/create'
    | '/training/announcement'
    | '/training/demo'
    | '/training/onboarding'
    | '/admin/accounts/$accountId'
    | '/admin/agent-notes/$note-id'
    | '/admin/agent-traces/$conversationId'
    | '/admin/agent-traces/ephemeral'
    | '/admin/agent/$runId'
    | '/admin/agent/capabilities'
    | '/admin/agent/missing-tools'
    | '/admin/agent/tool-telemetry'
    | '/admin/analytics/$slug'
    | '/admin/calls/$callId'
    | '/admin/care-coordinators/$care-coordinator-id'
    | '/admin/caregivers/$caregiver-id'
    | '/admin/clients/$client-id'
    | '/admin/organizations/$organization-id'
    | '/admin/revenue/$account-id'
    | '/admin/revenue/accounts'
    | '/admin/sales/agreements'
    | '/admin/sandbox/$organizationId'
    | '/admin/shifts/$shift-id'
    | '/admin/sms-engine-runs/$runId'
    | '/admin/users/$user-id'
    | '/admin/voice-config/$organization-id'
    | '/admin/voice-evals/cases'
    | '/admin/voice-evals/catalog'
    | '/admin/voice-evals/compare'
    | '/admin/voice-evals/compare-case'
    | '/admin/voice-playground/$call-id'
    | '/admin/voice-qa/$callId'
    | '/admin/voice-qa/shadow-comparison'
    | '/admin/voip/$organization-id'
    | '/settings/notifications/$channel'
    | '/agent'
    | '/calendar'
    | '/conversations'
    | '/outreaches'
    | '/scheduled'
    | '/shifts'
    | '/surveys'
    | '/training'
    | '/admin/access-tokens'
    | '/admin/accounts'
    | '/admin/agent-notes'
    | '/admin/agent-traces'
    | '/admin/agent'
    | '/admin/analytics'
    | '/admin/auto-callout-board'
    | '/admin/automations'
    | '/admin/calls'
    | '/admin/care-coordinators'
    | '/admin/caregivers'
    | '/admin/clients'
    | '/admin/extension-lab'
    | '/admin/franchises'
    | '/admin/org-distributions'
    | '/admin/organizations'
    | '/admin/outbox'
    | '/admin/recommendation-explorer'
    | '/admin/revenue'
    | '/admin/sandbox'
    | '/admin/shifts'
    | '/admin/sms-engine-runs'
    | '/admin/users'
    | '/admin/voice-config'
    | '/admin/voice-evals'
    | '/admin/voice-playground'
    | '/admin/voice-qa'
    | '/admin/voip'
    | '/settings/notifications'
    | '/agent/runs/$runId'
    | '/outreaches/message/$message-id'
    | '/outreaches/message/create'
    | '/outreaches/survey/$survey-id'
    | '/outreaches/survey/create'
    | '/admin/agent-traces/run/$runId'
    | '/admin/agent/actions/$audit-id'
    | '/admin/agent/automations/list'
    | '/admin/agent/automations/runs'
    | '/admin/agent/pages/$slug'
    | '/admin/agent/scratchpad/$note-id'
    | '/admin/agent/actions'
    | '/admin/agent/automations'
    | '/admin/agent/pages'
    | '/admin/agent/scratchpad'
    | '/extension-review/calendar/php/unassigned'
    | '/admin/automations/$organizationId/$automationId'
    | '/admin/voice-evals/runs/$runId'
    | '/admin/agent/runs/$runId/artifacts/$artifactId'
    | '/admin/automations/$organizationId/$automationId/runs/$automationRunId'
    | '/admin/extension-lab/ehr/$provider/$entity/$externalId'
    | '/admin/voice-evals/runs/$runId/cases/$caseResultId'
    | '/admin/agent/automations/$organizationId/$automationId'
    | '/admin/agent/automations/$organizationId/$automationId/runs/$automationRunId'
  id:
    | '__root__'
    | '/_app'
    | '/_auth'
    | '/phoebe-thinking-tips-mockup'
    | '/teach-phoebe-feedback-tags-mockup'
    | '/_app/(agent)'
    | '/_app/(extension)'
    | '/_app/(main)'
    | '/_app/admin'
    | '/_app/settings'
    | '/$organization-id/demo'
    | '/_auth/accept-invitation'
    | '/_auth/change-password'
    | '/_auth/error'
    | '/_auth/intro-call-booked'
    | '/_auth/reset-password'
    | '/_auth/sign-in'
    | '/_auth/sign-out'
    | '/_auth/sign-up'
    | '/chrome-extension/privacy'
    | '/outreaches/phoebe-thinking-tips-mockup'
    | '/r/$code'
    | '/simulator-world/display'
    | '/_app/(extension)/extension'
    | '/_app/(extension)/extension-local'
    | '/_app/admin/extension-lab'
    | '/_app/settings/notifications'
    | '/_app/(agent)/agent'
    | '/_app/(main)/activity'
    | '/_app/(main)/activity-board'
    | '/_app/(main)/authorizations'
    | '/_app/(main)/automations'
    | '/_app/(main)/callouts'
    | '/_app/(main)/caregivers'
    | '/_app/(main)/clients'
    | '/_app/(main)/coverage'
    | '/_app/(main)/dry-run-report'
    | '/_app/(main)/home'
    | '/_app/(main)/leaderboard'
    | '/_app/(main)/learn-phoebe'
    | '/_app/(main)/metrics'
    | '/_app/(main)/phone'
    | '/_app/(main)/playbooks'
    | '/_app/(main)/referrals'
    | '/_app/(main)/teach-phoebe'
    | '/_app/(main)/training'
    | '/_app/(main)/voice-calls'
    | '/_app/admin/agent-analysis'
    | '/_app/admin/agent-tools'
    | '/_app/admin/amd-shadow'
    | '/_app/admin/care-plan-previewer'
    | '/_app/admin/caregiver-sim'
    | '/_app/admin/data-quality'
    | '/_app/admin/data-sync'
    | '/_app/admin/demo-org'
    | '/_app/admin/design-kit'
    | '/_app/admin/document-ingestion'
    | '/_app/admin/flags'
    | '/_app/admin/imessage'
    | '/_app/admin/imessage-requests'
    | '/_app/admin/message-queue'
    | '/_app/admin/notifications-lab'
    | '/_app/admin/org-snapshots'
    | '/_app/admin/organization-default-settings'
    | '/_app/admin/outreach-observability'
    | '/_app/admin/outreaches'
    | '/_app/admin/prompt-rollout'
    | '/_app/admin/quality-scoreboard'
    | '/_app/admin/report-generator'
    | '/_app/admin/search'
    | '/_app/admin/shift-assignment-health'
    | '/_app/admin/simulator-world'
    | '/_app/admin/sms-debug'
    | '/_app/admin/sync-settings'
    | '/_app/admin/tag-matching'
    | '/_app/admin/tam-map'
    | '/_app/admin/ui-components'
    | '/_app/admin/voice'
    | '/_app/admin/voice-latency'
    | '/_app/internal/agreements'
    | '/_app/settings/activity-feed'
    | '/_app/settings/agency-context'
    | '/_app/settings/agent-rules'
    | '/_app/settings/agent-skills'
    | '/_app/settings/auto-assign'
    | '/_app/settings/auto-draft'
    | '/_app/settings/auto-reply-settings'
    | '/_app/settings/auto-send'
    | '/_app/settings/automation-schedule'
    | '/_app/settings/automations'
    | '/_app/settings/call-routing'
    | '/_app/settings/call-templates'
    | '/_app/settings/cancellations'
    | '/_app/settings/care-coordinators'
    | '/_app/settings/caregiver-engagement'
    | '/_app/settings/caregiver-tags'
    | '/_app/settings/change-history'
    | '/_app/settings/chrome-extension'
    | '/_app/settings/clock-in-out'
    | '/_app/settings/clock-in-templates'
    | '/_app/settings/configurations'
    | '/_app/settings/confirmation-messages'
    | '/_app/settings/daily-digest'
    | '/_app/settings/data-sync'
    | '/_app/settings/early-access'
    | '/_app/settings/help-center'
    | '/_app/settings/off-hours'
    | '/_app/settings/offices'
    | '/_app/settings/open-shift-responses'
    | '/_app/settings/other-templates'
    | '/_app/settings/outreach-automation'
    | '/_app/settings/outreach-templates'
    | '/_app/settings/phoebe'
    | '/_app/settings/phone'
    | '/_app/settings/phone-instructions'
    | '/_app/settings/phone-numbers'
    | '/_app/settings/phone-try'
    | '/_app/settings/quiet-hours'
    | '/_app/settings/recommendations'
    | '/_app/settings/shift-confirmation-skip-allow-lists'
    | '/_app/settings/shift-confirmations'
    | '/_app/settings/skip-allow-lists'
    | '/_app/settings/slack'
    | '/_app/settings/tag-matching'
    | '/_app/settings/team-coverage'
    | '/_app/settings/team-members'
    | '/_app/settings/test-mode'
    | '/_app/slack/link'
    | '/_app/(main)/'
    | '/_app/admin/'
    | '/_app/settings/'
    | '/_app/(main)/outreaches/$callout-id'
    | '/_app/(main)/shifts/$shift-id'
    | '/_app/(main)/surveys/$survey-id'
    | '/_app/(main)/surveys/create'
    | '/_app/(main)/training/announcement'
    | '/_app/(main)/training/demo'
    | '/_app/(main)/training/onboarding'
    | '/_app/admin/accounts/$accountId'
    | '/_app/admin/agent-notes/$note-id'
    | '/_app/admin/agent-traces/$conversationId'
    | '/_app/admin/agent-traces/ephemeral'
    | '/_app/admin/agent/$runId'
    | '/_app/admin/agent/capabilities'
    | '/_app/admin/agent/missing-tools'
    | '/_app/admin/agent/tool-telemetry'
    | '/_app/admin/analytics/$slug'
    | '/_app/admin/calls/$callId'
    | '/_app/admin/care-coordinators/$care-coordinator-id'
    | '/_app/admin/caregivers/$caregiver-id'
    | '/_app/admin/clients/$client-id'
    | '/_app/admin/organizations/$organization-id'
    | '/_app/admin/revenue/$account-id'
    | '/_app/admin/revenue/accounts'
    | '/_app/admin/sales/agreements'
    | '/_app/admin/sandbox/$organizationId'
    | '/_app/admin/shifts/$shift-id'
    | '/_app/admin/sms-engine-runs/$runId'
    | '/_app/admin/users/$user-id'
    | '/_app/admin/voice-config/$organization-id'
    | '/_app/admin/voice-evals/cases'
    | '/_app/admin/voice-evals/catalog'
    | '/_app/admin/voice-evals/compare'
    | '/_app/admin/voice-evals/compare-case'
    | '/_app/admin/voice-playground/$call-id'
    | '/_app/admin/voice-qa/$callId'
    | '/_app/admin/voice-qa/shadow-comparison'
    | '/_app/admin/voip/$organization-id'
    | '/_app/settings/notifications/$channel'
    | '/_app/(agent)/agent/'
    | '/_app/(main)/calendar/'
    | '/_app/(main)/conversations/'
    | '/_app/(main)/outreaches/'
    | '/_app/(main)/scheduled/'
    | '/_app/(main)/shifts/'
    | '/_app/(main)/surveys/'
    | '/_app/(main)/training/'
    | '/_app/admin/access-tokens/'
    | '/_app/admin/accounts/'
    | '/_app/admin/agent-notes/'
    | '/_app/admin/agent-traces/'
    | '/_app/admin/agent/'
    | '/_app/admin/analytics/'
    | '/_app/admin/auto-callout-board/'
    | '/_app/admin/automations/'
    | '/_app/admin/calls/'
    | '/_app/admin/care-coordinators/'
    | '/_app/admin/caregivers/'
    | '/_app/admin/clients/'
    | '/_app/admin/extension-lab/'
    | '/_app/admin/franchises/'
    | '/_app/admin/org-distributions/'
    | '/_app/admin/organizations/'
    | '/_app/admin/outbox/'
    | '/_app/admin/recommendation-explorer/'
    | '/_app/admin/revenue/'
    | '/_app/admin/sandbox/'
    | '/_app/admin/shifts/'
    | '/_app/admin/sms-engine-runs/'
    | '/_app/admin/users/'
    | '/_app/admin/voice-config/'
    | '/_app/admin/voice-evals/'
    | '/_app/admin/voice-playground/'
    | '/_app/admin/voice-qa/'
    | '/_app/admin/voip/'
    | '/_app/settings/notifications/'
    | '/_app/(agent)/agent/runs/$runId'
    | '/_app/(main)/outreaches/message/$message-id'
    | '/_app/(main)/outreaches/message/create'
    | '/_app/(main)/outreaches/survey/$survey-id'
    | '/_app/(main)/outreaches/survey/create'
    | '/_app/admin/agent-traces/run/$runId'
    | '/_app/admin/agent/actions/$audit-id'
    | '/_app/admin/agent/automations/list'
    | '/_app/admin/agent/automations/runs'
    | '/_app/admin/agent/pages/$slug'
    | '/_app/admin/agent/scratchpad/$note-id'
    | '/_app/admin/automations/$organizationId/$automationId'
    | '/_app/admin/agent/actions/'
    | '/_app/admin/agent/automations/'
    | '/_app/admin/agent/pages/'
    | '/_app/admin/agent/scratchpad/'
    | '/_app/(main)/extension-review/calendar/php/unassigned'
    | '/_app/admin/agent/automations/$organizationId/$automationId'
    | '/_app/admin/automations/$organizationId/$automationId/'
    | '/_app/admin/voice-evals/runs/$runId/'
    | '/_app/admin/agent/runs/$runId/artifacts/$artifactId'
    | '/_app/admin/automations/$organizationId/$automationId/runs/$automationRunId'
    | '/_app/admin/extension-lab/ehr/$provider/$entity/$externalId'
    | '/_app/admin/voice-evals/runs/$runId/cases/$caseResultId'
    | '/_app/admin/agent/automations/$organizationId/$automationId/'
    | '/_app/admin/agent/automations/$organizationId/$automationId/runs/$automationRunId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRouteRoute: typeof AppRouteRouteWithChildren
  AuthRouteRoute: typeof AuthRouteRouteWithChildren
  PhoebeThinkingTipsMockupRoute: typeof PhoebeThinkingTipsMockupRoute
  TeachPhoebeFeedbackTagsMockupRoute: typeof TeachPhoebeFeedbackTagsMockupRoute
  OrganizationIdDemoRoute: typeof OrganizationIdDemoRoute
  ChromeExtensionPrivacyRoute: typeof ChromeExtensionPrivacyRoute
  OutreachesPhoebeThinkingTipsMockupRoute: typeof OutreachesPhoebeThinkingTipsMockupRoute
  RCodeRoute: typeof RCodeRoute
  SimulatorWorldDisplayRoute: typeof SimulatorWorldDisplayRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/teach-phoebe-feedback-tags-mockup': {
      id: '/teach-phoebe-feedback-tags-mockup'
      path: '/teach-phoebe-feedback-tags-mockup'
      fullPath: '/teach-phoebe-feedback-tags-mockup'
      preLoaderRoute: typeof TeachPhoebeFeedbackTagsMockupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/phoebe-thinking-tips-mockup': {
      id: '/phoebe-thinking-tips-mockup'
      path: '/phoebe-thinking-tips-mockup'
      fullPath: '/phoebe-thinking-tips-mockup'
      preLoaderRoute: typeof PhoebeThinkingTipsMockupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/simulator-world/display': {
      id: '/simulator-world/display'
      path: '/simulator-world/display'
      fullPath: '/simulator-world/display'
      preLoaderRoute: typeof SimulatorWorldDisplayRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/r/$code': {
      id: '/r/$code'
      path: '/r/$code'
      fullPath: '/r/$code'
      preLoaderRoute: typeof RCodeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/outreaches/phoebe-thinking-tips-mockup': {
      id: '/outreaches/phoebe-thinking-tips-mockup'
      path: '/outreaches/phoebe-thinking-tips-mockup'
      fullPath: '/outreaches/phoebe-thinking-tips-mockup'
      preLoaderRoute: typeof OutreachesPhoebeThinkingTipsMockupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/chrome-extension/privacy': {
      id: '/chrome-extension/privacy'
      path: '/chrome-extension/privacy'
      fullPath: '/chrome-extension/privacy'
      preLoaderRoute: typeof ChromeExtensionPrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/sign-up': {
      id: '/_auth/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof AuthSignUpRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/sign-out': {
      id: '/_auth/sign-out'
      path: '/sign-out'
      fullPath: '/sign-out'
      preLoaderRoute: typeof AuthSignOutRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/sign-in': {
      id: '/_auth/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof AuthSignInRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/reset-password': {
      id: '/_auth/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof AuthResetPasswordRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/intro-call-booked': {
      id: '/_auth/intro-call-booked'
      path: '/intro-call-booked'
      fullPath: '/intro-call-booked'
      preLoaderRoute: typeof AuthIntroCallBookedRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/error': {
      id: '/_auth/error'
      path: '/error'
      fullPath: '/error'
      preLoaderRoute: typeof AuthErrorRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/change-password': {
      id: '/_auth/change-password'
      path: '/change-password'
      fullPath: '/change-password'
      preLoaderRoute: typeof AuthChangePasswordRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/accept-invitation': {
      id: '/_auth/accept-invitation'
      path: '/accept-invitation'
      fullPath: '/accept-invitation'
      preLoaderRoute: typeof AuthAcceptInvitationRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/$organization-id/demo': {
      id: '/$organization-id/demo'
      path: '/$organization-id/demo'
      fullPath: '/$organization-id/demo'
      preLoaderRoute: typeof OrganizationIdDemoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/admin': {
      id: '/_app/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AppAdminRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/(main)': {
      id: '/_app/(main)'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AppmainRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/(extension)': {
      id: '/_app/(extension)'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AppextensionRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/(agent)': {
      id: '/_app/(agent)'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AppagentRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/settings/': {
      id: '/_app/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AppSettingsIndexRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/admin/': {
      id: '/_app/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AppAdminIndexRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/(main)/': {
      id: '/_app/(main)/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppmainIndexRouteImport
      parentRoute: typeof AppmainRouteRoute
    }
    '/_app/slack/link': {
      id: '/_app/slack/link'
      path: '/slack/link'
      fullPath: '/slack/link'
      preLoaderRoute: typeof AppSlackLinkRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/settings/test-mode': {
      id: '/_app/settings/test-mode'
      path: '/test-mode'
      fullPath: '/settings/test-mode'
      preLoaderRoute: typeof AppSettingsTestModeRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/team-members': {
      id: '/_app/settings/team-members'
      path: '/team-members'
      fullPath: '/settings/team-members'
      preLoaderRoute: typeof AppSettingsTeamMembersRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/team-coverage': {
      id: '/_app/settings/team-coverage'
      path: '/team-coverage'
      fullPath: '/settings/team-coverage'
      preLoaderRoute: typeof AppSettingsTeamCoverageRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/tag-matching': {
      id: '/_app/settings/tag-matching'
      path: '/tag-matching'
      fullPath: '/settings/tag-matching'
      preLoaderRoute: typeof AppSettingsTagMatchingRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/slack': {
      id: '/_app/settings/slack'
      path: '/slack'
      fullPath: '/settings/slack'
      preLoaderRoute: typeof AppSettingsSlackRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/skip-allow-lists': {
      id: '/_app/settings/skip-allow-lists'
      path: '/skip-allow-lists'
      fullPath: '/settings/skip-allow-lists'
      preLoaderRoute: typeof AppSettingsSkipAllowListsRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/shift-confirmations': {
      id: '/_app/settings/shift-confirmations'
      path: '/shift-confirmations'
      fullPath: '/settings/shift-confirmations'
      preLoaderRoute: typeof AppSettingsShiftConfirmationsRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/shift-confirmation-skip-allow-lists': {
      id: '/_app/settings/shift-confirmation-skip-allow-lists'
      path: '/shift-confirmation-skip-allow-lists'
      fullPath: '/settings/shift-confirmation-skip-allow-lists'
      preLoaderRoute: typeof AppSettingsShiftConfirmationSkipAllowListsRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/recommendations': {
      id: '/_app/settings/recommendations'
      path: '/recommendations'
      fullPath: '/settings/recommendations'
      preLoaderRoute: typeof AppSettingsRecommendationsRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/quiet-hours': {
      id: '/_app/settings/quiet-hours'
      path: '/quiet-hours'
      fullPath: '/settings/quiet-hours'
      preLoaderRoute: typeof AppSettingsQuietHoursRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/phone-try': {
      id: '/_app/settings/phone-try'
      path: '/phone-try'
      fullPath: '/settings/phone-try'
      preLoaderRoute: typeof AppSettingsPhoneTryRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/phone-numbers': {
      id: '/_app/settings/phone-numbers'
      path: '/phone-numbers'
      fullPath: '/settings/phone-numbers'
      preLoaderRoute: typeof AppSettingsPhoneNumbersRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/phone-instructions': {
      id: '/_app/settings/phone-instructions'
      path: '/phone-instructions'
      fullPath: '/settings/phone-instructions'
      preLoaderRoute: typeof AppSettingsPhoneInstructionsRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/phone': {
      id: '/_app/settings/phone'
      path: '/phone'
      fullPath: '/settings/phone'
      preLoaderRoute: typeof AppSettingsPhoneRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/phoebe': {
      id: '/_app/settings/phoebe'
      path: '/phoebe'
      fullPath: '/settings/phoebe'
      preLoaderRoute: typeof AppSettingsPhoebeRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/outreach-templates': {
      id: '/_app/settings/outreach-templates'
      path: '/outreach-templates'
      fullPath: '/settings/outreach-templates'
      preLoaderRoute: typeof AppSettingsOutreachTemplatesRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/outreach-automation': {
      id: '/_app/settings/outreach-automation'
      path: '/outreach-automation'
      fullPath: '/settings/outreach-automation'
      preLoaderRoute: typeof AppSettingsOutreachAutomationRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/other-templates': {
      id: '/_app/settings/other-templates'
      path: '/other-templates'
      fullPath: '/settings/other-templates'
      preLoaderRoute: typeof AppSettingsOtherTemplatesRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/open-shift-responses': {
      id: '/_app/settings/open-shift-responses'
      path: '/open-shift-responses'
      fullPath: '/settings/open-shift-responses'
      preLoaderRoute: typeof AppSettingsOpenShiftResponsesRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/offices': {
      id: '/_app/settings/offices'
      path: '/offices'
      fullPath: '/settings/offices'
      preLoaderRoute: typeof AppSettingsOfficesRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/off-hours': {
      id: '/_app/settings/off-hours'
      path: '/off-hours'
      fullPath: '/settings/off-hours'
      preLoaderRoute: typeof AppSettingsOffHoursRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/help-center': {
      id: '/_app/settings/help-center'
      path: '/help-center'
      fullPath: '/settings/help-center'
      preLoaderRoute: typeof AppSettingsHelpCenterRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/early-access': {
      id: '/_app/settings/early-access'
      path: '/early-access'
      fullPath: '/settings/early-access'
      preLoaderRoute: typeof AppSettingsEarlyAccessRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/data-sync': {
      id: '/_app/settings/data-sync'
      path: '/data-sync'
      fullPath: '/settings/data-sync'
      preLoaderRoute: typeof AppSettingsDataSyncRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/daily-digest': {
      id: '/_app/settings/daily-digest'
      path: '/daily-digest'
      fullPath: '/settings/daily-digest'
      preLoaderRoute: typeof AppSettingsDailyDigestRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/confirmation-messages': {
      id: '/_app/settings/confirmation-messages'
      path: '/confirmation-messages'
      fullPath: '/settings/confirmation-messages'
      preLoaderRoute: typeof AppSettingsConfirmationMessagesRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/configurations': {
      id: '/_app/settings/configurations'
      path: '/configurations'
      fullPath: '/settings/configurations'
      preLoaderRoute: typeof AppSettingsConfigurationsRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/clock-in-templates': {
      id: '/_app/settings/clock-in-templates'
      path: '/clock-in-templates'
      fullPath: '/settings/clock-in-templates'
      preLoaderRoute: typeof AppSettingsClockInTemplatesRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/clock-in-out': {
      id: '/_app/settings/clock-in-out'
      path: '/clock-in-out'
      fullPath: '/settings/clock-in-out'
      preLoaderRoute: typeof AppSettingsClockInOutRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/chrome-extension': {
      id: '/_app/settings/chrome-extension'
      path: '/chrome-extension'
      fullPath: '/settings/chrome-extension'
      preLoaderRoute: typeof AppSettingsChromeExtensionRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/change-history': {
      id: '/_app/settings/change-history'
      path: '/change-history'
      fullPath: '/settings/change-history'
      preLoaderRoute: typeof AppSettingsChangeHistoryRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/caregiver-tags': {
      id: '/_app/settings/caregiver-tags'
      path: '/caregiver-tags'
      fullPath: '/settings/caregiver-tags'
      preLoaderRoute: typeof AppSettingsCaregiverTagsRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/caregiver-engagement': {
      id: '/_app/settings/caregiver-engagement'
      path: '/caregiver-engagement'
      fullPath: '/settings/caregiver-engagement'
      preLoaderRoute: typeof AppSettingsCaregiverEngagementRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/care-coordinators': {
      id: '/_app/settings/care-coordinators'
      path: '/care-coordinators'
      fullPath: '/settings/care-coordinators'
      preLoaderRoute: typeof AppSettingsCareCoordinatorsRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/cancellations': {
      id: '/_app/settings/cancellations'
      path: '/cancellations'
      fullPath: '/settings/cancellations'
      preLoaderRoute: typeof AppSettingsCancellationsRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/call-templates': {
      id: '/_app/settings/call-templates'
      path: '/call-templates'
      fullPath: '/settings/call-templates'
      preLoaderRoute: typeof AppSettingsCallTemplatesRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/call-routing': {
      id: '/_app/settings/call-routing'
      path: '/call-routing'
      fullPath: '/settings/call-routing'
      preLoaderRoute: typeof AppSettingsCallRoutingRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/automations': {
      id: '/_app/settings/automations'
      path: '/automations'
      fullPath: '/settings/automations'
      preLoaderRoute: typeof AppSettingsAutomationsRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/automation-schedule': {
      id: '/_app/settings/automation-schedule'
      path: '/automation-schedule'
      fullPath: '/settings/automation-schedule'
      preLoaderRoute: typeof AppSettingsAutomationScheduleRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/auto-send': {
      id: '/_app/settings/auto-send'
      path: '/auto-send'
      fullPath: '/settings/auto-send'
      preLoaderRoute: typeof AppSettingsAutoSendRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/auto-reply-settings': {
      id: '/_app/settings/auto-reply-settings'
      path: '/auto-reply-settings'
      fullPath: '/settings/auto-reply-settings'
      preLoaderRoute: typeof AppSettingsAutoReplySettingsRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/auto-draft': {
      id: '/_app/settings/auto-draft'
      path: '/auto-draft'
      fullPath: '/settings/auto-draft'
      preLoaderRoute: typeof AppSettingsAutoDraftRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/auto-assign': {
      id: '/_app/settings/auto-assign'
      path: '/auto-assign'
      fullPath: '/settings/auto-assign'
      preLoaderRoute: typeof AppSettingsAutoAssignRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/agent-skills': {
      id: '/_app/settings/agent-skills'
      path: '/agent-skills'
      fullPath: '/settings/agent-skills'
      preLoaderRoute: typeof AppSettingsAgentSkillsRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/agent-rules': {
      id: '/_app/settings/agent-rules'
      path: '/agent-rules'
      fullPath: '/settings/agent-rules'
      preLoaderRoute: typeof AppSettingsAgentRulesRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/agency-context': {
      id: '/_app/settings/agency-context'
      path: '/agency-context'
      fullPath: '/settings/agency-context'
      preLoaderRoute: typeof AppSettingsAgencyContextRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/activity-feed': {
      id: '/_app/settings/activity-feed'
      path: '/activity-feed'
      fullPath: '/settings/activity-feed'
      preLoaderRoute: typeof AppSettingsActivityFeedRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/internal/agreements': {
      id: '/_app/internal/agreements'
      path: '/internal/agreements'
      fullPath: '/internal/agreements'
      preLoaderRoute: typeof AppInternalAgreementsRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/admin/voice-latency': {
      id: '/_app/admin/voice-latency'
      path: '/voice-latency'
      fullPath: '/admin/voice-latency'
      preLoaderRoute: typeof AppAdminVoiceLatencyRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/voice': {
      id: '/_app/admin/voice'
      path: '/voice'
      fullPath: '/admin/voice'
      preLoaderRoute: typeof AppAdminVoiceRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/ui-components': {
      id: '/_app/admin/ui-components'
      path: '/ui-components'
      fullPath: '/admin/ui-components'
      preLoaderRoute: typeof AppAdminUiComponentsRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/tam-map': {
      id: '/_app/admin/tam-map'
      path: '/tam-map'
      fullPath: '/admin/tam-map'
      preLoaderRoute: typeof AppAdminTamMapRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/tag-matching': {
      id: '/_app/admin/tag-matching'
      path: '/tag-matching'
      fullPath: '/admin/tag-matching'
      preLoaderRoute: typeof AppAdminTagMatchingRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/sync-settings': {
      id: '/_app/admin/sync-settings'
      path: '/sync-settings'
      fullPath: '/admin/sync-settings'
      preLoaderRoute: typeof AppAdminSyncSettingsRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/sms-debug': {
      id: '/_app/admin/sms-debug'
      path: '/sms-debug'
      fullPath: '/admin/sms-debug'
      preLoaderRoute: typeof AppAdminSmsDebugRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/simulator-world': {
      id: '/_app/admin/simulator-world'
      path: '/simulator-world'
      fullPath: '/admin/simulator-world'
      preLoaderRoute: typeof AppAdminSimulatorWorldRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/shift-assignment-health': {
      id: '/_app/admin/shift-assignment-health'
      path: '/shift-assignment-health'
      fullPath: '/admin/shift-assignment-health'
      preLoaderRoute: typeof AppAdminShiftAssignmentHealthRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/search': {
      id: '/_app/admin/search'
      path: '/search'
      fullPath: '/admin/search'
      preLoaderRoute: typeof AppAdminSearchRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/report-generator': {
      id: '/_app/admin/report-generator'
      path: '/report-generator'
      fullPath: '/admin/report-generator'
      preLoaderRoute: typeof AppAdminReportGeneratorRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/quality-scoreboard': {
      id: '/_app/admin/quality-scoreboard'
      path: '/quality-scoreboard'
      fullPath: '/admin/quality-scoreboard'
      preLoaderRoute: typeof AppAdminQualityScoreboardRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/prompt-rollout': {
      id: '/_app/admin/prompt-rollout'
      path: '/prompt-rollout'
      fullPath: '/admin/prompt-rollout'
      preLoaderRoute: typeof AppAdminPromptRolloutRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/outreaches': {
      id: '/_app/admin/outreaches'
      path: '/outreaches'
      fullPath: '/admin/outreaches'
      preLoaderRoute: typeof AppAdminOutreachesRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/outreach-observability': {
      id: '/_app/admin/outreach-observability'
      path: '/outreach-observability'
      fullPath: '/admin/outreach-observability'
      preLoaderRoute: typeof AppAdminOutreachObservabilityRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/organization-default-settings': {
      id: '/_app/admin/organization-default-settings'
      path: '/organization-default-settings'
      fullPath: '/admin/organization-default-settings'
      preLoaderRoute: typeof AppAdminOrganizationDefaultSettingsRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/org-snapshots': {
      id: '/_app/admin/org-snapshots'
      path: '/org-snapshots'
      fullPath: '/admin/org-snapshots'
      preLoaderRoute: typeof AppAdminOrgSnapshotsRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/notifications-lab': {
      id: '/_app/admin/notifications-lab'
      path: '/notifications-lab'
      fullPath: '/admin/notifications-lab'
      preLoaderRoute: typeof AppAdminNotificationsLabRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/message-queue': {
      id: '/_app/admin/message-queue'
      path: '/message-queue'
      fullPath: '/admin/message-queue'
      preLoaderRoute: typeof AppAdminMessageQueueRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/imessage-requests': {
      id: '/_app/admin/imessage-requests'
      path: '/imessage-requests'
      fullPath: '/admin/imessage-requests'
      preLoaderRoute: typeof AppAdminImessageRequestsRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/imessage': {
      id: '/_app/admin/imessage'
      path: '/imessage'
      fullPath: '/admin/imessage'
      preLoaderRoute: typeof AppAdminImessageRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/flags': {
      id: '/_app/admin/flags'
      path: '/flags'
      fullPath: '/admin/flags'
      preLoaderRoute: typeof AppAdminFlagsRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/document-ingestion': {
      id: '/_app/admin/document-ingestion'
      path: '/document-ingestion'
      fullPath: '/admin/document-ingestion'
      preLoaderRoute: typeof AppAdminDocumentIngestionRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/design-kit': {
      id: '/_app/admin/design-kit'
      path: '/design-kit'
      fullPath: '/admin/design-kit'
      preLoaderRoute: typeof AppAdminDesignKitRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/demo-org': {
      id: '/_app/admin/demo-org'
      path: '/demo-org'
      fullPath: '/admin/demo-org'
      preLoaderRoute: typeof AppAdminDemoOrgRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/data-sync': {
      id: '/_app/admin/data-sync'
      path: '/data-sync'
      fullPath: '/admin/data-sync'
      preLoaderRoute: typeof AppAdminDataSyncRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/data-quality': {
      id: '/_app/admin/data-quality'
      path: '/data-quality'
      fullPath: '/admin/data-quality'
      preLoaderRoute: typeof AppAdminDataQualityRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/caregiver-sim': {
      id: '/_app/admin/caregiver-sim'
      path: '/caregiver-sim'
      fullPath: '/admin/caregiver-sim'
      preLoaderRoute: typeof AppAdminCaregiverSimRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/care-plan-previewer': {
      id: '/_app/admin/care-plan-previewer'
      path: '/care-plan-previewer'
      fullPath: '/admin/care-plan-previewer'
      preLoaderRoute: typeof AppAdminCarePlanPreviewerRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/amd-shadow': {
      id: '/_app/admin/amd-shadow'
      path: '/amd-shadow'
      fullPath: '/admin/amd-shadow'
      preLoaderRoute: typeof AppAdminAmdShadowRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/agent-tools': {
      id: '/_app/admin/agent-tools'
      path: '/agent-tools'
      fullPath: '/admin/agent-tools'
      preLoaderRoute: typeof AppAdminAgentToolsRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/agent-analysis': {
      id: '/_app/admin/agent-analysis'
      path: '/agent-analysis'
      fullPath: '/admin/agent-analysis'
      preLoaderRoute: typeof AppAdminAgentAnalysisRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/(main)/voice-calls': {
      id: '/_app/(main)/voice-calls'
      path: '/voice-calls'
      fullPath: '/voice-calls'
      preLoaderRoute: typeof AppmainVoiceCallsRouteImport
      parentRoute: typeof AppmainRouteRoute
    }
    '/_app/(main)/training': {
      id: '/_app/(main)/training'
      path: '/training'
      fullPath: '/training'
      preLoaderRoute: typeof AppmainTrainingRouteImport
      parentRoute: typeof AppmainRouteRoute
    }
    '/_app/(main)/teach-phoebe': {
      id: '/_app/(main)/teach-phoebe'
      path: '/teach-phoebe'
      fullPath: '/teach-phoebe'
      preLoaderRoute: typeof AppmainTeachPhoebeRouteImport
      parentRoute: typeof AppmainRouteRoute
    }
    '/_app/(main)/referrals': {
      id: '/_app/(main)/referrals'
      path: '/referrals'
      fullPath: '/referrals'
      preLoaderRoute: typeof AppmainReferralsRouteImport
      parentRoute: typeof AppmainRouteRoute
    }
    '/_app/(main)/playbooks': {
      id: '/_app/(main)/playbooks'
      path: '/playbooks'
      fullPath: '/playbooks'
      preLoaderRoute: typeof AppmainPlaybooksRouteImport
      parentRoute: typeof AppmainRouteRoute
    }
    '/_app/(main)/phone': {
      id: '/_app/(main)/phone'
      path: '/phone'
      fullPath: '/phone'
      preLoaderRoute: typeof AppmainPhoneRouteImport
      parentRoute: typeof AppmainRouteRoute
    }
    '/_app/(main)/metrics': {
      id: '/_app/(main)/metrics'
      path: '/metrics'
      fullPath: '/metrics'
      preLoaderRoute: typeof AppmainMetricsRouteImport
      parentRoute: typeof AppmainRouteRoute
    }
    '/_app/(main)/learn-phoebe': {
      id: '/_app/(main)/learn-phoebe'
      path: '/learn-phoebe'
      fullPath: '/learn-phoebe'
      preLoaderRoute: typeof AppmainLearnPhoebeRouteImport
      parentRoute: typeof AppmainRouteRoute
    }
    '/_app/(main)/leaderboard': {
      id: '/_app/(main)/leaderboard'
      path: '/leaderboard'
      fullPath: '/leaderboard'
      preLoaderRoute: typeof AppmainLeaderboardRouteImport
      parentRoute: typeof AppmainRouteRoute
    }
    '/_app/(main)/home': {
      id: '/_app/(main)/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof AppmainHomeRouteImport
      parentRoute: typeof AppmainRouteRoute
    }
    '/_app/(main)/dry-run-report': {
      id: '/_app/(main)/dry-run-report'
      path: '/dry-run-report'
      fullPath: '/dry-run-report'
      preLoaderRoute: typeof AppmainDryRunReportRouteImport
      parentRoute: typeof AppmainRouteRoute
    }
    '/_app/(main)/coverage': {
      id: '/_app/(main)/coverage'
      path: '/coverage'
      fullPath: '/coverage'
      preLoaderRoute: typeof AppmainCoverageRouteImport
      parentRoute: typeof AppmainRouteRoute
    }
    '/_app/(main)/clients': {
      id: '/_app/(main)/clients'
      path: '/clients'
      fullPath: '/clients'
      preLoaderRoute: typeof AppmainClientsRouteImport
      parentRoute: typeof AppmainRouteRoute
    }
    '/_app/(main)/caregivers': {
      id: '/_app/(main)/caregivers'
      path: '/caregivers'
      fullPath: '/caregivers'
      preLoaderRoute: typeof AppmainCaregiversRouteImport
      parentRoute: typeof AppmainRouteRoute
    }
    '/_app/(main)/callouts': {
      id: '/_app/(main)/callouts'
      path: '/callouts'
      fullPath: '/callouts'
      preLoaderRoute: typeof AppmainCalloutsRouteImport
      parentRoute: typeof AppmainRouteRoute
    }
    '/_app/(main)/automations': {
      id: '/_app/(main)/automations'
      path: '/automations'
      fullPath: '/automations'
      preLoaderRoute: typeof AppmainAutomationsRouteImport
      parentRoute: typeof AppmainRouteRoute
    }
    '/_app/(main)/authorizations': {
      id: '/_app/(main)/authorizations'
      path: '/authorizations'
      fullPath: '/authorizations'
      preLoaderRoute: typeof AppmainAuthorizationsRouteImport
      parentRoute: typeof AppmainRouteRoute
    }
    '/_app/(main)/activity-board': {
      id: '/_app/(main)/activity-board'
      path: '/activity-board'
      fullPath: '/activity-board'
      preLoaderRoute: typeof AppmainActivityBoardRouteImport
      parentRoute: typeof AppmainRouteRoute
    }
    '/_app/(main)/activity': {
      id: '/_app/(main)/activity'
      path: '/activity'
      fullPath: '/activity'
      preLoaderRoute: typeof AppmainActivityRouteImport
      parentRoute: typeof AppmainRouteRoute
    }
    '/_app/(agent)/agent': {
      id: '/_app/(agent)/agent'
      path: '/agent'
      fullPath: '/agent'
      preLoaderRoute: typeof AppagentAgentRouteImport
      parentRoute: typeof AppagentRouteRoute
    }
    '/_app/settings/notifications': {
      id: '/_app/settings/notifications'
      path: '/notifications'
      fullPath: '/settings/notifications'
      preLoaderRoute: typeof AppSettingsNotificationsRouteRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/admin/extension-lab': {
      id: '/_app/admin/extension-lab'
      path: '/extension-lab'
      fullPath: '/admin/extension-lab'
      preLoaderRoute: typeof AppAdminExtensionLabRouteRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/(extension)/extension-local': {
      id: '/_app/(extension)/extension-local'
      path: '/extension-local'
      fullPath: '/extension-local'
      preLoaderRoute: typeof AppextensionExtensionLocalRouteRouteImport
      parentRoute: typeof AppextensionRouteRoute
    }
    '/_app/(extension)/extension': {
      id: '/_app/(extension)/extension'
      path: '/extension'
      fullPath: '/extension'
      preLoaderRoute: typeof AppextensionExtensionRouteRouteImport
      parentRoute: typeof AppextensionRouteRoute
    }
    '/_app/settings/notifications/': {
      id: '/_app/settings/notifications/'
      path: '/'
      fullPath: '/settings/notifications/'
      preLoaderRoute: typeof AppSettingsNotificationsIndexRouteImport
      parentRoute: typeof AppSettingsNotificationsRouteRoute
    }
    '/_app/admin/voip/': {
      id: '/_app/admin/voip/'
      path: '/voip'
      fullPath: '/admin/voip/'
      preLoaderRoute: typeof AppAdminVoipIndexRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/voice-qa/': {
      id: '/_app/admin/voice-qa/'
      path: '/voice-qa'
      fullPath: '/admin/voice-qa/'
      preLoaderRoute: typeof AppAdminVoiceQaIndexRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/voice-playground/': {
      id: '/_app/admin/voice-playground/'
      path: '/voice-playground'
      fullPath: '/admin/voice-playground/'
      preLoaderRoute: typeof AppAdminVoicePlaygroundIndexRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/voice-evals/': {
      id: '/_app/admin/voice-evals/'
      path: '/voice-evals'
      fullPath: '/admin/voice-evals/'
      preLoaderRoute: typeof AppAdminVoiceEvalsIndexRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/voice-config/': {
      id: '/_app/admin/voice-config/'
      path: '/voice-config'
      fullPath: '/admin/voice-config/'
      preLoaderRoute: typeof AppAdminVoiceConfigIndexRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/users/': {
      id: '/_app/admin/users/'
      path: '/users'
      fullPath: '/admin/users/'
      preLoaderRoute: typeof AppAdminUsersIndexRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/sms-engine-runs/': {
      id: '/_app/admin/sms-engine-runs/'
      path: '/sms-engine-runs'
      fullPath: '/admin/sms-engine-runs/'
      preLoaderRoute: typeof AppAdminSmsEngineRunsIndexRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/shifts/': {
      id: '/_app/admin/shifts/'
      path: '/shifts'
      fullPath: '/admin/shifts/'
      preLoaderRoute: typeof AppAdminShiftsIndexRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/sandbox/': {
      id: '/_app/admin/sandbox/'
      path: '/sandbox'
      fullPath: '/admin/sandbox/'
      preLoaderRoute: typeof AppAdminSandboxIndexRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/revenue/': {
      id: '/_app/admin/revenue/'
      path: '/revenue'
      fullPath: '/admin/revenue/'
      preLoaderRoute: typeof AppAdminRevenueIndexRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/recommendation-explorer/': {
      id: '/_app/admin/recommendation-explorer/'
      path: '/recommendation-explorer'
      fullPath: '/admin/recommendation-explorer/'
      preLoaderRoute: typeof AppAdminRecommendationExplorerIndexRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/outbox/': {
      id: '/_app/admin/outbox/'
      path: '/outbox'
      fullPath: '/admin/outbox/'
      preLoaderRoute: typeof AppAdminOutboxIndexRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/organizations/': {
      id: '/_app/admin/organizations/'
      path: '/organizations'
      fullPath: '/admin/organizations/'
      preLoaderRoute: typeof AppAdminOrganizationsIndexRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/org-distributions/': {
      id: '/_app/admin/org-distributions/'
      path: '/org-distributions'
      fullPath: '/admin/org-distributions/'
      preLoaderRoute: typeof AppAdminOrgDistributionsIndexRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/franchises/': {
      id: '/_app/admin/franchises/'
      path: '/franchises'
      fullPath: '/admin/franchises/'
      preLoaderRoute: typeof AppAdminFranchisesIndexRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/extension-lab/': {
      id: '/_app/admin/extension-lab/'
      path: '/'
      fullPath: '/admin/extension-lab/'
      preLoaderRoute: typeof AppAdminExtensionLabIndexRouteImport
      parentRoute: typeof AppAdminExtensionLabRouteRoute
    }
    '/_app/admin/clients/': {
      id: '/_app/admin/clients/'
      path: '/clients'
      fullPath: '/admin/clients/'
      preLoaderRoute: typeof AppAdminClientsIndexRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/caregivers/': {
      id: '/_app/admin/caregivers/'
      path: '/caregivers'
      fullPath: '/admin/caregivers/'
      preLoaderRoute: typeof AppAdminCaregiversIndexRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/care-coordinators/': {
      id: '/_app/admin/care-coordinators/'
      path: '/care-coordinators'
      fullPath: '/admin/care-coordinators/'
      preLoaderRoute: typeof AppAdminCareCoordinatorsIndexRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/calls/': {
      id: '/_app/admin/calls/'
      path: '/calls'
      fullPath: '/admin/calls/'
      preLoaderRoute: typeof AppAdminCallsIndexRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/automations/': {
      id: '/_app/admin/automations/'
      path: '/automations'
      fullPath: '/admin/automations/'
      preLoaderRoute: typeof AppAdminAutomationsIndexRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/auto-callout-board/': {
      id: '/_app/admin/auto-callout-board/'
      path: '/auto-callout-board'
      fullPath: '/admin/auto-callout-board/'
      preLoaderRoute: typeof AppAdminAutoCalloutBoardIndexRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/analytics/': {
      id: '/_app/admin/analytics/'
      path: '/analytics'
      fullPath: '/admin/analytics/'
      preLoaderRoute: typeof AppAdminAnalyticsIndexRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/agent/': {
      id: '/_app/admin/agent/'
      path: '/agent'
      fullPath: '/admin/agent/'
      preLoaderRoute: typeof AppAdminAgentIndexRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/agent-traces/': {
      id: '/_app/admin/agent-traces/'
      path: '/agent-traces'
      fullPath: '/admin/agent-traces/'
      preLoaderRoute: typeof AppAdminAgentTracesIndexRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/agent-notes/': {
      id: '/_app/admin/agent-notes/'
      path: '/agent-notes'
      fullPath: '/admin/agent-notes/'
      preLoaderRoute: typeof AppAdminAgentNotesIndexRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/accounts/': {
      id: '/_app/admin/accounts/'
      path: '/accounts'
      fullPath: '/admin/accounts/'
      preLoaderRoute: typeof AppAdminAccountsIndexRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/access-tokens/': {
      id: '/_app/admin/access-tokens/'
      path: '/access-tokens'
      fullPath: '/admin/access-tokens/'
      preLoaderRoute: typeof AppAdminAccessTokensIndexRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/(main)/training/': {
      id: '/_app/(main)/training/'
      path: '/'
      fullPath: '/training/'
      preLoaderRoute: typeof AppmainTrainingIndexRouteImport
      parentRoute: typeof AppmainTrainingRoute
    }
    '/_app/(main)/surveys/': {
      id: '/_app/(main)/surveys/'
      path: '/surveys'
      fullPath: '/surveys/'
      preLoaderRoute: typeof AppmainSurveysIndexRouteImport
      parentRoute: typeof AppmainRouteRoute
    }
    '/_app/(main)/shifts/': {
      id: '/_app/(main)/shifts/'
      path: '/shifts'
      fullPath: '/shifts/'
      preLoaderRoute: typeof AppmainShiftsIndexRouteImport
      parentRoute: typeof AppmainRouteRoute
    }
    '/_app/(main)/scheduled/': {
      id: '/_app/(main)/scheduled/'
      path: '/scheduled'
      fullPath: '/scheduled/'
      preLoaderRoute: typeof AppmainScheduledIndexRouteImport
      parentRoute: typeof AppmainRouteRoute
    }
    '/_app/(main)/outreaches/': {
      id: '/_app/(main)/outreaches/'
      path: '/outreaches'
      fullPath: '/outreaches/'
      preLoaderRoute: typeof AppmainOutreachesIndexRouteImport
      parentRoute: typeof AppmainRouteRoute
    }
    '/_app/(main)/conversations/': {
      id: '/_app/(main)/conversations/'
      path: '/conversations'
      fullPath: '/conversations/'
      preLoaderRoute: typeof AppmainConversationsIndexRouteImport
      parentRoute: typeof AppmainRouteRoute
    }
    '/_app/(main)/calendar/': {
      id: '/_app/(main)/calendar/'
      path: '/calendar'
      fullPath: '/calendar/'
      preLoaderRoute: typeof AppmainCalendarIndexRouteImport
      parentRoute: typeof AppmainRouteRoute
    }
    '/_app/(agent)/agent/': {
      id: '/_app/(agent)/agent/'
      path: '/'
      fullPath: '/agent/'
      preLoaderRoute: typeof AppagentAgentIndexRouteImport
      parentRoute: typeof AppagentAgentRoute
    }
    '/_app/settings/notifications/$channel': {
      id: '/_app/settings/notifications/$channel'
      path: '/$channel'
      fullPath: '/settings/notifications/$channel'
      preLoaderRoute: typeof AppSettingsNotificationsChannelRouteImport
      parentRoute: typeof AppSettingsNotificationsRouteRoute
    }
    '/_app/admin/voip/$organization-id': {
      id: '/_app/admin/voip/$organization-id'
      path: '/voip/$organization-id'
      fullPath: '/admin/voip/$organization-id'
      preLoaderRoute: typeof AppAdminVoipOrganizationIdRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/voice-qa/shadow-comparison': {
      id: '/_app/admin/voice-qa/shadow-comparison'
      path: '/voice-qa/shadow-comparison'
      fullPath: '/admin/voice-qa/shadow-comparison'
      preLoaderRoute: typeof AppAdminVoiceQaShadowComparisonRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/voice-qa/$callId': {
      id: '/_app/admin/voice-qa/$callId'
      path: '/voice-qa/$callId'
      fullPath: '/admin/voice-qa/$callId'
      preLoaderRoute: typeof AppAdminVoiceQaCallIdRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/voice-playground/$call-id': {
      id: '/_app/admin/voice-playground/$call-id'
      path: '/voice-playground/$call-id'
      fullPath: '/admin/voice-playground/$call-id'
      preLoaderRoute: typeof AppAdminVoicePlaygroundCallIdRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/voice-evals/compare-case': {
      id: '/_app/admin/voice-evals/compare-case'
      path: '/voice-evals/compare-case'
      fullPath: '/admin/voice-evals/compare-case'
      preLoaderRoute: typeof AppAdminVoiceEvalsCompareCaseRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/voice-evals/compare': {
      id: '/_app/admin/voice-evals/compare'
      path: '/voice-evals/compare'
      fullPath: '/admin/voice-evals/compare'
      preLoaderRoute: typeof AppAdminVoiceEvalsCompareRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/voice-evals/catalog': {
      id: '/_app/admin/voice-evals/catalog'
      path: '/voice-evals/catalog'
      fullPath: '/admin/voice-evals/catalog'
      preLoaderRoute: typeof AppAdminVoiceEvalsCatalogRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/voice-evals/cases': {
      id: '/_app/admin/voice-evals/cases'
      path: '/voice-evals/cases'
      fullPath: '/admin/voice-evals/cases'
      preLoaderRoute: typeof AppAdminVoiceEvalsCasesRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/voice-config/$organization-id': {
      id: '/_app/admin/voice-config/$organization-id'
      path: '/voice-config/$organization-id'
      fullPath: '/admin/voice-config/$organization-id'
      preLoaderRoute: typeof AppAdminVoiceConfigOrganizationIdRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/users/$user-id': {
      id: '/_app/admin/users/$user-id'
      path: '/users/$user-id'
      fullPath: '/admin/users/$user-id'
      preLoaderRoute: typeof AppAdminUsersUserIdRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/sms-engine-runs/$runId': {
      id: '/_app/admin/sms-engine-runs/$runId'
      path: '/sms-engine-runs/$runId'
      fullPath: '/admin/sms-engine-runs/$runId'
      preLoaderRoute: typeof AppAdminSmsEngineRunsRunIdRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/shifts/$shift-id': {
      id: '/_app/admin/shifts/$shift-id'
      path: '/shifts/$shift-id'
      fullPath: '/admin/shifts/$shift-id'
      preLoaderRoute: typeof AppAdminShiftsShiftIdRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/sandbox/$organizationId': {
      id: '/_app/admin/sandbox/$organizationId'
      path: '/sandbox/$organizationId'
      fullPath: '/admin/sandbox/$organizationId'
      preLoaderRoute: typeof AppAdminSandboxOrganizationIdRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/sales/agreements': {
      id: '/_app/admin/sales/agreements'
      path: '/sales/agreements'
      fullPath: '/admin/sales/agreements'
      preLoaderRoute: typeof AppAdminSalesAgreementsRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/revenue/accounts': {
      id: '/_app/admin/revenue/accounts'
      path: '/revenue/accounts'
      fullPath: '/admin/revenue/accounts'
      preLoaderRoute: typeof AppAdminRevenueAccountsRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/revenue/$account-id': {
      id: '/_app/admin/revenue/$account-id'
      path: '/revenue/$account-id'
      fullPath: '/admin/revenue/$account-id'
      preLoaderRoute: typeof AppAdminRevenueAccountIdRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/organizations/$organization-id': {
      id: '/_app/admin/organizations/$organization-id'
      path: '/organizations/$organization-id'
      fullPath: '/admin/organizations/$organization-id'
      preLoaderRoute: typeof AppAdminOrganizationsOrganizationIdRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/clients/$client-id': {
      id: '/_app/admin/clients/$client-id'
      path: '/clients/$client-id'
      fullPath: '/admin/clients/$client-id'
      preLoaderRoute: typeof AppAdminClientsClientIdRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/caregivers/$caregiver-id': {
      id: '/_app/admin/caregivers/$caregiver-id'
      path: '/caregivers/$caregiver-id'
      fullPath: '/admin/caregivers/$caregiver-id'
      preLoaderRoute: typeof AppAdminCaregiversCaregiverIdRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/care-coordinators/$care-coordinator-id': {
      id: '/_app/admin/care-coordinators/$care-coordinator-id'
      path: '/care-coordinators/$care-coordinator-id'
      fullPath: '/admin/care-coordinators/$care-coordinator-id'
      preLoaderRoute: typeof AppAdminCareCoordinatorsCareCoordinatorIdRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/calls/$callId': {
      id: '/_app/admin/calls/$callId'
      path: '/calls/$callId'
      fullPath: '/admin/calls/$callId'
      preLoaderRoute: typeof AppAdminCallsCallIdRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/analytics/$slug': {
      id: '/_app/admin/analytics/$slug'
      path: '/analytics/$slug'
      fullPath: '/admin/analytics/$slug'
      preLoaderRoute: typeof AppAdminAnalyticsSlugRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/agent/tool-telemetry': {
      id: '/_app/admin/agent/tool-telemetry'
      path: '/agent/tool-telemetry'
      fullPath: '/admin/agent/tool-telemetry'
      preLoaderRoute: typeof AppAdminAgentToolTelemetryRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/agent/missing-tools': {
      id: '/_app/admin/agent/missing-tools'
      path: '/agent/missing-tools'
      fullPath: '/admin/agent/missing-tools'
      preLoaderRoute: typeof AppAdminAgentMissingToolsRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/agent/capabilities': {
      id: '/_app/admin/agent/capabilities'
      path: '/agent/capabilities'
      fullPath: '/admin/agent/capabilities'
      preLoaderRoute: typeof AppAdminAgentCapabilitiesRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/agent/$runId': {
      id: '/_app/admin/agent/$runId'
      path: '/agent/$runId'
      fullPath: '/admin/agent/$runId'
      preLoaderRoute: typeof AppAdminAgentRunIdRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/agent-traces/ephemeral': {
      id: '/_app/admin/agent-traces/ephemeral'
      path: '/agent-traces/ephemeral'
      fullPath: '/admin/agent-traces/ephemeral'
      preLoaderRoute: typeof AppAdminAgentTracesEphemeralRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/agent-traces/$conversationId': {
      id: '/_app/admin/agent-traces/$conversationId'
      path: '/agent-traces/$conversationId'
      fullPath: '/admin/agent-traces/$conversationId'
      preLoaderRoute: typeof AppAdminAgentTracesConversationIdRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/agent-notes/$note-id': {
      id: '/_app/admin/agent-notes/$note-id'
      path: '/agent-notes/$note-id'
      fullPath: '/admin/agent-notes/$note-id'
      preLoaderRoute: typeof AppAdminAgentNotesNoteIdRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/accounts/$accountId': {
      id: '/_app/admin/accounts/$accountId'
      path: '/accounts/$accountId'
      fullPath: '/admin/accounts/$accountId'
      preLoaderRoute: typeof AppAdminAccountsAccountIdRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/(main)/training/onboarding': {
      id: '/_app/(main)/training/onboarding'
      path: '/onboarding'
      fullPath: '/training/onboarding'
      preLoaderRoute: typeof AppmainTrainingOnboardingRouteImport
      parentRoute: typeof AppmainTrainingRoute
    }
    '/_app/(main)/training/demo': {
      id: '/_app/(main)/training/demo'
      path: '/demo'
      fullPath: '/training/demo'
      preLoaderRoute: typeof AppmainTrainingDemoRouteImport
      parentRoute: typeof AppmainTrainingRoute
    }
    '/_app/(main)/training/announcement': {
      id: '/_app/(main)/training/announcement'
      path: '/announcement'
      fullPath: '/training/announcement'
      preLoaderRoute: typeof AppmainTrainingAnnouncementRouteImport
      parentRoute: typeof AppmainTrainingRoute
    }
    '/_app/(main)/surveys/create': {
      id: '/_app/(main)/surveys/create'
      path: '/surveys/create'
      fullPath: '/surveys/create'
      preLoaderRoute: typeof AppmainSurveysCreateRouteImport
      parentRoute: typeof AppmainRouteRoute
    }
    '/_app/(main)/surveys/$survey-id': {
      id: '/_app/(main)/surveys/$survey-id'
      path: '/surveys/$survey-id'
      fullPath: '/surveys/$survey-id'
      preLoaderRoute: typeof AppmainSurveysSurveyIdRouteImport
      parentRoute: typeof AppmainRouteRoute
    }
    '/_app/(main)/shifts/$shift-id': {
      id: '/_app/(main)/shifts/$shift-id'
      path: '/shifts/$shift-id'
      fullPath: '/shifts/$shift-id'
      preLoaderRoute: typeof AppmainShiftsShiftIdRouteImport
      parentRoute: typeof AppmainRouteRoute
    }
    '/_app/(main)/outreaches/$callout-id': {
      id: '/_app/(main)/outreaches/$callout-id'
      path: '/outreaches/$callout-id'
      fullPath: '/outreaches/$callout-id'
      preLoaderRoute: typeof AppmainOutreachesCalloutIdRouteImport
      parentRoute: typeof AppmainRouteRoute
    }
    '/_app/admin/agent/scratchpad/': {
      id: '/_app/admin/agent/scratchpad/'
      path: '/agent/scratchpad'
      fullPath: '/admin/agent/scratchpad/'
      preLoaderRoute: typeof AppAdminAgentScratchpadIndexRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/agent/pages/': {
      id: '/_app/admin/agent/pages/'
      path: '/agent/pages'
      fullPath: '/admin/agent/pages/'
      preLoaderRoute: typeof AppAdminAgentPagesIndexRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/agent/automations/': {
      id: '/_app/admin/agent/automations/'
      path: '/agent/automations'
      fullPath: '/admin/agent/automations/'
      preLoaderRoute: typeof AppAdminAgentAutomationsIndexRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/agent/actions/': {
      id: '/_app/admin/agent/actions/'
      path: '/agent/actions'
      fullPath: '/admin/agent/actions/'
      preLoaderRoute: typeof AppAdminAgentActionsIndexRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/automations/$organizationId/$automationId': {
      id: '/_app/admin/automations/$organizationId/$automationId'
      path: '/automations/$organizationId/$automationId'
      fullPath: '/admin/automations/$organizationId/$automationId'
      preLoaderRoute: typeof AppAdminAutomationsOrganizationIdAutomationIdRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/agent/scratchpad/$note-id': {
      id: '/_app/admin/agent/scratchpad/$note-id'
      path: '/agent/scratchpad/$note-id'
      fullPath: '/admin/agent/scratchpad/$note-id'
      preLoaderRoute: typeof AppAdminAgentScratchpadNoteIdRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/agent/pages/$slug': {
      id: '/_app/admin/agent/pages/$slug'
      path: '/agent/pages/$slug'
      fullPath: '/admin/agent/pages/$slug'
      preLoaderRoute: typeof AppAdminAgentPagesSlugRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/agent/automations/runs': {
      id: '/_app/admin/agent/automations/runs'
      path: '/agent/automations/runs'
      fullPath: '/admin/agent/automations/runs'
      preLoaderRoute: typeof AppAdminAgentAutomationsRunsRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/agent/automations/list': {
      id: '/_app/admin/agent/automations/list'
      path: '/agent/automations/list'
      fullPath: '/admin/agent/automations/list'
      preLoaderRoute: typeof AppAdminAgentAutomationsListRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/agent/actions/$audit-id': {
      id: '/_app/admin/agent/actions/$audit-id'
      path: '/agent/actions/$audit-id'
      fullPath: '/admin/agent/actions/$audit-id'
      preLoaderRoute: typeof AppAdminAgentActionsAuditIdRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/agent-traces/run/$runId': {
      id: '/_app/admin/agent-traces/run/$runId'
      path: '/agent-traces/run/$runId'
      fullPath: '/admin/agent-traces/run/$runId'
      preLoaderRoute: typeof AppAdminAgentTracesRunRunIdRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/(main)/outreaches/survey/create': {
      id: '/_app/(main)/outreaches/survey/create'
      path: '/outreaches/survey/create'
      fullPath: '/outreaches/survey/create'
      preLoaderRoute: typeof AppmainOutreachesSurveyCreateRouteImport
      parentRoute: typeof AppmainRouteRoute
    }
    '/_app/(main)/outreaches/survey/$survey-id': {
      id: '/_app/(main)/outreaches/survey/$survey-id'
      path: '/outreaches/survey/$survey-id'
      fullPath: '/outreaches/survey/$survey-id'
      preLoaderRoute: typeof AppmainOutreachesSurveySurveyIdRouteImport
      parentRoute: typeof AppmainRouteRoute
    }
    '/_app/(main)/outreaches/message/create': {
      id: '/_app/(main)/outreaches/message/create'
      path: '/outreaches/message/create'
      fullPath: '/outreaches/message/create'
      preLoaderRoute: typeof AppmainOutreachesMessageCreateRouteImport
      parentRoute: typeof AppmainRouteRoute
    }
    '/_app/(main)/outreaches/message/$message-id': {
      id: '/_app/(main)/outreaches/message/$message-id'
      path: '/outreaches/message/$message-id'
      fullPath: '/outreaches/message/$message-id'
      preLoaderRoute: typeof AppmainOutreachesMessageMessageIdRouteImport
      parentRoute: typeof AppmainRouteRoute
    }
    '/_app/(agent)/agent/runs/$runId': {
      id: '/_app/(agent)/agent/runs/$runId'
      path: '/runs/$runId'
      fullPath: '/agent/runs/$runId'
      preLoaderRoute: typeof AppagentAgentRunsRunIdRouteImport
      parentRoute: typeof AppagentAgentRoute
    }
    '/_app/admin/voice-evals/runs/$runId/': {
      id: '/_app/admin/voice-evals/runs/$runId/'
      path: '/voice-evals/runs/$runId'
      fullPath: '/admin/voice-evals/runs/$runId/'
      preLoaderRoute: typeof AppAdminVoiceEvalsRunsRunIdIndexRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/automations/$organizationId/$automationId/': {
      id: '/_app/admin/automations/$organizationId/$automationId/'
      path: '/'
      fullPath: '/admin/automations/$organizationId/$automationId/'
      preLoaderRoute: typeof AppAdminAutomationsOrganizationIdAutomationIdIndexRouteImport
      parentRoute: typeof AppAdminAutomationsOrganizationIdAutomationIdRoute
    }
    '/_app/admin/agent/automations/$organizationId/$automationId': {
      id: '/_app/admin/agent/automations/$organizationId/$automationId'
      path: '/agent/automations/$organizationId/$automationId'
      fullPath: '/admin/agent/automations/$organizationId/$automationId'
      preLoaderRoute: typeof AppAdminAgentAutomationsOrganizationIdAutomationIdRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/(main)/extension-review/calendar/php/unassigned': {
      id: '/_app/(main)/extension-review/calendar/php/unassigned'
      path: '/extension-review/calendar/php/unassigned'
      fullPath: '/extension-review/calendar/php/unassigned'
      preLoaderRoute: typeof AppmainExtensionReviewCalendarPhpUnassignedRouteImport
      parentRoute: typeof AppmainRouteRoute
    }
    '/_app/admin/agent/automations/$organizationId/$automationId/': {
      id: '/_app/admin/agent/automations/$organizationId/$automationId/'
      path: '/'
      fullPath: '/admin/agent/automations/$organizationId/$automationId/'
      preLoaderRoute: typeof AppAdminAgentAutomationsOrganizationIdAutomationIdIndexRouteImport
      parentRoute: typeof AppAdminAgentAutomationsOrganizationIdAutomationIdRoute
    }
    '/_app/admin/voice-evals/runs/$runId/cases/$caseResultId': {
      id: '/_app/admin/voice-evals/runs/$runId/cases/$caseResultId'
      path: '/voice-evals/runs/$runId/cases/$caseResultId'
      fullPath: '/admin/voice-evals/runs/$runId/cases/$caseResultId'
      preLoaderRoute: typeof AppAdminVoiceEvalsRunsRunIdCasesCaseResultIdRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/extension-lab/ehr/$provider/$entity/$externalId': {
      id: '/_app/admin/extension-lab/ehr/$provider/$entity/$externalId'
      path: '/ehr/$provider/$entity/$externalId'
      fullPath: '/admin/extension-lab/ehr/$provider/$entity/$externalId'
      preLoaderRoute: typeof AppAdminExtensionLabEhrProviderEntityExternalIdRouteImport
      parentRoute: typeof AppAdminExtensionLabRouteRoute
    }
    '/_app/admin/automations/$organizationId/$automationId/runs/$automationRunId': {
      id: '/_app/admin/automations/$organizationId/$automationId/runs/$automationRunId'
      path: '/runs/$automationRunId'
      fullPath: '/admin/automations/$organizationId/$automationId/runs/$automationRunId'
      preLoaderRoute: typeof AppAdminAutomationsOrganizationIdAutomationIdRunsAutomationRunIdRouteImport
      parentRoute: typeof AppAdminAutomationsOrganizationIdAutomationIdRoute
    }
    '/_app/admin/agent/runs/$runId/artifacts/$artifactId': {
      id: '/_app/admin/agent/runs/$runId/artifacts/$artifactId'
      path: '/agent/runs/$runId/artifacts/$artifactId'
      fullPath: '/admin/agent/runs/$runId/artifacts/$artifactId'
      preLoaderRoute: typeof AppAdminAgentRunsRunIdArtifactsArtifactIdRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/agent/automations/$organizationId/$automationId/runs/$automationRunId': {
      id: '/_app/admin/agent/automations/$organizationId/$automationId/runs/$automationRunId'
      path: '/runs/$automationRunId'
      fullPath: '/admin/agent/automations/$organizationId/$automationId/runs/$automationRunId'
      preLoaderRoute: typeof AppAdminAgentAutomationsOrganizationIdAutomationIdRunsAutomationRunIdRouteImport
      parentRoute: typeof AppAdminAgentAutomationsOrganizationIdAutomationIdRoute
    }
  }
}

interface AppagentAgentRouteChildren {
  AppagentAgentIndexRoute: typeof AppagentAgentIndexRoute
  AppagentAgentRunsRunIdRoute: typeof AppagentAgentRunsRunIdRoute
}

const AppagentAgentRouteChildren: AppagentAgentRouteChildren = {
  AppagentAgentIndexRoute: AppagentAgentIndexRoute,
  AppagentAgentRunsRunIdRoute: AppagentAgentRunsRunIdRoute,
}

const AppagentAgentRouteWithChildren = AppagentAgentRoute._addFileChildren(
  AppagentAgentRouteChildren,
)

interface AppagentRouteRouteChildren {
  AppagentAgentRoute: typeof AppagentAgentRouteWithChildren
}

const AppagentRouteRouteChildren: AppagentRouteRouteChildren = {
  AppagentAgentRoute: AppagentAgentRouteWithChildren,
}

const AppagentRouteRouteWithChildren = AppagentRouteRoute._addFileChildren(
  AppagentRouteRouteChildren,
)

interface AppextensionRouteRouteChildren {
  AppextensionExtensionRouteRoute: typeof AppextensionExtensionRouteRoute
  AppextensionExtensionLocalRouteRoute: typeof AppextensionExtensionLocalRouteRoute
}

const AppextensionRouteRouteChildren: AppextensionRouteRouteChildren = {
  AppextensionExtensionRouteRoute: AppextensionExtensionRouteRoute,
  AppextensionExtensionLocalRouteRoute: AppextensionExtensionLocalRouteRoute,
}

const AppextensionRouteRouteWithChildren =
  AppextensionRouteRoute._addFileChildren(AppextensionRouteRouteChildren)

interface AppmainTrainingRouteChildren {
  AppmainTrainingAnnouncementRoute: typeof AppmainTrainingAnnouncementRoute
  AppmainTrainingDemoRoute: typeof AppmainTrainingDemoRoute
  AppmainTrainingOnboardingRoute: typeof AppmainTrainingOnboardingRoute
  AppmainTrainingIndexRoute: typeof AppmainTrainingIndexRoute
}

const AppmainTrainingRouteChildren: AppmainTrainingRouteChildren = {
  AppmainTrainingAnnouncementRoute: AppmainTrainingAnnouncementRoute,
  AppmainTrainingDemoRoute: AppmainTrainingDemoRoute,
  AppmainTrainingOnboardingRoute: AppmainTrainingOnboardingRoute,
  AppmainTrainingIndexRoute: AppmainTrainingIndexRoute,
}

const AppmainTrainingRouteWithChildren = AppmainTrainingRoute._addFileChildren(
  AppmainTrainingRouteChildren,
)

interface AppmainRouteRouteChildren {
  AppmainActivityRoute: typeof AppmainActivityRoute
  AppmainActivityBoardRoute: typeof AppmainActivityBoardRoute
  AppmainAuthorizationsRoute: typeof AppmainAuthorizationsRoute
  AppmainAutomationsRoute: typeof AppmainAutomationsRoute
  AppmainCalloutsRoute: typeof AppmainCalloutsRoute
  AppmainCaregiversRoute: typeof AppmainCaregiversRoute
  AppmainClientsRoute: typeof AppmainClientsRoute
  AppmainCoverageRoute: typeof AppmainCoverageRoute
  AppmainDryRunReportRoute: typeof AppmainDryRunReportRoute
  AppmainHomeRoute: typeof AppmainHomeRoute
  AppmainLeaderboardRoute: typeof AppmainLeaderboardRoute
  AppmainLearnPhoebeRoute: typeof AppmainLearnPhoebeRoute
  AppmainMetricsRoute: typeof AppmainMetricsRoute
  AppmainPhoneRoute: typeof AppmainPhoneRoute
  AppmainPlaybooksRoute: typeof AppmainPlaybooksRoute
  AppmainReferralsRoute: typeof AppmainReferralsRoute
  AppmainTeachPhoebeRoute: typeof AppmainTeachPhoebeRoute
  AppmainTrainingRoute: typeof AppmainTrainingRouteWithChildren
  AppmainVoiceCallsRoute: typeof AppmainVoiceCallsRoute
  AppmainIndexRoute: typeof AppmainIndexRoute
  AppmainOutreachesCalloutIdRoute: typeof AppmainOutreachesCalloutIdRoute
  AppmainShiftsShiftIdRoute: typeof AppmainShiftsShiftIdRoute
  AppmainSurveysSurveyIdRoute: typeof AppmainSurveysSurveyIdRoute
  AppmainSurveysCreateRoute: typeof AppmainSurveysCreateRoute
  AppmainCalendarIndexRoute: typeof AppmainCalendarIndexRoute
  AppmainConversationsIndexRoute: typeof AppmainConversationsIndexRoute
  AppmainOutreachesIndexRoute: typeof AppmainOutreachesIndexRoute
  AppmainScheduledIndexRoute: typeof AppmainScheduledIndexRoute
  AppmainShiftsIndexRoute: typeof AppmainShiftsIndexRoute
  AppmainSurveysIndexRoute: typeof AppmainSurveysIndexRoute
  AppmainOutreachesMessageMessageIdRoute: typeof AppmainOutreachesMessageMessageIdRoute
  AppmainOutreachesMessageCreateRoute: typeof AppmainOutreachesMessageCreateRoute
  AppmainOutreachesSurveySurveyIdRoute: typeof AppmainOutreachesSurveySurveyIdRoute
  AppmainOutreachesSurveyCreateRoute: typeof AppmainOutreachesSurveyCreateRoute
  AppmainExtensionReviewCalendarPhpUnassignedRoute: typeof AppmainExtensionReviewCalendarPhpUnassignedRoute
}

const AppmainRouteRouteChildren: AppmainRouteRouteChildren = {
  AppmainActivityRoute: AppmainActivityRoute,
  AppmainActivityBoardRoute: AppmainActivityBoardRoute,
  AppmainAuthorizationsRoute: AppmainAuthorizationsRoute,
  AppmainAutomationsRoute: AppmainAutomationsRoute,
  AppmainCalloutsRoute: AppmainCalloutsRoute,
  AppmainCaregiversRoute: AppmainCaregiversRoute,
  AppmainClientsRoute: AppmainClientsRoute,
  AppmainCoverageRoute: AppmainCoverageRoute,
  AppmainDryRunReportRoute: AppmainDryRunReportRoute,
  AppmainHomeRoute: AppmainHomeRoute,
  AppmainLeaderboardRoute: AppmainLeaderboardRoute,
  AppmainLearnPhoebeRoute: AppmainLearnPhoebeRoute,
  AppmainMetricsRoute: AppmainMetricsRoute,
  AppmainPhoneRoute: AppmainPhoneRoute,
  AppmainPlaybooksRoute: AppmainPlaybooksRoute,
  AppmainReferralsRoute: AppmainReferralsRoute,
  AppmainTeachPhoebeRoute: AppmainTeachPhoebeRoute,
  AppmainTrainingRoute: AppmainTrainingRouteWithChildren,
  AppmainVoiceCallsRoute: AppmainVoiceCallsRoute,
  AppmainIndexRoute: AppmainIndexRoute,
  AppmainOutreachesCalloutIdRoute: AppmainOutreachesCalloutIdRoute,
  AppmainShiftsShiftIdRoute: AppmainShiftsShiftIdRoute,
  AppmainSurveysSurveyIdRoute: AppmainSurveysSurveyIdRoute,
  AppmainSurveysCreateRoute: AppmainSurveysCreateRoute,
  AppmainCalendarIndexRoute: AppmainCalendarIndexRoute,
  AppmainConversationsIndexRoute: AppmainConversationsIndexRoute,
  AppmainOutreachesIndexRoute: AppmainOutreachesIndexRoute,
  AppmainScheduledIndexRoute: AppmainScheduledIndexRoute,
  AppmainShiftsIndexRoute: AppmainShiftsIndexRoute,
  AppmainSurveysIndexRoute: AppmainSurveysIndexRoute,
  AppmainOutreachesMessageMessageIdRoute:
    AppmainOutreachesMessageMessageIdRoute,
  AppmainOutreachesMessageCreateRoute: AppmainOutreachesMessageCreateRoute,
  AppmainOutreachesSurveySurveyIdRoute: AppmainOutreachesSurveySurveyIdRoute,
  AppmainOutreachesSurveyCreateRoute: AppmainOutreachesSurveyCreateRoute,
  AppmainExtensionReviewCalendarPhpUnassignedRoute:
    AppmainExtensionReviewCalendarPhpUnassignedRoute,
}

const AppmainRouteRouteWithChildren = AppmainRouteRoute._addFileChildren(
  AppmainRouteRouteChildren,
)

interface AppAdminExtensionLabRouteRouteChildren {
  AppAdminExtensionLabIndexRoute: typeof AppAdminExtensionLabIndexRoute
  AppAdminExtensionLabEhrProviderEntityExternalIdRoute: typeof AppAdminExtensionLabEhrProviderEntityExternalIdRoute
}

const AppAdminExtensionLabRouteRouteChildren: AppAdminExtensionLabRouteRouteChildren =
  {
    AppAdminExtensionLabIndexRoute: AppAdminExtensionLabIndexRoute,
    AppAdminExtensionLabEhrProviderEntityExternalIdRoute:
      AppAdminExtensionLabEhrProviderEntityExternalIdRoute,
  }

const AppAdminExtensionLabRouteRouteWithChildren =
  AppAdminExtensionLabRouteRoute._addFileChildren(
    AppAdminExtensionLabRouteRouteChildren,
  )

interface AppAdminAutomationsOrganizationIdAutomationIdRouteChildren {
  AppAdminAutomationsOrganizationIdAutomationIdIndexRoute: typeof AppAdminAutomationsOrganizationIdAutomationIdIndexRoute
  AppAdminAutomationsOrganizationIdAutomationIdRunsAutomationRunIdRoute: typeof AppAdminAutomationsOrganizationIdAutomationIdRunsAutomationRunIdRoute
}

const AppAdminAutomationsOrganizationIdAutomationIdRouteChildren: AppAdminAutomationsOrganizationIdAutomationIdRouteChildren =
  {
    AppAdminAutomationsOrganizationIdAutomationIdIndexRoute:
      AppAdminAutomationsOrganizationIdAutomationIdIndexRoute,
    AppAdminAutomationsOrganizationIdAutomationIdRunsAutomationRunIdRoute:
      AppAdminAutomationsOrganizationIdAutomationIdRunsAutomationRunIdRoute,
  }

const AppAdminAutomationsOrganizationIdAutomationIdRouteWithChildren =
  AppAdminAutomationsOrganizationIdAutomationIdRoute._addFileChildren(
    AppAdminAutomationsOrganizationIdAutomationIdRouteChildren,
  )

interface AppAdminAgentAutomationsOrganizationIdAutomationIdRouteChildren {
  AppAdminAgentAutomationsOrganizationIdAutomationIdIndexRoute: typeof AppAdminAgentAutomationsOrganizationIdAutomationIdIndexRoute
  AppAdminAgentAutomationsOrganizationIdAutomationIdRunsAutomationRunIdRoute: typeof AppAdminAgentAutomationsOrganizationIdAutomationIdRunsAutomationRunIdRoute
}

const AppAdminAgentAutomationsOrganizationIdAutomationIdRouteChildren: AppAdminAgentAutomationsOrganizationIdAutomationIdRouteChildren =
  {
    AppAdminAgentAutomationsOrganizationIdAutomationIdIndexRoute:
      AppAdminAgentAutomationsOrganizationIdAutomationIdIndexRoute,
    AppAdminAgentAutomationsOrganizationIdAutomationIdRunsAutomationRunIdRoute:
      AppAdminAgentAutomationsOrganizationIdAutomationIdRunsAutomationRunIdRoute,
  }

const AppAdminAgentAutomationsOrganizationIdAutomationIdRouteWithChildren =
  AppAdminAgentAutomationsOrganizationIdAutomationIdRoute._addFileChildren(
    AppAdminAgentAutomationsOrganizationIdAutomationIdRouteChildren,
  )

interface AppAdminRouteRouteChildren {
  AppAdminExtensionLabRouteRoute: typeof AppAdminExtensionLabRouteRouteWithChildren
  AppAdminAgentAnalysisRoute: typeof AppAdminAgentAnalysisRoute
  AppAdminAgentToolsRoute: typeof AppAdminAgentToolsRoute
  AppAdminAmdShadowRoute: typeof AppAdminAmdShadowRoute
  AppAdminCarePlanPreviewerRoute: typeof AppAdminCarePlanPreviewerRoute
  AppAdminCaregiverSimRoute: typeof AppAdminCaregiverSimRoute
  AppAdminDataQualityRoute: typeof AppAdminDataQualityRoute
  AppAdminDataSyncRoute: typeof AppAdminDataSyncRoute
  AppAdminDemoOrgRoute: typeof AppAdminDemoOrgRoute
  AppAdminDesignKitRoute: typeof AppAdminDesignKitRoute
  AppAdminDocumentIngestionRoute: typeof AppAdminDocumentIngestionRoute
  AppAdminFlagsRoute: typeof AppAdminFlagsRoute
  AppAdminImessageRoute: typeof AppAdminImessageRoute
  AppAdminImessageRequestsRoute: typeof AppAdminImessageRequestsRoute
  AppAdminMessageQueueRoute: typeof AppAdminMessageQueueRoute
  AppAdminNotificationsLabRoute: typeof AppAdminNotificationsLabRoute
  AppAdminOrgSnapshotsRoute: typeof AppAdminOrgSnapshotsRoute
  AppAdminOrganizationDefaultSettingsRoute: typeof AppAdminOrganizationDefaultSettingsRoute
  AppAdminOutreachObservabilityRoute: typeof AppAdminOutreachObservabilityRoute
  AppAdminOutreachesRoute: typeof AppAdminOutreachesRoute
  AppAdminPromptRolloutRoute: typeof AppAdminPromptRolloutRoute
  AppAdminQualityScoreboardRoute: typeof AppAdminQualityScoreboardRoute
  AppAdminReportGeneratorRoute: typeof AppAdminReportGeneratorRoute
  AppAdminSearchRoute: typeof AppAdminSearchRoute
  AppAdminShiftAssignmentHealthRoute: typeof AppAdminShiftAssignmentHealthRoute
  AppAdminSimulatorWorldRoute: typeof AppAdminSimulatorWorldRoute
  AppAdminSmsDebugRoute: typeof AppAdminSmsDebugRoute
  AppAdminSyncSettingsRoute: typeof AppAdminSyncSettingsRoute
  AppAdminTagMatchingRoute: typeof AppAdminTagMatchingRoute
  AppAdminTamMapRoute: typeof AppAdminTamMapRoute
  AppAdminUiComponentsRoute: typeof AppAdminUiComponentsRoute
  AppAdminVoiceRoute: typeof AppAdminVoiceRoute
  AppAdminVoiceLatencyRoute: typeof AppAdminVoiceLatencyRoute
  AppAdminIndexRoute: typeof AppAdminIndexRoute
  AppAdminAccountsAccountIdRoute: typeof AppAdminAccountsAccountIdRoute
  AppAdminAgentNotesNoteIdRoute: typeof AppAdminAgentNotesNoteIdRoute
  AppAdminAgentTracesConversationIdRoute: typeof AppAdminAgentTracesConversationIdRoute
  AppAdminAgentTracesEphemeralRoute: typeof AppAdminAgentTracesEphemeralRoute
  AppAdminAgentRunIdRoute: typeof AppAdminAgentRunIdRoute
  AppAdminAgentCapabilitiesRoute: typeof AppAdminAgentCapabilitiesRoute
  AppAdminAgentMissingToolsRoute: typeof AppAdminAgentMissingToolsRoute
  AppAdminAgentToolTelemetryRoute: typeof AppAdminAgentToolTelemetryRoute
  AppAdminAnalyticsSlugRoute: typeof AppAdminAnalyticsSlugRoute
  AppAdminCallsCallIdRoute: typeof AppAdminCallsCallIdRoute
  AppAdminCareCoordinatorsCareCoordinatorIdRoute: typeof AppAdminCareCoordinatorsCareCoordinatorIdRoute
  AppAdminCaregiversCaregiverIdRoute: typeof AppAdminCaregiversCaregiverIdRoute
  AppAdminClientsClientIdRoute: typeof AppAdminClientsClientIdRoute
  AppAdminOrganizationsOrganizationIdRoute: typeof AppAdminOrganizationsOrganizationIdRoute
  AppAdminRevenueAccountIdRoute: typeof AppAdminRevenueAccountIdRoute
  AppAdminRevenueAccountsRoute: typeof AppAdminRevenueAccountsRoute
  AppAdminSalesAgreementsRoute: typeof AppAdminSalesAgreementsRoute
  AppAdminSandboxOrganizationIdRoute: typeof AppAdminSandboxOrganizationIdRoute
  AppAdminShiftsShiftIdRoute: typeof AppAdminShiftsShiftIdRoute
  AppAdminSmsEngineRunsRunIdRoute: typeof AppAdminSmsEngineRunsRunIdRoute
  AppAdminUsersUserIdRoute: typeof AppAdminUsersUserIdRoute
  AppAdminVoiceConfigOrganizationIdRoute: typeof AppAdminVoiceConfigOrganizationIdRoute
  AppAdminVoiceEvalsCasesRoute: typeof AppAdminVoiceEvalsCasesRoute
  AppAdminVoiceEvalsCatalogRoute: typeof AppAdminVoiceEvalsCatalogRoute
  AppAdminVoiceEvalsCompareRoute: typeof AppAdminVoiceEvalsCompareRoute
  AppAdminVoiceEvalsCompareCaseRoute: typeof AppAdminVoiceEvalsCompareCaseRoute
  AppAdminVoicePlaygroundCallIdRoute: typeof AppAdminVoicePlaygroundCallIdRoute
  AppAdminVoiceQaCallIdRoute: typeof AppAdminVoiceQaCallIdRoute
  AppAdminVoiceQaShadowComparisonRoute: typeof AppAdminVoiceQaShadowComparisonRoute
  AppAdminVoipOrganizationIdRoute: typeof AppAdminVoipOrganizationIdRoute
  AppAdminAccessTokensIndexRoute: typeof AppAdminAccessTokensIndexRoute
  AppAdminAccountsIndexRoute: typeof AppAdminAccountsIndexRoute
  AppAdminAgentNotesIndexRoute: typeof AppAdminAgentNotesIndexRoute
  AppAdminAgentTracesIndexRoute: typeof AppAdminAgentTracesIndexRoute
  AppAdminAgentIndexRoute: typeof AppAdminAgentIndexRoute
  AppAdminAnalyticsIndexRoute: typeof AppAdminAnalyticsIndexRoute
  AppAdminAutoCalloutBoardIndexRoute: typeof AppAdminAutoCalloutBoardIndexRoute
  AppAdminAutomationsIndexRoute: typeof AppAdminAutomationsIndexRoute
  AppAdminCallsIndexRoute: typeof AppAdminCallsIndexRoute
  AppAdminCareCoordinatorsIndexRoute: typeof AppAdminCareCoordinatorsIndexRoute
  AppAdminCaregiversIndexRoute: typeof AppAdminCaregiversIndexRoute
  AppAdminClientsIndexRoute: typeof AppAdminClientsIndexRoute
  AppAdminFranchisesIndexRoute: typeof AppAdminFranchisesIndexRoute
  AppAdminOrgDistributionsIndexRoute: typeof AppAdminOrgDistributionsIndexRoute
  AppAdminOrganizationsIndexRoute: typeof AppAdminOrganizationsIndexRoute
  AppAdminOutboxIndexRoute: typeof AppAdminOutboxIndexRoute
  AppAdminRecommendationExplorerIndexRoute: typeof AppAdminRecommendationExplorerIndexRoute
  AppAdminRevenueIndexRoute: typeof AppAdminRevenueIndexRoute
  AppAdminSandboxIndexRoute: typeof AppAdminSandboxIndexRoute
  AppAdminShiftsIndexRoute: typeof AppAdminShiftsIndexRoute
  AppAdminSmsEngineRunsIndexRoute: typeof AppAdminSmsEngineRunsIndexRoute
  AppAdminUsersIndexRoute: typeof AppAdminUsersIndexRoute
  AppAdminVoiceConfigIndexRoute: typeof AppAdminVoiceConfigIndexRoute
  AppAdminVoiceEvalsIndexRoute: typeof AppAdminVoiceEvalsIndexRoute
  AppAdminVoicePlaygroundIndexRoute: typeof AppAdminVoicePlaygroundIndexRoute
  AppAdminVoiceQaIndexRoute: typeof AppAdminVoiceQaIndexRoute
  AppAdminVoipIndexRoute: typeof AppAdminVoipIndexRoute
  AppAdminAgentTracesRunRunIdRoute: typeof AppAdminAgentTracesRunRunIdRoute
  AppAdminAgentActionsAuditIdRoute: typeof AppAdminAgentActionsAuditIdRoute
  AppAdminAgentAutomationsListRoute: typeof AppAdminAgentAutomationsListRoute
  AppAdminAgentAutomationsRunsRoute: typeof AppAdminAgentAutomationsRunsRoute
  AppAdminAgentPagesSlugRoute: typeof AppAdminAgentPagesSlugRoute
  AppAdminAgentScratchpadNoteIdRoute: typeof AppAdminAgentScratchpadNoteIdRoute
  AppAdminAutomationsOrganizationIdAutomationIdRoute: typeof AppAdminAutomationsOrganizationIdAutomationIdRouteWithChildren
  AppAdminAgentActionsIndexRoute: typeof AppAdminAgentActionsIndexRoute
  AppAdminAgentAutomationsIndexRoute: typeof AppAdminAgentAutomationsIndexRoute
  AppAdminAgentPagesIndexRoute: typeof AppAdminAgentPagesIndexRoute
  AppAdminAgentScratchpadIndexRoute: typeof AppAdminAgentScratchpadIndexRoute
  AppAdminAgentAutomationsOrganizationIdAutomationIdRoute: typeof AppAdminAgentAutomationsOrganizationIdAutomationIdRouteWithChildren
  AppAdminVoiceEvalsRunsRunIdIndexRoute: typeof AppAdminVoiceEvalsRunsRunIdIndexRoute
  AppAdminAgentRunsRunIdArtifactsArtifactIdRoute: typeof AppAdminAgentRunsRunIdArtifactsArtifactIdRoute
  AppAdminVoiceEvalsRunsRunIdCasesCaseResultIdRoute: typeof AppAdminVoiceEvalsRunsRunIdCasesCaseResultIdRoute
}

const AppAdminRouteRouteChildren: AppAdminRouteRouteChildren = {
  AppAdminExtensionLabRouteRoute: AppAdminExtensionLabRouteRouteWithChildren,
  AppAdminAgentAnalysisRoute: AppAdminAgentAnalysisRoute,
  AppAdminAgentToolsRoute: AppAdminAgentToolsRoute,
  AppAdminAmdShadowRoute: AppAdminAmdShadowRoute,
  AppAdminCarePlanPreviewerRoute: AppAdminCarePlanPreviewerRoute,
  AppAdminCaregiverSimRoute: AppAdminCaregiverSimRoute,
  AppAdminDataQualityRoute: AppAdminDataQualityRoute,
  AppAdminDataSyncRoute: AppAdminDataSyncRoute,
  AppAdminDemoOrgRoute: AppAdminDemoOrgRoute,
  AppAdminDesignKitRoute: AppAdminDesignKitRoute,
  AppAdminDocumentIngestionRoute: AppAdminDocumentIngestionRoute,
  AppAdminFlagsRoute: AppAdminFlagsRoute,
  AppAdminImessageRoute: AppAdminImessageRoute,
  AppAdminImessageRequestsRoute: AppAdminImessageRequestsRoute,
  AppAdminMessageQueueRoute: AppAdminMessageQueueRoute,
  AppAdminNotificationsLabRoute: AppAdminNotificationsLabRoute,
  AppAdminOrgSnapshotsRoute: AppAdminOrgSnapshotsRoute,
  AppAdminOrganizationDefaultSettingsRoute:
    AppAdminOrganizationDefaultSettingsRoute,
  AppAdminOutreachObservabilityRoute: AppAdminOutreachObservabilityRoute,
  AppAdminOutreachesRoute: AppAdminOutreachesRoute,
  AppAdminPromptRolloutRoute: AppAdminPromptRolloutRoute,
  AppAdminQualityScoreboardRoute: AppAdminQualityScoreboardRoute,
  AppAdminReportGeneratorRoute: AppAdminReportGeneratorRoute,
  AppAdminSearchRoute: AppAdminSearchRoute,
  AppAdminShiftAssignmentHealthRoute: AppAdminShiftAssignmentHealthRoute,
  AppAdminSimulatorWorldRoute: AppAdminSimulatorWorldRoute,
  AppAdminSmsDebugRoute: AppAdminSmsDebugRoute,
  AppAdminSyncSettingsRoute: AppAdminSyncSettingsRoute,
  AppAdminTagMatchingRoute: AppAdminTagMatchingRoute,
  AppAdminTamMapRoute: AppAdminTamMapRoute,
  AppAdminUiComponentsRoute: AppAdminUiComponentsRoute,
  AppAdminVoiceRoute: AppAdminVoiceRoute,
  AppAdminVoiceLatencyRoute: AppAdminVoiceLatencyRoute,
  AppAdminIndexRoute: AppAdminIndexRoute,
  AppAdminAccountsAccountIdRoute: AppAdminAccountsAccountIdRoute,
  AppAdminAgentNotesNoteIdRoute: AppAdminAgentNotesNoteIdRoute,
  AppAdminAgentTracesConversationIdRoute:
    AppAdminAgentTracesConversationIdRoute,
  AppAdminAgentTracesEphemeralRoute: AppAdminAgentTracesEphemeralRoute,
  AppAdminAgentRunIdRoute: AppAdminAgentRunIdRoute,
  AppAdminAgentCapabilitiesRoute: AppAdminAgentCapabilitiesRoute,
  AppAdminAgentMissingToolsRoute: AppAdminAgentMissingToolsRoute,
  AppAdminAgentToolTelemetryRoute: AppAdminAgentToolTelemetryRoute,
  AppAdminAnalyticsSlugRoute: AppAdminAnalyticsSlugRoute,
  AppAdminCallsCallIdRoute: AppAdminCallsCallIdRoute,
  AppAdminCareCoordinatorsCareCoordinatorIdRoute:
    AppAdminCareCoordinatorsCareCoordinatorIdRoute,
  AppAdminCaregiversCaregiverIdRoute: AppAdminCaregiversCaregiverIdRoute,
  AppAdminClientsClientIdRoute: AppAdminClientsClientIdRoute,
  AppAdminOrganizationsOrganizationIdRoute:
    AppAdminOrganizationsOrganizationIdRoute,
  AppAdminRevenueAccountIdRoute: AppAdminRevenueAccountIdRoute,
  AppAdminRevenueAccountsRoute: AppAdminRevenueAccountsRoute,
  AppAdminSalesAgreementsRoute: AppAdminSalesAgreementsRoute,
  AppAdminSandboxOrganizationIdRoute: AppAdminSandboxOrganizationIdRoute,
  AppAdminShiftsShiftIdRoute: AppAdminShiftsShiftIdRoute,
  AppAdminSmsEngineRunsRunIdRoute: AppAdminSmsEngineRunsRunIdRoute,
  AppAdminUsersUserIdRoute: AppAdminUsersUserIdRoute,
  AppAdminVoiceConfigOrganizationIdRoute:
    AppAdminVoiceConfigOrganizationIdRoute,
  AppAdminVoiceEvalsCasesRoute: AppAdminVoiceEvalsCasesRoute,
  AppAdminVoiceEvalsCatalogRoute: AppAdminVoiceEvalsCatalogRoute,
  AppAdminVoiceEvalsCompareRoute: AppAdminVoiceEvalsCompareRoute,
  AppAdminVoiceEvalsCompareCaseRoute: AppAdminVoiceEvalsCompareCaseRoute,
  AppAdminVoicePlaygroundCallIdRoute: AppAdminVoicePlaygroundCallIdRoute,
  AppAdminVoiceQaCallIdRoute: AppAdminVoiceQaCallIdRoute,
  AppAdminVoiceQaShadowComparisonRoute: AppAdminVoiceQaShadowComparisonRoute,
  AppAdminVoipOrganizationIdRoute: AppAdminVoipOrganizationIdRoute,
  AppAdminAccessTokensIndexRoute: AppAdminAccessTokensIndexRoute,
  AppAdminAccountsIndexRoute: AppAdminAccountsIndexRoute,
  AppAdminAgentNotesIndexRoute: AppAdminAgentNotesIndexRoute,
  AppAdminAgentTracesIndexRoute: AppAdminAgentTracesIndexRoute,
  AppAdminAgentIndexRoute: AppAdminAgentIndexRoute,
  AppAdminAnalyticsIndexRoute: AppAdminAnalyticsIndexRoute,
  AppAdminAutoCalloutBoardIndexRoute: AppAdminAutoCalloutBoardIndexRoute,
  AppAdminAutomationsIndexRoute: AppAdminAutomationsIndexRoute,
  AppAdminCallsIndexRoute: AppAdminCallsIndexRoute,
  AppAdminCareCoordinatorsIndexRoute: AppAdminCareCoordinatorsIndexRoute,
  AppAdminCaregiversIndexRoute: AppAdminCaregiversIndexRoute,
  AppAdminClientsIndexRoute: AppAdminClientsIndexRoute,
  AppAdminFranchisesIndexRoute: AppAdminFranchisesIndexRoute,
  AppAdminOrgDistributionsIndexRoute: AppAdminOrgDistributionsIndexRoute,
  AppAdminOrganizationsIndexRoute: AppAdminOrganizationsIndexRoute,
  AppAdminOutboxIndexRoute: AppAdminOutboxIndexRoute,
  AppAdminRecommendationExplorerIndexRoute:
    AppAdminRecommendationExplorerIndexRoute,
  AppAdminRevenueIndexRoute: AppAdminRevenueIndexRoute,
  AppAdminSandboxIndexRoute: AppAdminSandboxIndexRoute,
  AppAdminShiftsIndexRoute: AppAdminShiftsIndexRoute,
  AppAdminSmsEngineRunsIndexRoute: AppAdminSmsEngineRunsIndexRoute,
  AppAdminUsersIndexRoute: AppAdminUsersIndexRoute,
  AppAdminVoiceConfigIndexRoute: AppAdminVoiceConfigIndexRoute,
  AppAdminVoiceEvalsIndexRoute: AppAdminVoiceEvalsIndexRoute,
  AppAdminVoicePlaygroundIndexRoute: AppAdminVoicePlaygroundIndexRoute,
  AppAdminVoiceQaIndexRoute: AppAdminVoiceQaIndexRoute,
  AppAdminVoipIndexRoute: AppAdminVoipIndexRoute,
  AppAdminAgentTracesRunRunIdRoute: AppAdminAgentTracesRunRunIdRoute,
  AppAdminAgentActionsAuditIdRoute: AppAdminAgentActionsAuditIdRoute,
  AppAdminAgentAutomationsListRoute: AppAdminAgentAutomationsListRoute,
  AppAdminAgentAutomationsRunsRoute: AppAdminAgentAutomationsRunsRoute,
  AppAdminAgentPagesSlugRoute: AppAdminAgentPagesSlugRoute,
  AppAdminAgentScratchpadNoteIdRoute: AppAdminAgentScratchpadNoteIdRoute,
  AppAdminAutomationsOrganizationIdAutomationIdRoute:
    AppAdminAutomationsOrganizationIdAutomationIdRouteWithChildren,
  AppAdminAgentActionsIndexRoute: AppAdminAgentActionsIndexRoute,
  AppAdminAgentAutomationsIndexRoute: AppAdminAgentAutomationsIndexRoute,
  AppAdminAgentPagesIndexRoute: AppAdminAgentPagesIndexRoute,
  AppAdminAgentScratchpadIndexRoute: AppAdminAgentScratchpadIndexRoute,
  AppAdminAgentAutomationsOrganizationIdAutomationIdRoute:
    AppAdminAgentAutomationsOrganizationIdAutomationIdRouteWithChildren,
  AppAdminVoiceEvalsRunsRunIdIndexRoute: AppAdminVoiceEvalsRunsRunIdIndexRoute,
  AppAdminAgentRunsRunIdArtifactsArtifactIdRoute:
    AppAdminAgentRunsRunIdArtifactsArtifactIdRoute,
  AppAdminVoiceEvalsRunsRunIdCasesCaseResultIdRoute:
    AppAdminVoiceEvalsRunsRunIdCasesCaseResultIdRoute,
}

const AppAdminRouteRouteWithChildren = AppAdminRouteRoute._addFileChildren(
  AppAdminRouteRouteChildren,
)

interface AppSettingsNotificationsRouteRouteChildren {
  AppSettingsNotificationsChannelRoute: typeof AppSettingsNotificationsChannelRoute
  AppSettingsNotificationsIndexRoute: typeof AppSettingsNotificationsIndexRoute
}

const AppSettingsNotificationsRouteRouteChildren: AppSettingsNotificationsRouteRouteChildren =
  {
    AppSettingsNotificationsChannelRoute: AppSettingsNotificationsChannelRoute,
    AppSettingsNotificationsIndexRoute: AppSettingsNotificationsIndexRoute,
  }

const AppSettingsNotificationsRouteRouteWithChildren =
  AppSettingsNotificationsRouteRoute._addFileChildren(
    AppSettingsNotificationsRouteRouteChildren,
  )

interface AppSettingsRouteRouteChildren {
  AppSettingsNotificationsRouteRoute: typeof AppSettingsNotificationsRouteRouteWithChildren
  AppSettingsActivityFeedRoute: typeof AppSettingsActivityFeedRoute
  AppSettingsAgencyContextRoute: typeof AppSettingsAgencyContextRoute
  AppSettingsAgentRulesRoute: typeof AppSettingsAgentRulesRoute
  AppSettingsAgentSkillsRoute: typeof AppSettingsAgentSkillsRoute
  AppSettingsAutoAssignRoute: typeof AppSettingsAutoAssignRoute
  AppSettingsAutoDraftRoute: typeof AppSettingsAutoDraftRoute
  AppSettingsAutoReplySettingsRoute: typeof AppSettingsAutoReplySettingsRoute
  AppSettingsAutoSendRoute: typeof AppSettingsAutoSendRoute
  AppSettingsAutomationScheduleRoute: typeof AppSettingsAutomationScheduleRoute
  AppSettingsAutomationsRoute: typeof AppSettingsAutomationsRoute
  AppSettingsCallRoutingRoute: typeof AppSettingsCallRoutingRoute
  AppSettingsCallTemplatesRoute: typeof AppSettingsCallTemplatesRoute
  AppSettingsCancellationsRoute: typeof AppSettingsCancellationsRoute
  AppSettingsCareCoordinatorsRoute: typeof AppSettingsCareCoordinatorsRoute
  AppSettingsCaregiverEngagementRoute: typeof AppSettingsCaregiverEngagementRoute
  AppSettingsCaregiverTagsRoute: typeof AppSettingsCaregiverTagsRoute
  AppSettingsChangeHistoryRoute: typeof AppSettingsChangeHistoryRoute
  AppSettingsChromeExtensionRoute: typeof AppSettingsChromeExtensionRoute
  AppSettingsClockInOutRoute: typeof AppSettingsClockInOutRoute
  AppSettingsClockInTemplatesRoute: typeof AppSettingsClockInTemplatesRoute
  AppSettingsConfigurationsRoute: typeof AppSettingsConfigurationsRoute
  AppSettingsConfirmationMessagesRoute: typeof AppSettingsConfirmationMessagesRoute
  AppSettingsDailyDigestRoute: typeof AppSettingsDailyDigestRoute
  AppSettingsDataSyncRoute: typeof AppSettingsDataSyncRoute
  AppSettingsEarlyAccessRoute: typeof AppSettingsEarlyAccessRoute
  AppSettingsHelpCenterRoute: typeof AppSettingsHelpCenterRoute
  AppSettingsOffHoursRoute: typeof AppSettingsOffHoursRoute
  AppSettingsOfficesRoute: typeof AppSettingsOfficesRoute
  AppSettingsOpenShiftResponsesRoute: typeof AppSettingsOpenShiftResponsesRoute
  AppSettingsOtherTemplatesRoute: typeof AppSettingsOtherTemplatesRoute
  AppSettingsOutreachAutomationRoute: typeof AppSettingsOutreachAutomationRoute
  AppSettingsOutreachTemplatesRoute: typeof AppSettingsOutreachTemplatesRoute
  AppSettingsPhoebeRoute: typeof AppSettingsPhoebeRoute
  AppSettingsPhoneRoute: typeof AppSettingsPhoneRoute
  AppSettingsPhoneInstructionsRoute: typeof AppSettingsPhoneInstructionsRoute
  AppSettingsPhoneNumbersRoute: typeof AppSettingsPhoneNumbersRoute
  AppSettingsPhoneTryRoute: typeof AppSettingsPhoneTryRoute
  AppSettingsQuietHoursRoute: typeof AppSettingsQuietHoursRoute
  AppSettingsRecommendationsRoute: typeof AppSettingsRecommendationsRoute
  AppSettingsShiftConfirmationSkipAllowListsRoute: typeof AppSettingsShiftConfirmationSkipAllowListsRoute
  AppSettingsShiftConfirmationsRoute: typeof AppSettingsShiftConfirmationsRoute
  AppSettingsSkipAllowListsRoute: typeof AppSettingsSkipAllowListsRoute
  AppSettingsSlackRoute: typeof AppSettingsSlackRoute
  AppSettingsTagMatchingRoute: typeof AppSettingsTagMatchingRoute
  AppSettingsTeamCoverageRoute: typeof AppSettingsTeamCoverageRoute
  AppSettingsTeamMembersRoute: typeof AppSettingsTeamMembersRoute
  AppSettingsTestModeRoute: typeof AppSettingsTestModeRoute
  AppSettingsIndexRoute: typeof AppSettingsIndexRoute
}

const AppSettingsRouteRouteChildren: AppSettingsRouteRouteChildren = {
  AppSettingsNotificationsRouteRoute:
    AppSettingsNotificationsRouteRouteWithChildren,
  AppSettingsActivityFeedRoute: AppSettingsActivityFeedRoute,
  AppSettingsAgencyContextRoute: AppSettingsAgencyContextRoute,
  AppSettingsAgentRulesRoute: AppSettingsAgentRulesRoute,
  AppSettingsAgentSkillsRoute: AppSettingsAgentSkillsRoute,
  AppSettingsAutoAssignRoute: AppSettingsAutoAssignRoute,
  AppSettingsAutoDraftRoute: AppSettingsAutoDraftRoute,
  AppSettingsAutoReplySettingsRoute: AppSettingsAutoReplySettingsRoute,
  AppSettingsAutoSendRoute: AppSettingsAutoSendRoute,
  AppSettingsAutomationScheduleRoute: AppSettingsAutomationScheduleRoute,
  AppSettingsAutomationsRoute: AppSettingsAutomationsRoute,
  AppSettingsCallRoutingRoute: AppSettingsCallRoutingRoute,
  AppSettingsCallTemplatesRoute: AppSettingsCallTemplatesRoute,
  AppSettingsCancellationsRoute: AppSettingsCancellationsRoute,
  AppSettingsCareCoordinatorsRoute: AppSettingsCareCoordinatorsRoute,
  AppSettingsCaregiverEngagementRoute: AppSettingsCaregiverEngagementRoute,
  AppSettingsCaregiverTagsRoute: AppSettingsCaregiverTagsRoute,
  AppSettingsChangeHistoryRoute: AppSettingsChangeHistoryRoute,
  AppSettingsChromeExtensionRoute: AppSettingsChromeExtensionRoute,
  AppSettingsClockInOutRoute: AppSettingsClockInOutRoute,
  AppSettingsClockInTemplatesRoute: AppSettingsClockInTemplatesRoute,
  AppSettingsConfigurationsRoute: AppSettingsConfigurationsRoute,
  AppSettingsConfirmationMessagesRoute: AppSettingsConfirmationMessagesRoute,
  AppSettingsDailyDigestRoute: AppSettingsDailyDigestRoute,
  AppSettingsDataSyncRoute: AppSettingsDataSyncRoute,
  AppSettingsEarlyAccessRoute: AppSettingsEarlyAccessRoute,
  AppSettingsHelpCenterRoute: AppSettingsHelpCenterRoute,
  AppSettingsOffHoursRoute: AppSettingsOffHoursRoute,
  AppSettingsOfficesRoute: AppSettingsOfficesRoute,
  AppSettingsOpenShiftResponsesRoute: AppSettingsOpenShiftResponsesRoute,
  AppSettingsOtherTemplatesRoute: AppSettingsOtherTemplatesRoute,
  AppSettingsOutreachAutomationRoute: AppSettingsOutreachAutomationRoute,
  AppSettingsOutreachTemplatesRoute: AppSettingsOutreachTemplatesRoute,
  AppSettingsPhoebeRoute: AppSettingsPhoebeRoute,
  AppSettingsPhoneRoute: AppSettingsPhoneRoute,
  AppSettingsPhoneInstructionsRoute: AppSettingsPhoneInstructionsRoute,
  AppSettingsPhoneNumbersRoute: AppSettingsPhoneNumbersRoute,
  AppSettingsPhoneTryRoute: AppSettingsPhoneTryRoute,
  AppSettingsQuietHoursRoute: AppSettingsQuietHoursRoute,
  AppSettingsRecommendationsRoute: AppSettingsRecommendationsRoute,
  AppSettingsShiftConfirmationSkipAllowListsRoute:
    AppSettingsShiftConfirmationSkipAllowListsRoute,
  AppSettingsShiftConfirmationsRoute: AppSettingsShiftConfirmationsRoute,
  AppSettingsSkipAllowListsRoute: AppSettingsSkipAllowListsRoute,
  AppSettingsSlackRoute: AppSettingsSlackRoute,
  AppSettingsTagMatchingRoute: AppSettingsTagMatchingRoute,
  AppSettingsTeamCoverageRoute: AppSettingsTeamCoverageRoute,
  AppSettingsTeamMembersRoute: AppSettingsTeamMembersRoute,
  AppSettingsTestModeRoute: AppSettingsTestModeRoute,
  AppSettingsIndexRoute: AppSettingsIndexRoute,
}

const AppSettingsRouteRouteWithChildren =
  AppSettingsRouteRoute._addFileChildren(AppSettingsRouteRouteChildren)

interface AppRouteRouteChildren {
  AppagentRouteRoute: typeof AppagentRouteRouteWithChildren
  AppextensionRouteRoute: typeof AppextensionRouteRouteWithChildren
  AppmainRouteRoute: typeof AppmainRouteRouteWithChildren
  AppAdminRouteRoute: typeof AppAdminRouteRouteWithChildren
  AppSettingsRouteRoute: typeof AppSettingsRouteRouteWithChildren
  AppInternalAgreementsRoute: typeof AppInternalAgreementsRoute
  AppSlackLinkRoute: typeof AppSlackLinkRoute
}

const AppRouteRouteChildren: AppRouteRouteChildren = {
  AppagentRouteRoute: AppagentRouteRouteWithChildren,
  AppextensionRouteRoute: AppextensionRouteRouteWithChildren,
  AppmainRouteRoute: AppmainRouteRouteWithChildren,
  AppAdminRouteRoute: AppAdminRouteRouteWithChildren,
  AppSettingsRouteRoute: AppSettingsRouteRouteWithChildren,
  AppInternalAgreementsRoute: AppInternalAgreementsRoute,
  AppSlackLinkRoute: AppSlackLinkRoute,
}

const AppRouteRouteWithChildren = AppRouteRoute._addFileChildren(
  AppRouteRouteChildren,
)

interface AuthRouteRouteChildren {
  AuthAcceptInvitationRoute: typeof AuthAcceptInvitationRoute
  AuthChangePasswordRoute: typeof AuthChangePasswordRoute
  AuthErrorRoute: typeof AuthErrorRoute
  AuthIntroCallBookedRoute: typeof AuthIntroCallBookedRoute
  AuthResetPasswordRoute: typeof AuthResetPasswordRoute
  AuthSignInRoute: typeof AuthSignInRoute
  AuthSignOutRoute: typeof AuthSignOutRoute
  AuthSignUpRoute: typeof AuthSignUpRoute
}

const AuthRouteRouteChildren: AuthRouteRouteChildren = {
  AuthAcceptInvitationRoute: AuthAcceptInvitationRoute,
  AuthChangePasswordRoute: AuthChangePasswordRoute,
  AuthErrorRoute: AuthErrorRoute,
  AuthIntroCallBookedRoute: AuthIntroCallBookedRoute,
  AuthResetPasswordRoute: AuthResetPasswordRoute,
  AuthSignInRoute: AuthSignInRoute,
  AuthSignOutRoute: AuthSignOutRoute,
  AuthSignUpRoute: AuthSignUpRoute,
}

const AuthRouteRouteWithChildren = AuthRouteRoute._addFileChildren(
  AuthRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AppRouteRoute: AppRouteRouteWithChildren,
  AuthRouteRoute: AuthRouteRouteWithChildren,
  PhoebeThinkingTipsMockupRoute: PhoebeThinkingTipsMockupRoute,
  TeachPhoebeFeedbackTagsMockupRoute: TeachPhoebeFeedbackTagsMockupRoute,
  OrganizationIdDemoRoute: OrganizationIdDemoRoute,
  ChromeExtensionPrivacyRoute: ChromeExtensionPrivacyRoute,
  OutreachesPhoebeThinkingTipsMockupRoute:
    OutreachesPhoebeThinkingTipsMockupRoute,
  RCodeRoute: RCodeRoute,
  SimulatorWorldDisplayRoute: SimulatorWorldDisplayRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
